/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：37__part-12
 */

import { Lt, Bt, Gt, Ut, Vt, Yt, qt as migrateCloudDict } from "../../../../unrestored/shared/1571/2636/37/index__part-6"
import { gn } from "../../../../unrestored/shared/1571/2636/37/index__part-7"
import { Pn, Bn, Fn, Gn } from "../../../../unrestored/shared/1571/2636/37/index__part-8"
import { qn } from "../../../../unrestored/shared/1571/2636/37/index__part-9"
import { $r, uo, go } from "../../../../unrestored/shared/1571/2636/37/index__part-11"
import { store } from "../store"
var _o
import * as /* [auto-meaningful-name] */Module_22 from /* 22 */"../../../../unrestored/shared/1571/2636/37/22"
import * as /* [auto-meaningful-name] */Module_276 from /* 276 */"../../../../unrestored/shared/1571/2636/276"
import * as /* [auto-meaningful-name] */Module_111 from /* 111 */"../../../../unrestored/shared/1571/2636/37/111"
import * as /* [auto-meaningful-name] */Module_42 from /* 42 */"../../../../unrestored/shared/1571/2636/42/index"
import * as /* [auto-meaningful-name] */Module_110 from /* 110 */"../../../../unrestored/shared/1571/2636/110"
import * as /* [auto-meaningful-name] */Module_174 from /* 174 */"../../../../unrestored/shared/1571/2636/174"
import * as /* [auto-meaningful-name] */Module_20 from /* 20 */"../../../../unrestored/shared/1571/2636/20/index"
import * as /* [auto-meaningful-name] */Module_392 from /* 392 */"../../../../unrestored/shared/1571/2636/392/index"
import * as /* [auto-meaningful-name] */Module_144 from /* 144 */"../../../../unrestored/shared/1571/2636/144"
import * as CustomWidgetRestrict from "../../../shared/widget/custom/restrict"
import * as /* [auto-meaningful-name] */Module_375 from /* 375 */"../../../../unrestored/shared/1571/2636/97/375"
import * as /* [auto-meaningful-name] */Module_345 from /* 345 */"../../../../unrestored/shared/1571/2636/48/345"
import * as /* [auto-meaningful-name] */Module_410 from /* 410 */"../../../../unrestored/shared/1571/2636/410"
import /* [auto-meaningful-name] */Unrestored_shared_1571_2636_37_515 from "../../../../unrestored/shared/1571/2636/37/515"
import * as /* [auto-meaningful-name] */Module_147 from /* 147 */"../../../../unrestored/shared/1571/2636/147"
import * as /* [auto-meaningful-name] */Module_219 from /* 219 */"../../../../unrestored/shared/1571/2636/37/219/index"
import * as /* [auto-meaningful-name] */Module_376 from /* 376 */"../../../../unrestored/shared/1571/2636/37/376"
import * as CustomWidgetShop from "../../../shared/widget/custom/shop"
import * as CustomWidgetStorage from "../../../shared/widget/custom/storage"
import * as LoadCustomWidget from "../../../shared/widget/custom/load"
import * as /* [auto-meaningful-name] */Module_127 from /* 127 */"../../../../unrestored/shared/1571/2636/127"
import * as /* [auto-meaningful-name] */Module_145 from /* 145 */"../../../../unrestored/shared/1571/2636/145"
import * as /* [auto-meaningful-name] */Module_97 from /* 97 */"../../../../unrestored/shared/1571/2636/97"
import * as /* [auto-meaningful-name] */Shared_tools from "../../../shared/tools"
import { oTHelper } from "../../../../unrestored/shared/1571/2636/49"
import * as /* [auto-meaningful-name] */Module_24 from /* 24 */"../../../../unrestored/shared/1571/2636/24/index"
import * as Language from "../../../shared/ui/language"
import * as /* [auto-meaningful-name] */Module_64 from /* 64 */"../../../../unrestored/shared/1571/2636/64"
import * as /* [auto-meaningful-name] */Widget_builtIn_types from "../../widget/built-in/types"
import * as /* [auto-meaningful-name] */Module_305 from /* 305 */"../../../../unrestored/shared/1571/2636/305"
import * as /* [auto-meaningful-name] */Module_215 from /* 215 */"../../../../unrestored/shared/1571/2636/215"
import * as /* [auto-meaningful-name] */Module_9 from /* 9 */"../../../../unrestored/shared/1571/2636/9"
import * as /* [auto-meaningful-name] */Module_328 from /* 328 */"../../../../unrestored/shared/1571/2636/328"
import * as /* [auto-meaningful-name] */Module_553 from /* 553 */"../../../../unrestored/shared/1571/2636/553"
import * as /* [auto-meaningful-name] */Module_141 from /* 141 */"../../../../unrestored/shared/1571/2636/141/index"
import * as /* [auto-meaningful-name] */Module_197 from /* 197 */"../../../../unrestored/shared/1571/2636/197/index"
import * as /* [auto-meaningful-name] */Module_139 from /* 139 */"../../../../unrestored/shared/1571/2636/207/139"
import * as /* [auto-meaningful-name] */Module_26 from /* 26 */"../../../../unrestored/shared/1571/2636/26/index"
import * as /* [auto-meaningful-name] */Module_297 from /* 297 */"../../../../unrestored/shared/1571/2636/297"
import * as /* [auto-meaningful-name] */Module_177 from /* 177 */"../../../../unrestored/shared/1571/2636/177"
import * as /* [auto-meaningful-name] */Module_627 from /* 627 */"../../../../unrestored/shared/1571/2636/627"
import * as Terser from "terser"
import * as /* [auto-meaningful-name] */Module_2680 from /* 2680 */"../../../../unrestored/shared/1571/2636/2680/index"
import * as /* [auto-meaningful-name] */Module_11 from /* 11 */"../../../../unrestored/shared/1571/2636/11"
import * as /* [auto-meaningful-name] */Module_10 from /* 10 */"../../../../unrestored/shared/1571/2636/10/index"
import * as /* [auto-meaningful-name] */Module_7 from /* 7 */"../../../../unrestored/shared/1571/2636/7"
import * as ReduxSagaEffects from "../../../../unrestored/shared/1571/2636/48/3/index"
import RegeneratorRuntime from "regenerator-runtime"
import * as /* [auto-meaningful-name] */Module_100 from /* 100 */"../../../../unrestored/shared/1571/2636/100"
import * as /* [auto-meaningful-name] */Module_47 from /* 47 */"../../../../unrestored/shared/1571/2636/47"
import * as /* [auto-meaningful-name] */Module_53 from /* 53 */"../../../../unrestored/shared/1571/2636/53"
import * as /* [auto-meaningful-name] */Lodash from "lodash"
import * as CustomWidgetType from "../../../shared/widget/custom/type"
import * as /* [auto-meaningful-name] */Module_18 from /* 18 */"../../../../unrestored/shared/1571/2636/18"
import * as Actions from "./actions"
import { asyncDeleteProjectWidgetAction } from "./actions"
import Immutable from /* 66 */"immutable"
import * as /* [auto-meaningful-name] */Module_6 from /* 6 */"../../../../unrestored/shared/1571/2636/6"
import * as /* [auto-meaningful-name] */Module_25 from /* 25 */"../../../../unrestored/shared/1571/2636/25/index"
import * as /* [auto-meaningful-name] */React from "react"
import /* [auto-meaningful-name] */React1 from "react"
import * as /* [auto-meaningful-name] */Module_27 from /* 27 */"../../../../unrestored/shared/1571/2636/27"
import * as /* [auto-meaningful-name] */Module_39 from /* 39 */"../../../../unrestored/shared/1571/2636/39"
import * as /* [auto-meaningful-name] */ReactDom from "react-dom"
import /* [auto-meaningful-name] */ReactDom1 from "react-dom"
import * as /* [auto-meaningful-name] */Classnames from "classnames"
import /* [auto-meaningful-name] */Classnames1 from "classnames"
import * as Components from "../../../shared/ui/components"
import { Button, Dialog } from "../../../shared/ui/components"
import * as /* [auto-meaningful-name] */Module_266 from /* 266 */"../../../../unrestored/shared/1571/2636/266"
import /* [auto-meaningful-name] */Module_2661 from /* 266 */"../../../../unrestored/shared/1571/2636/266"
import * as /* [auto-meaningful-name] */Module_188 from /* 188 */"../../../../unrestored/shared/1571/2636/188"
var No = function (e) {
  var /* [auto-meaningful-name] */e$title = e.title
  var /* [auto-meaningful-name] */e$onConfirm = e.onConfirm
  var /* [auto-meaningful-name] */e$content = e.content
  var /* [auto-meaningful-name] */e$onDeny = e.onDeny
  var /* [auto-meaningful-name] */e$className = e.className
  var /* [auto-meaningful-name] */e$onCancel = e.onCancel
  var /* [auto-meaningful-name] */e$isDangerous = e.isDangerous
  var /* [auto-meaningful-name] */e$cancelText = e.cancelText
  var /* [auto-meaningful-name] */e$allowText = e.allowText
  var /* [auto-meaningful-name] */e$denyText = e.denyText
  var /* [auto-meaningful-name] */e$cancelBtnVisible = e.cancelBtnVisible
  var p = undefined === e$cancelBtnVisible || e$cancelBtnVisible
  var /* [auto-meaningful-name] */e$confirmBtnVisible = e.confirmBtnVisible
  var h = undefined === e$confirmBtnVisible || e$confirmBtnVisible
  var /* [auto-meaningful-name] */e$mask = e.mask
  var g = undefined === e$mask || e$mask
  var _ = function () {
    if (e$onConfirm) {
      e$onConfirm()
    }
  }
  return <Dialog
    visible={true}
    showCloseButton={false}
    withPortal={true}
    maskClosable={false}
    mask={g}
    className={Classnames1(Module_2661.dialog, e$className, e$denyText && Module_2661.dialogSecondary)}
  >
    <Module_188.a>
      <Module_188.b
        keys="enter"
        callback={_}
      />
    </Module_188.a>
    <h3>{e$title}</h3>
    <span>{e$content}</span>
    <div
      className={Classnames1(Module_2661.dialogButtons)}
    >
      {p && <Button
        type="light"
        onClick={function () {
          if (e$onCancel) {
            e$onCancel()
          }
        }}
      >
        {e$cancelText}
      </Button>}
      {e$denyText && <Button
        onClick={function () {
          if (e$onDeny) {
            e$onDeny()
          }
        }}
        className={Module_2661.denyButton}
      >
        {e$denyText}
      </Button>}
      {h && <Button
        type="primary"
        danger={e$isDangerous}
        onClick={_}
      >
        {e$allowText}
      </Button>}
    </div>
  </Dialog>
}
var Ro = new (function () {
  function e() {
    Module_27.a(this, e)
    this.boxQueue = []
    this.currentBox = null
  }
  Module_39.a(e, [
    {
      key: "appendDialog",
      value: function (e) {
        var t = this
        var n = document.createElement("div")
        var r = Module_64.a("dialog")
        n.id = r
        var /* [auto-meaningful-name] */e$onConfirm = e.onConfirm
        var /* [auto-meaningful-name] */e$onCancel = e.onCancel
        var /* [auto-meaningful-name] */e$onClose = e.onClose
        var c = function () {
          var e = Module_7.a(RegeneratorRuntime.mark(function e() {
            return RegeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (!e$onConfirm) {
                      e.next = 3
                      break
                    }
                    e.next = 3
                    return e$onConfirm()
                  case 3:
                    t.openDialog()
                  case 4:
                  case "end":
                    return e.stop()
                }
              }
            }, e)
          }))
          return function () {
            return e.apply(this, arguments)
          }
        }()
        var l = function () {
          var e = Module_7.a(RegeneratorRuntime.mark(function e() {
            return RegeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (!e$onCancel) {
                      e.next = 3
                      break
                    }
                    e.next = 3
                    return e$onCancel()
                  case 3:
                    t.openDialog()
                  case 4:
                  case "end":
                    return e.stop()
                }
              }
            }, e)
          }))
          return function () {
            return e.apply(this, arguments)
          }
        }()
        var u = function () {
          var e = Module_7.a(RegeneratorRuntime.mark(function e() {
            return RegeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (!e$onClose) {
                      e.next = 3
                      break
                    }
                    e.next = 3
                    return e$onClose()
                  case 3:
                    t.openDialog()
                  case 4:
                  case "end":
                    return e.stop()
                }
              }
            }, e)
          }))
          return function () {
            return e.apply(this, arguments)
          }
        }()
        var d = Module_6.a(Module_6.a({}, e), {}, {
          onConfirm: c,
          onClose: u,
          onCancel: l
        })
        this.boxQueue.push({
          id: r,
          element: n,
          config: d
        })
        if (!this.currentBox) {
          this.openDialog()
        }
        return r
      }
    }, {
      key: "openDialog",
      value: function () {
        this.destroyCurrentBox()
        var e = this.boxQueue.shift()
        if (e) {
          ReactDom1.render(React1.createElement(No, e.config), e.element)
          document.body.appendChild(e.element)
          this.currentBox = e
        }
        return e
      }
    }, {
      key: "removeDialog",
      value: function (e) {
        var /* [auto-meaningful-name] */this$currentBox
        if (!e) {
          return e
        }
        if (e === (null === (this$currentBox = this.currentBox) || undefined === this$currentBox ? undefined : this$currentBox.id)) {
          this.destroyCurrentBox()
          return e
        }
        var n = this.boxQueue.findIndex(function (t) {
          return t.id === e
        })
        if (n >= 0) {
          this.boxQueue.splice(n, 1)
        }
        return e
      }
    }, {
      key: "destroyCurrentBox",
      value: function () {
        if (this.currentBox) {
          this.destroyBox(this.currentBox.element)
          this.currentBox = null
        }
      }
    }, {
      key: "destroyBox",
      value: function (e) {
        ReactDom1.unmountComponentAtNode(e)
        document.body.removeChild(e)
      }
    }
  ])
  return e
}())()
var ko = RegeneratorRuntime.mark(ti)
var xo = RegeneratorRuntime.mark(ni)
var Do = RegeneratorRuntime.mark(ri)
var Mo = RegeneratorRuntime.mark(oi)
var Lo = RegeneratorRuntime.mark(ii)
var Po = RegeneratorRuntime.mark(ai)
var Bo = RegeneratorRuntime.mark(si)
var Fo = RegeneratorRuntime.mark(ci)
var Go = RegeneratorRuntime.mark(li)
var Wo = RegeneratorRuntime.mark(ui)
var Uo = RegeneratorRuntime.mark(di)
var Ho = RegeneratorRuntime.mark(pi)
var Vo = RegeneratorRuntime.mark(fi)
var zo = RegeneratorRuntime.mark(hi)
var Yo = RegeneratorRuntime.mark(mi)
var Ko = RegeneratorRuntime.mark(gi)
var qo = RegeneratorRuntime.mark(_i)
var Xo = RegeneratorRuntime.mark(vi)
var Qo = RegeneratorRuntime.mark(bi)
var Zo = RegeneratorRuntime.mark(yi)
var Jo = RegeneratorRuntime.mark(Ei)
var $o = RegeneratorRuntime.mark(Oi)
var ei = RegeneratorRuntime.mark(Si)
function ti() {
  var /* [auto-meaningful-name] */t$sent
  return RegeneratorRuntime.wrap(function (t) {
    for (;;) {
      switch (t.prev = t.next) {
        case 0:
          t.next = 2
          return ReduxSagaEffects.f(Module_22.s)
        case 2:
          t$sent = t.sent
          t.next = 5
          return ReduxSagaEffects.e(Actions.openConfirmDialogAction({
            onConfirm: function () {
              store.dispatch(Actions.openSignInDialogAction())
            },
            allowText: Language.c(t$sent, "cloudSpace.login").toString(),
            cancelText: Language.c(t$sent, "cloudSpace.cancelLogin").toString(),
            title: Language.c(t$sent, "cloudSpace.NotLoginTitle").toString(),
            content: Language.c(t$sent, "cloudSpace.notLoginDescription").toString()
          }))
        case 5:
        case "end":
          return t.stop()
      }
    }
  }, ko)
}
function ni(e) {
  var /* [auto-meaningful-name] */o$sent
  var n
  var r
  return RegeneratorRuntime.wrap(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          o.next = 2
          return ReduxSagaEffects.f(Module_22.s)
        case 2:
          o$sent = o.sent
          n = e.map(function (e) {
            return <div
              className={"removedCloudDB"}
              key={e.id}
              children={<li
                children={e.title}
                className="removedDBName"
                key={e.id}
              />}
            />
          })
          r = <div
            className={"removedCloudDBWrapper"}
            children={[n]}
          />
          o.next = 7
          return ReduxSagaEffects.e(Actions.openConfirmDialogAction({
            allowText: Language.c(o$sent, "know").toString(),
            title: Language.c(o$sent, "cloudSpace.dataSourceNotExistDesc").toString(),
            content: r,
            cancelBtnVisible: false,
            onConfirm: function () {
              store.dispatch(Actions.Ij(new Date().getTime()))
            }
          }))
        case 7:
        case "end":
          return o.stop()
      }
    }
  }, xo)
}
function ri(e, t) {
  var /* [auto-meaningful-name] */a$sent
  var r
  var o
  var i
  return RegeneratorRuntime.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          a.next = 2
          return ReduxSagaEffects.f(Module_22.s)
        case 2:
          a$sent = a.sent
          r = Language.c(a$sent, t) ? Language.c(a$sent, t) : t
          o = e.map(function (e) {
            return <div
              className={"removedCloudDB"}
              key={e.id}
              children={<li
                children={e.title}
                className="removedDBName"
                key={e.id}
              />}
            />
          })
          i = <div
            className={"removedCloudDBWrapper"}
            children={[o]}
          />
          Ro.appendDialog({
            allowText: Language.c(a$sent, "know").toString(),
            title: "以下控件绑定的云数据源发生异常(".concat(r, ")，请重新绑定"),
            content: i,
            cancelBtnVisible: false
          })
        case 7:
        case "end":
          return a.stop()
      }
    }
  }, Do)
}
function oi(e, t) {
  var /* [auto-meaningful-name] */a$sent
  var r
  var o
  var i
  return RegeneratorRuntime.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          a.next = 2
          return ReduxSagaEffects.f(Module_22.s)
        case 2:
          a$sent = a.sent
          r = Language.c(a$sent, t)
          o = e.map(function (e) {
            return <div
              className={"removedCloudDB"}
              key={e.id}
              children={<li
                children={e.title}
                className="removedDBName"
                key={e.id}
              />}
            />
          })
          i = <div
            className={"removedCloudDBWrapper"}
            children={[o]}
          />
          Ro.appendDialog({
            allowText: Language.c(a$sent, "know").toString(),
            title: Language.c(a$sent, "cloudSpace.dataSourceExceedLimitError", {
              type: r
            }).toString(),
            content: i,
            cancelBtnVisible: false
          })
        case 7:
        case "end":
          return a.stop()
      }
    }
  }, Mo)
}
function ii() {
  var /* [auto-meaningful-name] */r$sent
  var /* [auto-meaningful-name] */r$sent$dicts
  var /* [auto-meaningful-name] */r$sent$tables
  return RegeneratorRuntime.wrap(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          r.next = 2
          return ReduxSagaEffects.f(Module_22.r)
        case 2:
          if (!r.sent) {
            r.next = 21
            break
          }
          r.prev = 4
          r.next = 7
          return ReduxSagaEffects.a({
            dicts: ReduxSagaEffects.b(Module_111.g),
            tables: ReduxSagaEffects.b(Module_111.j)
          })
        case 7:
          r$sent = r.sent
          r$sent$dicts = r$sent.dicts
          r$sent$tables = r$sent.tables
          r.next = 12
          return ReduxSagaEffects.e(Actions.Bg(r$sent$dicts, true))
        case 12:
          r.next = 14
          return ReduxSagaEffects.e(Actions.Eg(r$sent$tables, true))
        case 14:
          r.next = 19
          break
        case 16:
          r.prev = 16
          r.t0 = r.catch(4)
          console.error(r.t0)
        case 19:
          r.next = 23
          break
        case 21:
          r.next = 23
          return ReduxSagaEffects.b(ai)
        case 23:
        case "end":
          return r.stop()
      }
    }
  }, Lo, null, [[4, 16]])
}
function ai() {
  var /* [auto-meaningful-name] */o$sent
  var /* [auto-meaningful-name] */o$sent1
  var /* [auto-meaningful-name] */_o$sent$dicts
  var /* [auto-meaningful-name] */_o$sent$tables
  return RegeneratorRuntime.wrap(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          o.next = 2
          return ReduxSagaEffects.f(Module_22.y)
        case 2:
          o$sent = o.sent
          o.prev = 3
          o.next = 6
          return ReduxSagaEffects.a({
            dicts: ReduxSagaEffects.b(Module_111.g, o$sent),
            tables: ReduxSagaEffects.b(Module_111.j, o$sent)
          })
        case 6:
          o$sent1 = o.sent
          _o$sent$dicts = o$sent1.dicts
          _o$sent$tables = o$sent1.tables
          o.next = 11
          return ReduxSagaEffects.e(Actions.Bg(_o$sent$dicts, true))
        case 11:
          o.next = 13
          return ReduxSagaEffects.e(Actions.Eg(_o$sent$tables, true))
        case 13:
          o.next = 18
          break
        case 15:
          o.prev = 15
          o.t0 = o.catch(3)
          console.error(o.t0)
        case 18:
        case "end":
          return o.stop()
      }
    }
  }, Po, null, [[3, 15]])
}
function si() {
  var /* [auto-meaningful-name] */_$sent
  var /* [auto-meaningful-name] */_$sent1
  var /* [auto-meaningful-name] */_$sent2
  var r
  var o
  var i
  var a
  var s
  var c
  var u
  var d
  var p
  var f
  var h
  var m
  var g
  return RegeneratorRuntime.wrap(function (_) {
    for (;;) {
      switch (_.prev = _.next) {
        case 0:
          _.next = 2
          return ReduxSagaEffects.f(Module_22.z)
        case 2:
          _$sent = _.sent
          _.next = 5
          return ReduxSagaEffects.f(Module_22.b)
        case 5:
          _$sent1 = _.sent
          _.next = 8
          return ReduxSagaEffects.f(Module_22.d)
        case 8:
          for (_$sent2 = _.sent, r = [], o = [], i = [], _$sent === Module_18.d.LOCAL_FILE && Module_42.b.forEach(function (e) {
            if (e.type === Widget_builtIn_types.j && e.attributes.cloudDictId !== Module_9.i) {
              r.push(e)
            }
            if (e.type === Widget_builtIn_types.k && e.attributes.cloudTableId !== Module_9.i) {
              o.push(e)
            }
            if (e.type === Widget_builtIn_types.A && "number" === typeof e.attributes.dataSource) {
              i.push(e)
            }
          }), Module_42.g.forEach(function (e) {
            if (e.type === Widget_builtIn_types.j && e.attributes.cloudDictId !== Module_9.i) {
              r.push(e)
            }
            if (e.type === Widget_builtIn_types.k && e.attributes.cloudTableId !== Module_9.i) {
              o.push(e)
            }
            if (e.type === Widget_builtIn_types.A && "number" === typeof e.attributes.dataSource) {
              i.push(e)
            }
          }), a = [], s = function () {
            var e = u[c]
            if (_$sent1.findIndex(function (t) {
              return t.id === e.attributes.cloudDictId
            }) < 0) {
              a.push(e)
            }
          }, c = 0, u = r; c < u.length; c++) {
            s()
          }
          for (d = function () {
            var e = f[p]
            if (_$sent2.findIndex(function (t) {
              return t.id === e.attributes.cloudTableId
            }) < 0) {
              a.push(e)
            }
          }, p = 0, f = o; p < f.length; p++) {
            d()
          }
          for (h = function () {
            var e = g[m]
            if (_$sent2.findIndex(function (t) {
              return t.id === e.attributes.dataSource
            }) < 0) {
              a.push(e)
            }
          }, m = 0, g = i; m < g.length; m++) {
            h()
          }
          return _.abrupt("return", a)
        case 22:
        case "end":
          return _.stop()
      }
    }
  }, Bo)
}
function ci(e) {
  var /* [auto-meaningful-name] */n$sent
  return RegeneratorRuntime.wrap(function (n) {
    for (;;) {
      switch (n.prev = n.next) {
        case 0:
          n.next = 2
          return ReduxSagaEffects.f(Module_22.h)
        case 2:
          n$sent = n.sent
          n.next = 5
          return ReduxSagaEffects.b(ii)
        case 5:
          n.next = 7
          return ReduxSagaEffects.b(pi)
        case 7:
          n.next = 9
          return ReduxSagaEffects.b(fi)
        case 9:
          n.next = 11
          return ReduxSagaEffects.b(gi)
        case 11:
          n.next = 13
          return ReduxSagaEffects.b(li, e.payload)
        case 13:
          if (!n$sent) {
            Module_26.z.rerenderCurrentScreenWorkspaceData()
          }
        case 14:
        case "end":
          return n.stop()
      }
    }
  }, Fo)
}
function li(e) {
  var /* [auto-meaningful-name] */i$sent
  var n
  var r
  var /* [auto-meaningful-name] */r$value
  return RegeneratorRuntime.wrap(function (i) {
    for (;;) {
      switch (i.prev = i.next) {
        case 0:
          i.next = 2
          return ReduxSagaEffects.b(si)
        case 2:
          if (!((i$sent = i.sent).length > 0 && e)) {
            i.next = 6
            break
          }
          i.next = 6
          return ReduxSagaEffects.b(ni, i$sent)
        case 6:
          if (0 !== i$sent.length) {
            i.next = 8
            break
          }
          return i.abrupt("return", [])
        case 8:
          n = Module_47.a(i$sent)
          i.prev = 9
          n.s()
        case 11:
          if ((r = n.n()).done) {
            i.next = 30
            break
          }
          if ((r$value = r.value).type !== Widget_builtIn_types.j) {
            i.next = 18
            break
          }
          i.next = 16
          return ReduxSagaEffects.e(Actions.Lg(r$value.id, "cloudDictId", Module_9.i, false, true, true))
        case 16:
          i.next = 18
          return ReduxSagaEffects.e(Actions.Ih([r$value.attributes.cloudDictId]))
        case 18:
          if (r$value.type !== Widget_builtIn_types.k) {
            i.next = 23
            break
          }
          i.next = 21
          return ReduxSagaEffects.e(Actions.Lg(r$value.id, "cloudTableId", Module_9.i, false, true, true))
        case 21:
          i.next = 23
          return ReduxSagaEffects.e(Actions.Jh([r$value.attributes.cloudTableId]))
        case 23:
          if (r$value.type !== Widget_builtIn_types.A) {
            i.next = 28
            break
          }
          i.next = 26
          return ReduxSagaEffects.e(Actions.Lg(r$value.id, "dataSource", "", false, true, true))
        case 26:
          i.next = 28
          return ReduxSagaEffects.e(Actions.Jh([r$value.attributes.dataSource]))
        case 28:
          i.next = 11
          break
        case 30:
          i.next = 35
          break
        case 32:
          i.prev = 32
          i.t0 = i.catch(9)
          n.e(i.t0)
        case 35:
          i.prev = 35
          n.f()
          return i.finish(35)
        case 38:
          return i.abrupt("return", i$sent)
        case 39:
        case "end":
          return i.stop()
      }
    }
  }, Go, null, [[9, 32, 35, 38]])
}
function ui() {
  var /* [auto-meaningful-name] */N$sent
  var t
  var n
  var r
  var o
  var a
  var s
  var l
  var /* [auto-meaningful-name] */_N$sent
  var d
  var /* [auto-meaningful-name] */d$code
  var /* [auto-meaningful-name] */d$msg
  var /* [auto-meaningful-name] */_N$sent2
  var m
  var /* [auto-meaningful-name] */m$code
  var /* [auto-meaningful-name] */m$msg
  var v
  var b
  var y
  var E
  var O
  var w
  var C
  var T
  var S
  var A
  var I
  var j
  return RegeneratorRuntime.wrap(function (N) {
    for (;;) {
      switch (N.prev = N.next) {
        case 0:
          if (0 !== Module_42.b.size) {
            N.next = 2
            break
          }
          return N.abrupt("return")
        case 2:
          N.next = 4
          return ReduxSagaEffects.f(Module_22.J)
        case 4:
          if (N.sent) {
            N.next = 9
            break
          }
          N.next = 8
          return ReduxSagaEffects.b(ti)
        case 8:
          return N.abrupt("return")
        case 9:
          N.next = 11
          return ReduxSagaEffects.b(li, false)
        case 11:
          if (N$sent = N.sent, t = new Set(), n = new Set(), N$sent.forEach(function (e) {
            if (e.type === Widget_builtIn_types.j) {
              t.add(e.attributes.cloudDictId)
            }
            if (e.type === Widget_builtIn_types.k) {
              n.add(e.attributes.cloudTableId)
            }
            if (e.type === Widget_builtIn_types.A && "number" === typeof e.attributes.dataSource) {
              n.add(e.attributes.dataSource)
            }
          }), r = [], o = [], a = [], s = [], l = [], N.prev = 20, !(t.size > 0)) {
            N.next = 26
            break
          }
          N.next = 24
          return ReduxSagaEffects.b(Module_111.b, Module_25.a(t))
        case 24:
          _N$sent = N.sent
          N$sent.forEach(function (e) {
            if (e.type === Widget_builtIn_types.j) {
              var t = Module_42.b.get(e.id)
              if (t) {
                var n = _N$sent[e.attributes.cloudDictId]
                if (n === Module_9.e) {
                  r.push(e)
                  t.attributes.cloudDictId = Module_9.i
                } else {
                  if (n) {
                    t.attributes.cloudDictId = parseInt(_N$sent[e.attributes.cloudDictId])
                  }
                }
              }
            }
          })
        case 26:
          N.next = 39
          break
        case 28:
          N.prev = 28
          N.t0 = N.catch(20)
          console.error(N.t0)
          d = JSON.parse(N.t0.message)
          d$code = d.code
          d$msg = d.msg
          N.t1 = d$code
          N.next = 40400903 === N.t1 ? 35 : 37
          break
        case 35:
          s.push.apply(s, Module_25.a(N$sent.filter(function (e) {
            return e.type === Widget_builtIn_types.j
          })))
          return N.abrupt("break", 39)
        case 37:
          N.next = 39
          return ReduxSagaEffects.b(ri, N$sent.filter(function (e) {
            return e.type === Widget_builtIn_types.j
          }), d$msg)
        case 39:
          if (N.prev = 39, !(n.size > 0)) {
            N.next = 45
            break
          }
          N.next = 43
          return ReduxSagaEffects.b(Module_111.c, Module_25.a(n))
        case 43:
          _N$sent2 = N.sent
          N$sent.forEach(function (e) {
            if (e.type === Widget_builtIn_types.k) {
              var t = _N$sent2[e.attributes.cloudTableId]
              var n = Module_42.b.get(e.id)
              if (n) {
                if (t === Module_9.e) {
                  o.push(e)
                  n.attributes.cloudTableId = Module_9.i
                } else {
                  if (t) {
                    n.attributes.cloudTableId = parseInt(_N$sent2[e.attributes.cloudTableId])
                  }
                }
              }
            }
            if (e.type === Widget_builtIn_types.A) {
              var r = _N$sent2[e.attributes.dataSource]
              var i = Module_42.b.get(e.id)
              if (i) {
                if (r === Module_9.e) {
                  a.push(e)
                  i.attributes.dataSource = ""
                } else {
                  if (r) {
                    i.attributes.dataSource = parseInt(_N$sent2[e.attributes.dataSource])
                  }
                }
              }
            }
          })
        case 45:
          N.next = 58
          break
        case 47:
          N.prev = 47
          N.t2 = N.catch(39)
          console.error(N.t2)
          m = JSON.parse(N.t2.message)
          m$code = m.code
          m$msg = m.msg
          N.t3 = m$code
          N.next = 40400927 === N.t3 ? 54 : 56
          break
        case 54:
          l.push.apply(l, Module_25.a(N$sent.filter(function (e) {
            return e.type === Widget_builtIn_types.k || e.type === Widget_builtIn_types.A
          })))
          return N.abrupt("break", 58)
        case 56:
          N.next = 58
          return ReduxSagaEffects.b(ri, N$sent.filter(function (e) {
            return e.type === Widget_builtIn_types.k
          }), m$msg)
        case 58:
          if (!(r.length > 0 || o.length > 0 || a.length > 0)) {
            N.next = 61
            break
          }
          N.next = 61
          return ReduxSagaEffects.b(ri, [].concat(r, o, a), "cloudSpace.dataSourceNotExist")
        case 61:
          if (!(s.length > 0)) {
            N.next = 64
            break
          }
          N.next = 64
          return ReduxSagaEffects.b(oi, [].concat(s), "cloudSpace.cloudDict")
        case 64:
          if (!(l.length > 0)) {
            N.next = 67
            break
          }
          N.next = 67
          return ReduxSagaEffects.b(oi, [].concat(l), "cloudSpace.cloudTable")
        case 67:
          v = []
          Module_42.b.forEach(function (e) {
            if (e.type === Widget_builtIn_types.j) {
              v.push(e)
            }
          })
          b = RegeneratorRuntime.mark(function e() {
            var t
            var n
            var o
            var i
            return RegeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (t = E[y], !(n = Module_42.b.get(t.id))) {
                      e.next = 8
                      break
                    }
                    o = s.find(function (e) {
                      return e.id === n.id
                    })
                    i = r.find(function (e) {
                      return e.id === n.id
                    })
                    e.next = 7
                    return ReduxSagaEffects.e(Actions.Lg(t.id, "cloudDictId", o || i ? Module_9.i : n.attributes.cloudDictId, true, true, true))
                  case 7:
                    Module_42.b.delete(t.id)
                  case 8:
                  case "end":
                    return e.stop()
                }
              }
            }, e)
          })
          y = 0
          E = v
        case 71:
          if (!(y < E.length)) {
            N.next = 76
            break
          }
          return N.delegateYield(b(), "t4", 73)
        case 73:
          y++
          N.next = 71
          break
        case 76:
          O = []
          Module_42.b.forEach(function (e) {
            if (e.type === Widget_builtIn_types.k) {
              O.push(e)
            }
          })
          w = RegeneratorRuntime.mark(function e() {
            var t
            var n
            var o
            var i
            return RegeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (t = T[C], !(n = Module_42.b.get(t.id))) {
                      e.next = 8
                      break
                    }
                    o = l.find(function (e) {
                      return e.id === n.id
                    })
                    i = r.find(function (e) {
                      return e.id === n.id
                    })
                    e.next = 7
                    return ReduxSagaEffects.e(Actions.Lg(t.id, "cloudTableId", o || i ? Module_9.i : n.attributes.cloudTableId, true, true, true))
                  case 7:
                    Module_42.b.delete(t.id)
                  case 8:
                  case "end":
                    return e.stop()
                }
              }
            }, e)
          })
          C = 0
          T = O
        case 80:
          if (!(C < T.length)) {
            N.next = 85
            break
          }
          return N.delegateYield(w(), "t5", 82)
        case 82:
          C++
          N.next = 80
          break
        case 85:
          S = []
          Module_42.b.forEach(function (e) {
            if (e.type === Widget_builtIn_types.A) {
              S.push(e)
            }
          })
          A = RegeneratorRuntime.mark(function e() {
            var t
            var n
            var o
            var i
            return RegeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (t = j[I], !(n = Module_42.b.get(t.id))) {
                      e.next = 8
                      break
                    }
                    o = l.find(function (e) {
                      return e.id === n.id
                    })
                    i = r.find(function (e) {
                      return e.id === n.id
                    })
                    e.next = 7
                    return ReduxSagaEffects.e(Actions.Lg(t.id, "dataSource", o || i ? "" : n.attributes.dataSource, true, true, true))
                  case 7:
                    Module_42.b.delete(t.id)
                  case 8:
                  case "end":
                    return e.stop()
                }
              }
            }, e)
          })
          I = 0
          j = S
        case 89:
          if (!(I < j.length)) {
            N.next = 94
            break
          }
          return N.delegateYield(A(), "t6", 91)
        case 91:
          I++
          N.next = 89
          break
        case 94:
          N.next = 96
          return ReduxSagaEffects.b(pi)
        case 96:
          N.next = 98
          return ReduxSagaEffects.b(gi)
        case 98:
          N.next = 100
          return ReduxSagaEffects.e(Actions.Qf())
        case 100:
          N.next = 102
          return ReduxSagaEffects.b(fi)
        case 102:
          N.next = 104
          return ReduxSagaEffects.e(Actions.Qj())
        case 104:
        case "end":
          return N.stop()
      }
    }
  }, Wo, null, [[20, 28], [39, 47]])
}
function di() {
  var /* [auto-meaningful-name] */t$sent
  return RegeneratorRuntime.wrap(function (t) {
    for (;;) {
      switch (t.prev = t.next) {
        case 0:
          t.next = 2
          return ReduxSagaEffects.e(Actions.ak({
            header: {
              cloudDBManager: Module_18.j.Hide
            }
          }))
        case 2:
          t.next = 4
          return ReduxSagaEffects.b(Module_147.h)
        case 4:
          if (!((t$sent = t.sent) && t$sent.length > 0)) {
            t.next = 8
            break
          }
          t.next = 8
          return ReduxSagaEffects.e(Actions.ak({
            header: {
              cloudDBManager: Module_18.j.Show
            }
          }))
        case 8:
        case "end":
          return t.stop()
      }
    }
  }, Uo)
}
function pi() {
  var e
  var /* [auto-meaningful-name] */r$t1$value
  var n
  return RegeneratorRuntime.wrap(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          e = {}
          Module_42.g.forEach(function (t) {
            if (t.type === Widget_builtIn_types.j && t.attributes.cloudDictId) {
              e[t.attributes.cloudDictId] = false
            }
          })
          r.t0 = RegeneratorRuntime.keys(e)
        case 3:
          if ((r.t1 = r.t0()).done) {
            r.next = 10
            break
          }
          r$t1$value = r.t1.value
          n = Number(r$t1$value)
          r.next = 8
          return ReduxSagaEffects.e(Actions.Pf(n))
        case 8:
          r.next = 3
          break
        case 10:
        case "end":
          return r.stop()
      }
    }
  }, Ho)
}
function fi() {
  var e
  var /* [auto-meaningful-name] */r$t1$value
  var n
  return RegeneratorRuntime.wrap(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          e = {}
          Module_42.g.forEach(function (t) {
            if (t.type === Widget_builtIn_types.A && "number" === typeof t.attributes.dataSource) {
              e[t.attributes.dataSource] = false
            }
          })
          r.t0 = RegeneratorRuntime.keys(e)
        case 3:
          if ((r.t1 = r.t0()).done) {
            r.next = 10
            break
          }
          r$t1$value = r.t1.value
          n = Number(r$t1$value)
          r.next = 8
          return ReduxSagaEffects.e(Actions.Sf(n))
        case 8:
          r.next = 3
          break
        case 10:
        case "end":
          return r.stop()
      }
    }
  }, Vo)
}
function hi(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$id
  var /* [auto-meaningful-name] */e$payload$showToast
  var /* [auto-meaningful-name] */s$sent
  var /* [auto-meaningful-name] */_s$sent
  var a
  return RegeneratorRuntime.wrap(function (s) {
    for (;;) {
      switch (s.prev = s.next) {
        case 0:
          e$payload = e.payload
          e$payload$id = e$payload.id
          e$payload$showToast = e$payload.showToast
          s.prev = 1
          s.next = 4
          return ReduxSagaEffects.f(Module_22.u)
        case 4:
          s$sent = s.sent
          s.next = 7
          return ReduxSagaEffects.f(Module_22.r)
        case 7:
          if (_s$sent = s.sent, a = [], !s$sent || _s$sent) {
            s.next = 15
            break
          }
          s.next = 12
          return ReduxSagaEffects.b(Module_111.k, e$payload$id, s$sent)
        case 12:
          a = s.sent
          s.next = 18
          break
        case 15:
          s.next = 17
          return ReduxSagaEffects.b(Module_111.f, e$payload$id)
        case 17:
          a = s.sent
        case 18:
          s.next = 20
          return ReduxSagaEffects.e(Actions.Ag(e$payload$id, a, true))
        case 20:
          s.next = 27
          break
        case 22:
          if (s.prev = 22, s.t0 = s.catch(1), !e$payload$showToast) {
            s.next = 27
            break
          }
          s.next = 27
          return ReduxSagaEffects.e(Actions.showCommonToastInfoAction({
            type: "error",
            message: s.t0.message
          }))
        case 27:
        case "end":
          return s.stop()
      }
    }
  }, zo, null, [[1, 22]])
}
function mi(e) {
  var /* [auto-meaningful-name] */l$data
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$id
  var /* [auto-meaningful-name] */e$payload$data
  var /* [auto-meaningful-name] */e$payload$isEmitOT
  var /* [auto-meaningful-name] */f$sent
  var l
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace
  var d
  var p
  return RegeneratorRuntime.wrap(function (f) {
    for (;;) {
      switch (f.prev = f.next) {
        case 0:
          e$payload = e.payload
          e$payload$id = e$payload.id
          e$payload$data = e$payload.data
          e$payload$isEmitOT = e$payload.isEmitOT
          f.next = 3
          return ReduxSagaEffects.f(Module_22.a)
        case 3:
          f$sent = f.sent
          l = f$sent.find(function (e) {
            return e.id === e$payload$id
          })
          f.next = 7
          return ReduxSagaEffects.e(Actions.Jj(e$payload$id, e$payload$data))
        case 7:
          if (e$payload$isEmitOT) {
            if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace = oTHelper.cloudSpace) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace)) {
              $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace.clientOp.updateCloudDictKeys(e$payload$id, e$payload$data)
            }
          }
          if (null === l || undefined === l || null === (l$data = l.data) || undefined === l$data ? undefined : l$data.length) {
            d = []
            p = []
            l.data.forEach(function (e) {
              var t = true
              e$payload$data.forEach(function (n) {
                if (e.id === n.id) {
                  t = false
                  if (e.key !== n.key) {
                    p.push(Module_6.a(Module_6.a({}, n), {}, {
                      oldKey: e.key
                    }))
                  }
                }
              })
              if (t) {
                d.push(e)
              }
            })
            d.forEach(function (e) {
              Module_26.q(Module_26.c.CLOUD_DICT_KEYS, e.key)
            })
            p.forEach(function (e) {
              Module_26.v(e$payload$id, e.oldKey, e.key)
            })
          }
        case 9:
        case "end":
          return f.stop()
      }
    }
  }, Yo)
}
function gi() {
  var e
  var /* [auto-meaningful-name] */r$t1$value
  var n
  return RegeneratorRuntime.wrap(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          e = {}
          Module_42.g.forEach(function (t) {
            if (t.type === Widget_builtIn_types.k && t.attributes.cloudTableId !== Module_9.i) {
              e[t.attributes.cloudTableId] = false
            }
            if (t.type === Widget_builtIn_types.A && "number" === typeof t.attributes.dataSource) {
              e[t.attributes.dataSource] = false
            }
          })
          r.t0 = RegeneratorRuntime.keys(e)
        case 3:
          if ((r.t1 = r.t0()).done) {
            r.next = 10
            break
          }
          r$t1$value = r.t1.value
          n = Number(r$t1$value)
          r.next = 8
          return ReduxSagaEffects.e(Actions.Rf(n, false))
        case 8:
          r.next = 3
          break
        case 10:
        case "end":
          return r.stop()
      }
    }
  }, Ko)
}
function _i(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$id
  var /* [auto-meaningful-name] */e$payload$showToast
  var /* [auto-meaningful-name] */s$sent
  var /* [auto-meaningful-name] */_s$sent2
  var a
  return RegeneratorRuntime.wrap(function (s) {
    for (;;) {
      switch (s.prev = s.next) {
        case 0:
          e$payload = e.payload
          e$payload$id = e$payload.id
          e$payload$showToast = e$payload.showToast
          s.prev = 1
          s.next = 4
          return ReduxSagaEffects.f(Module_22.y)
        case 4:
          s$sent = s.sent
          s.next = 7
          return ReduxSagaEffects.f(Module_22.r)
        case 7:
          if (_s$sent2 = s.sent, !s$sent || _s$sent2) {
            s.next = 14
            break
          }
          s.next = 11
          return ReduxSagaEffects.b(Module_111.m, e$payload$id, s$sent)
        case 11:
          a = s.sent
          s.next = 17
          break
        case 14:
          s.next = 16
          return ReduxSagaEffects.b(Module_111.i, e$payload$id)
        case 16:
          a = s.sent
        case 17:
          s.next = 19
          return ReduxSagaEffects.e(Actions.Dg(e$payload$id, a.columns, true))
        case 19:
          s.next = 26
          break
        case 21:
          if (s.prev = 21, s.t0 = s.catch(1), !e$payload$showToast) {
            s.next = 26
            break
          }
          s.next = 26
          return ReduxSagaEffects.e(Actions.showCommonToastInfoAction({
            type: "error",
            message: s.t0.message
          }))
        case 26:
        case "end":
          return s.stop()
      }
    }
  }, qo, null, [[1, 21]])
}
function vi(e, t) {
  var n
  var r
  var o
  var i
  var /* [auto-meaningful-name] */i$attributes$templateSlotMap
  var s
  var l
  var /* [auto-meaningful-name] */i$attributes$templateSlotMapL$dataBindings
  return RegeneratorRuntime.wrap(function (d) {
    for (;;) {
      switch (d.prev = d.next) {
        case 0:
          n = []
          Module_42.g.forEach(function (t) {
            if (t.type === Widget_builtIn_types.A && t.attributes.dataSource === e) {
              n.push(t)
            }
          })
          r = 0
          o = n
        case 3:
          if (!(r < o.length)) {
            d.next = 14
            break
          }
          for (l in i = o[r], i$attributes$templateSlotMap = i.attributes.templateSlotMap, s = false, i$attributes$templateSlotMap) if ((i$attributes$templateSlotMapL$dataBindings = i$attributes$templateSlotMap[l].dataBindings) && t.includes(i$attributes$templateSlotMapL$dataBindings)) {
            i$attributes$templateSlotMap[l].dataBindings = ""
            s = true
          }
          if (!s) {
            d.next = 11
            break
          }
          d.next = 11
          return ReduxSagaEffects.e(Actions.Lg(i.id, "templateSlotMap", i$attributes$templateSlotMap, false, true, true))
        case 11:
          r++
          d.next = 3
          break
        case 14:
        case "end":
          return d.stop()
      }
    }
  }, Xo)
}
function bi(e) {
  var /* [auto-meaningful-name] */l$columns
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$id
  var /* [auto-meaningful-name] */e$payload$columns
  var /* [auto-meaningful-name] */e$payload$isEmitOT
  var /* [auto-meaningful-name] */f$sent
  var l
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace
  var d
  var p
  return RegeneratorRuntime.wrap(function (f) {
    for (;;) {
      switch (f.prev = f.next) {
        case 0:
          e$payload = e.payload
          e$payload$id = e$payload.id
          e$payload$columns = e$payload.columns
          e$payload$isEmitOT = e$payload.isEmitOT
          f.next = 3
          return ReduxSagaEffects.f(Module_22.c)
        case 3:
          f$sent = f.sent
          l = f$sent.find(function (e) {
            return e.id === e$payload$id
          })
          f.next = 7
          return ReduxSagaEffects.e(Actions.Mj(e$payload$id, e$payload$columns))
        case 7:
          f.next = 9
          return ReduxSagaEffects.e(Actions.Oj(e$payload$id, e$payload$columns))
        case 9:
          if (e$payload$isEmitOT && (null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace = oTHelper.cloudSpace) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace || $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace.clientOp.updateCloudTableColumns(e$payload$id, e$payload$columns)), !(null === l || undefined === l || null === (l$columns = l.columns) || undefined === l$columns ? undefined : l$columns.length)) {
            f.next = 19
            break
          }
          if (d = [], p = [], l.columns.forEach(function (e) {
            var t = true
            e$payload$columns.forEach(function (n) {
              if (e.id === n.id) {
                t = false
                if (e.name !== n.name) {
                  p.push(Module_6.a(Module_6.a({}, n), {}, {
                    oldName: e.name
                  }))
                }
              }
            })
            if (t) {
              d.push(e)
            }
          }), d.forEach(function (e) {
            Module_26.q(Module_26.c.CLOUD_TABLE_COLUMNS, e.name)
          }), p.forEach(function (e) {
            Module_26.w(e$payload$id, e.oldName, e.name)
          }), !(d.length > 0)) {
            f.next = 19
            break
          }
          f.next = 19
          return ReduxSagaEffects.b(vi, e$payload$id, d.map(function (e) {
            return e.id
          }))
        case 19:
        case "end":
          return f.stop()
      }
    }
  }, Qo)
}
function yi(e) {
  var /* [auto-meaningful-name] */e$payload$id
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace
  var /* [auto-meaningful-name] */a$sent
  var /* [auto-meaningful-name] */_a$sent
  var i
  return RegeneratorRuntime.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          e$payload$id = e.payload.id
          a.prev = 1
          a.next = 4
          return ReduxSagaEffects.f(Module_22.u)
        case 4:
          a$sent = a.sent
          a.next = 7
          return ReduxSagaEffects.f(Module_22.r)
        case 7:
          if (_a$sent = a.sent, i = [], !a$sent || _a$sent) {
            a.next = 15
            break
          }
          a.next = 12
          return ReduxSagaEffects.b(Module_111.l, e$payload$id, a$sent)
        case 12:
          i = a.sent
          a.next = 18
          break
        case 15:
          a.next = 17
          return ReduxSagaEffects.b(Module_111.h, e$payload$id)
        case 17:
          i = a.sent
        case 18:
          a.next = 20
          return ReduxSagaEffects.e(Actions.Nj(e$payload$id, i))
        case 20:
          if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace = oTHelper.cloudSpace) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace)) {
            $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace.clientOp.updateCloudTableData(e$payload$id, i)
          }
          a.next = 25
          break
        case 23:
          a.prev = 23
          a.t0 = a.catch(1)
        case 25:
        case "end":
          return a.stop()
      }
    }
  }, Zo, null, [[1, 23]])
}
function Ei(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$list
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace
  return RegeneratorRuntime.wrap(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          e$payload = e.payload
          e$payload$list = e$payload.list
          if (e$payload.isEmitOT) {
            if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace = oTHelper.cloudSpace) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace)) {
              $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace.clientOp.updateCloudDictList(e$payload$list)
            }
          }
          o.next = 4
          return ReduxSagaEffects.e(Actions.Kj(e$payload$list))
        case 4:
        case "end":
          return o.stop()
      }
    }
  }, Jo)
}
function Oi(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$list
  var /* [auto-meaningful-name] */e$payload$isEmitOT
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace
  return RegeneratorRuntime.wrap(function (i) {
    for (;;) {
      switch (i.prev = i.next) {
        case 0:
          e$payload = e.payload
          e$payload$list = e$payload.list
          e$payload$isEmitOT = e$payload.isEmitOT
          i.next = 3
          return ReduxSagaEffects.e(Actions.Lj(e$payload$list))
        case 3:
          if (e$payload$isEmitOT) {
            if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace = oTHelper.cloudSpace) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace)) {
              $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$cloudSpace.clientOp.updateCloudTableList(e$payload$list)
            }
          }
        case 4:
        case "end":
          return i.stop()
      }
    }
  }, $o)
}
var wi
_o = {}
Module_11.a(_o, Actions.cb, ui)
Module_11.a(_o, Actions.C, ci)
Module_11.a(_o, Actions.O, hi)
Module_11.a(_o, Actions.Bb, mi)
Module_11.a(_o, Actions.Q, _i)
Module_11.a(_o, Actions.Db, bi)
Module_11.a(_o, Actions.R, yi)
Module_11.a(_o, Actions.Cb, Ei)
Module_11.a(_o, Actions.Eb, Oi)
var Ci = _o
var Ti = qn(Ci)
function Si() {
  return RegeneratorRuntime.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          e.next = 2
          return ReduxSagaEffects.g(Object.keys(Ci), Ti)
        case 2:
          e.next = 4
          return ReduxSagaEffects.h([Actions.P], ii)
        case 4:
        case "end":
          return e.stop()
      }
    }
  }, ei)
}
var Ai = RegeneratorRuntime.mark(Xa)
var Ii = RegeneratorRuntime.mark(Qa)
var ji = RegeneratorRuntime.mark(Ja)
var Ni = RegeneratorRuntime.mark(onAsyncCreateProject)
var Ri = RegeneratorRuntime.mark(es)
var ki = RegeneratorRuntime.mark(ts)
var xi = RegeneratorRuntime.mark(ns)
var Di = RegeneratorRuntime.mark(loadWorkFromJSON)
var Mi = RegeneratorRuntime.mark(os)
var Li = RegeneratorRuntime.mark(is)
var Pi = RegeneratorRuntime.mark(as)
var Bi = RegeneratorRuntime.mark(ss)
var Fi = RegeneratorRuntime.mark(cs)
var Gi = RegeneratorRuntime.mark(ls)
var Wi = RegeneratorRuntime.mark(us)
var Ui = RegeneratorRuntime.mark(ds)
var Hi = RegeneratorRuntime.mark(ps)
var Vi = RegeneratorRuntime.mark(fs)
var zi = RegeneratorRuntime.mark(hs)
var Yi = RegeneratorRuntime.mark(ms)
var Ki = RegeneratorRuntime.mark(gs)
var qi = RegeneratorRuntime.mark(_s)
var Xi = RegeneratorRuntime.mark(vs)
var Qi = RegeneratorRuntime.mark(bs)
var Zi = RegeneratorRuntime.mark(ys)
var Ji = RegeneratorRuntime.mark(Es)
var $i = RegeneratorRuntime.mark(Cs)
var ta = RegeneratorRuntime.mark(Ss)
var na = RegeneratorRuntime.mark(As)
var ra = RegeneratorRuntime.mark(Is)
var oa = RegeneratorRuntime.mark(js)
var ia = RegeneratorRuntime.mark(Ns)
var aa = RegeneratorRuntime.mark(Rs)
var ca = RegeneratorRuntime.mark(handlePublishWorkToH5)
var la = RegeneratorRuntime.mark(Ds)
var ua = RegeneratorRuntime.mark(Ms)
var da = RegeneratorRuntime.mark(getSoundFileMap)
var pa = RegeneratorRuntime.mark(getIconFileMap)
var fa = RegeneratorRuntime.mark(getFontFileMap)
var ha = RegeneratorRuntime.mark(Ws)
var ma = RegeneratorRuntime.mark(Us)
var ga = RegeneratorRuntime.mark(Hs)
var _a = RegeneratorRuntime.mark(Vs)
var va = RegeneratorRuntime.mark(zs)
var ba = RegeneratorRuntime.mark(Ys)
var ya = RegeneratorRuntime.mark(Ks)
var Ea = RegeneratorRuntime.mark(qs)
var Oa = RegeneratorRuntime.mark(Xs)
var wa = RegeneratorRuntime.mark(Qs)
var Ca = RegeneratorRuntime.mark(Zs)
var Ta = RegeneratorRuntime.mark(Js)
var Sa = RegeneratorRuntime.mark($s)
var Aa = RegeneratorRuntime.mark(ec)
var Ia = RegeneratorRuntime.mark(tc)
var ja = RegeneratorRuntime.mark(nc)
var Na = RegeneratorRuntime.mark(rc)
var Ra = RegeneratorRuntime.mark(oc)
var ka = RegeneratorRuntime.mark(ic)
var xa = RegeneratorRuntime.mark(ac)
var Da = RegeneratorRuntime.mark(sc)
var Ma = RegeneratorRuntime.mark(cc)
var La = RegeneratorRuntime.mark(lc)
var Pa = RegeneratorRuntime.mark(uc)
var Ba = RegeneratorRuntime.mark(dc)
var Fa = RegeneratorRuntime.mark(pc)
var Ga = RegeneratorRuntime.mark(fc)
var Wa = RegeneratorRuntime.mark(hc)
var Ua = RegeneratorRuntime.mark(mc)
var Ha = RegeneratorRuntime.mark(gc)
var Va = RegeneratorRuntime.mark(_c)
var za = RegeneratorRuntime.mark(vc)
var Ya = RegeneratorRuntime.mark(bc)
var Ka = RegeneratorRuntime.mark(yc)
var qa = RegeneratorRuntime.mark(wc)
function Xa(e) {
  var t
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$index
  var /* [auto-meaningful-name] */e$payload$shouldSaveCurrentData
  var i
  var /* [auto-meaningful-name] */p$sent
  var /* [auto-meaningful-name] */p$sent1
  var l
  var u
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$customEvent
  return RegeneratorRuntime.wrap(function (p) {
    for (;;) {
      switch (p.prev = p.next) {
        case 0:
          e$payload = e.payload
          e$payload$index = e$payload.index
          e$payload$shouldSaveCurrentData = e$payload.shouldSaveCurrentData
          i = undefined === e$payload$shouldSaveCurrentData || e$payload$shouldSaveCurrentData
          p.next = 3
          return ReduxSagaEffects.f(Module_22.x)
        case 3:
          p$sent = p.sent
          p.next = 6
          return ReduxSagaEffects.f(Module_22.C)
        case 6:
          if (p$sent1 = p.sent, l = p$sent1.get(e$payload$index), u = -1 === p$sent ? "__EMPTY_ID__" : (null === (t = p$sent1.get(p$sent)) || undefined === t ? undefined : t.id) || "__EMPTY_ID__", !(null === l || undefined === l ? undefined : l.id) || l.id === u) {
            p.next = 17
            break
          }
          Module_26.g.setSelectedItem()
          p.next = 13
          return ReduxSagaEffects.e(Actions.Bi(e$payload$index))
        case 13:
          p.next = 15
          return ReduxSagaEffects.e(Actions.ug(undefined))
        case 15:
          Module_26.z.selectWorkspaceByScreenId(l.id, i)
          if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$customEvent = oTHelper.customEvent) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$customEvent)) {
            $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$customEvent.emit.focusItem("widget")
          }
        case 17:
        case "end":
          return p.stop()
      }
    }
  }, Ai)
}
function Qa(e) {
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$screen
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$blink
  var /* [auto-meaningful-name] */e$payload$index
  var /* [auto-meaningful-name] */p$sent
  var /* [auto-meaningful-name] */p$sent1
  var a
  var s
  var /* [auto-meaningful-name] */p$sent1$size
  var u
  var d
  return RegeneratorRuntime.wrap(function (p) {
    for (;;) {
      switch (p.prev = p.next) {
        case 0:
          e$payload$index = e.payload.index
          p.next = 3
          return ReduxSagaEffects.f(Module_22.s)
        case 3:
          p$sent = p.sent
          p.next = 6
          return ReduxSagaEffects.f(Module_22.C)
        case 6:
          p$sent1 = p.sent
          a = Module_9.B(Language.c(p$sent, "defaultScreenTitle").toString(), p$sent1)
          s = Module_9.A(a)
          p$sent1$size = p$sent1.size
          u = Module_26.z.addWorkspaceData({
            screenId: s.id
          })
          d = undefined !== e$payload$index ? e$payload$index : p$sent1$size
          p.next = 14
          return ReduxSagaEffects.e(Actions.if(s, d))
        case 14:
          p.next = 16
          return ReduxSagaEffects.e(Actions.vg(d))
        case 16:
          p.next = 18
          return ReduxSagaEffects.e(Actions.Fi(true))
        case 18:
          if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$screen = oTHelper.screen) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$screen)) {
            $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$screen.clientOp.addScreen(s, d)
          }
          if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$blink = oTHelper.blink) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$blink)) {
            $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$blink.clientOp.addWorkspace(s.id, {
              screenId: s.id,
              workspaceJson: null === u || undefined === u ? undefined : u.getWorkspaceJson(),
              workspaceOffset: null === u || undefined === u ? undefined : u.getWorkspaceOffset()
            })
          }
        case 20:
        case "end":
          return p.stop()
      }
    }
  }, Ii)
}
function Za(e) {
  var t = Module_9.A(Language.c(e, "defaultScreenTitle").toString())
  return {
    title: Language.c(e, "newProjectTitle").toString(),
    version: Module_53.e,
    blockly: Module_11.a({}, t.id, {
      screenId: t.id,
      workspaceJson: {
        blocks: {},
        connections: {},
        comments: {}
      },
      workspaceOffset: {
        x: 0,
        y: 0
      }
    }),
    screens: Module_11.a({}, t.id, Module_6.a(Module_6.a({}, t), {}, {
      widgets: {}
    })),
    screenIds: [t.id],
    imageFileList: [],
    globalVariableList: [],
    globalArrayList: [],
    globalObjectList: []
  }
}
function Ja(e) {
  var /* [auto-meaningful-name] */e$payload$code
  var /* [auto-meaningful-name] */r$sent
  return RegeneratorRuntime.wrap(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          e$payload$code = e.payload.code
          r.next = 3
          return ReduxSagaEffects.f(Module_22.s)
        case 3:
          r$sent = r.sent
          r.next = 6
          return ReduxSagaEffects.e(Actions.warpAsyncCreateProject())
        case 6:
          if (40500103 !== e$payload$code) {
            r.next = 11
            break
          }
          r.next = 9
          return ReduxSagaEffects.e(Actions.openConfirmDialogAction({
            title: "error",
            content: Language.c(r$sent, "MyProject.projectHasDeleted").toString(),
            cancelBtnVisible: false
          }))
        case 9:
          r.next = 19
          break
        case 11:
          if (40500101 !== e$payload$code) {
            r.next = 16
            break
          }
          r.next = 14
          return ReduxSagaEffects.e(Actions.openConfirmDialogAction({
            title: "error",
            content: Language.c(r$sent, "MyProject.projectHasNoRermission").toString(),
            cancelBtnVisible: false
          }))
        case 14:
          r.next = 19
          break
        case 16:
          if (40400906 !== e$payload$code) {
            r.next = 19
            break
          }
          r.next = 19
          return ReduxSagaEffects.e(Actions.openConfirmDialogAction({
            title: Language.c(r$sent, "OT.editPermissionLostTitle").toString(),
            content: Language.c(r$sent, "OT.editPermissionLostDescription").toString(),
            cancelBtnVisible: false
          }))
        case 19:
        case "end":
          return r.stop()
      }
    }
  }, ji)
}
function onAsyncCreateProject(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$json
  var /* [auto-meaningful-name] */e$payload$jsonFrom
  var o
  var /* [auto-meaningful-name] */e$payload$lastSavedTime
  var /* [auto-meaningful-name] */e$payload$projectId
  var /* [auto-meaningful-name] */e$payload$isCollWork
  var /* [auto-meaningful-name] */e$payload$isAuthor
  var d
  var /* [auto-meaningful-name] */e$payload$editPermission
  var /* [auto-meaningful-name] */e$payload$sourceTag
  var /* [auto-meaningful-name] */e$payload$sourceId
  var /* [auto-meaningful-name] */y$sent
  var g
  var _
  var v
  var b
  return RegeneratorRuntime.wrap(function (y) {
    for (;;) {
      switch (y.prev = y.next) {
        case 0:
          e$payload = e.payload
          e$payload$json = e$payload.json
          e$payload$jsonFrom = e$payload.jsonFrom
          o = undefined === e$payload$jsonFrom ? Module_18.d.OTHER : e$payload$jsonFrom
          e$payload$lastSavedTime = e$payload.lastSavedTime
          e$payload$projectId = e$payload.projectId
          e$payload$isCollWork = e$payload.isCollWork
          e$payload$isAuthor = e$payload.isAuthor
          d = undefined === e$payload$isAuthor || e$payload$isAuthor
          e$payload$editPermission = e$payload.editPermission
          e$payload$sourceTag = e$payload.sourceTag
          e$payload$sourceId = e$payload.sourceId
          y.next = 3
          return ReduxSagaEffects.e(Actions.Gi(false))
        case 3:
          y.next = 5
          return ReduxSagaEffects.f(Module_22.s)
        case 5:
          y$sent = y.sent
          y.next = 8
          return ReduxSagaEffects.e(Actions.Ug())
        case 8:
          g = e$payload$json
          _ = e$payload$sourceTag || Module_18.g.FREEDOM
          v = e$payload$sourceId || ""
          y.next = 13
          return ReduxSagaEffects.e(Actions.Di(o))
        case 13:
          if (!g) {
            g = Za(y$sent)
          }
          y.next = 16
          return ReduxSagaEffects.b(loadWorkFromJSON, g)
        case 16:
          y.next = 18
          return ReduxSagaEffects.e(Actions.Uh(e$payload$projectId || Module_64.a("PROJECT")))
        case 18:
          y.next = 20
          return ReduxSagaEffects.e(Actions.Ei(e$payload$lastSavedTime))
        case 20:
          y.next = 22
          return ReduxSagaEffects.e(Actions.Fi(false))
        case 22:
          y.next = 24
          return ReduxSagaEffects.e(Module_100.n())
        case 24:
          if (o !== Module_18.d.MY_WORK) {
            y.next = 29
            break
          }
          y.next = 27
          return ReduxSagaEffects.e(Actions.Tg(true))
        case 27:
          y.next = 29
          return ReduxSagaEffects.e(Actions.Cf(true))
        case 29:
          if (!e$payload$projectId) {
            y.next = 38
            break
          }
          if (!e$payload$isCollWork) {
            y.next = 33
            break
          }
          y.next = 33
          return ReduxSagaEffects.e(Module_100.o(e$payload$projectId))
        case 33:
          Shared_tools.jb(e$payload$projectId)
          _ = g.sourceTag || Module_18.g.FREEDOM
          v = g.sourceId || ""
          y.next = 44
          break
        case 38:
          Gn()
          y.next = 41
          return ReduxSagaEffects.e(Actions.Tg(true))
        case 41:
          Shared_tools.k(["workId", "inviteCode", "jsonUrl"])
          y.next = 44
          return ReduxSagaEffects.b(ts, _, v)
        case 44:
          y.next = 46
          return ReduxSagaEffects.e(Module_100.q(!!d))
        case 46:
          y.next = 48
          return ReduxSagaEffects.e(Actions.Sg())
        case 48:
          y.next = 50
          return ReduxSagaEffects.e(Actions.bg())
        case 50:
          y.next = 52
          return ReduxSagaEffects.e(Actions.cg())
        case 52:
          if (o !== Module_18.d.LOCAL_FILE) {
            y.next = 57
            break
          }
          y.next = 55
          return ReduxSagaEffects.e(Actions.dg())
        case 55:
          y.next = 63
          break
        case 57:
          y.next = 59
          return ReduxSagaEffects.b(pi)
        case 59:
          y.next = 61
          return ReduxSagaEffects.b(gi)
        case 61:
          y.next = 63
          return ReduxSagaEffects.b(fi)
        case 63:
          y.next = 65
          return ReduxSagaEffects.e(Actions.Ci(e$payload$editPermission || Module_18.c.Edit))
        case 65:
          y.t0 = Module_26.z
          y.next = 68
          return ReduxSagaEffects.f(Module_22.y)
        case 68:
          y.t1 = y.sent
          y.t0.setCurrentProjectId.call(y.t0, y.t1)
          y.next = 72
          return ReduxSagaEffects.e(Actions.Ui({
            tag: _,
            id: v
          }))
        case 72:
          if (o !== Module_18.d.HOME_COURSE) {
            Shared_tools.k(["courseId"])
          }
          if (o !== Module_18.d.HOME_TEMPLATE) {
            Shared_tools.k(["templateId"])
          }
          y.next = 76
          return ReduxSagaEffects.b(go)
        case 76:
          if (e$payload$projectId && (b = Bn()) && Fn(b), o === Module_18.d.HOME_COURSE || o === Module_18.d.COURSE) {
            y.next = 81
            break
          }
          if (Module_627.a.isLoaded()) {
            Module_627.a.show()
            Module_627.a.close({
              closeAnimationPos: {
                x: 150,
                y: 30
              }
            })
          }
          y.next = 81
          return ReduxSagaEffects.e(Actions.Gh(Module_392.a))
        case 81:
          y.next = 83
          return ReduxSagaEffects.e(Actions.Gi(true))
        case 83:
        case "end":
          return y.stop()
      }
    }
  }, Ni)
}
function es(e) {
  var /* [auto-meaningful-name] */e$payload$json
  var n
  var r
  var o
  return RegeneratorRuntime.wrap(function (i) {
    for (;;) {
      switch (i.prev = i.next) {
        case 0:
          e$payload$json = e.payload.json
          i.next = 3
          return ReduxSagaEffects.e(Actions.Gi(false))
        case 3:
          i.next = 5
          return ReduxSagaEffects.e(Actions.Ug())
        case 5:
          n = Module_345.a(e$payload$json)
          i.next = 8
          return ReduxSagaEffects.b(loadWorkFromJSON, n)
        case 8:
          i.next = 10
          return ReduxSagaEffects.e(Actions.Uh(e$payload$json.id))
        case 10:
          i.next = 12
          return ReduxSagaEffects.e(Actions.Fi(false))
        case 12:
          i.next = 14
          return ReduxSagaEffects.e(Actions.bg())
        case 14:
          i.next = 16
          return ReduxSagaEffects.e(Actions.cg())
        case 16:
          i.next = 18
          return ReduxSagaEffects.b(pi)
        case 18:
          i.next = 20
          return ReduxSagaEffects.b(gi)
        case 20:
          i.next = 22
          return ReduxSagaEffects.b(fi)
        case 22:
          i.next = 24
          return ReduxSagaEffects.e(Actions.Ci(Module_18.c.Edit))
        case 24:
          i.t0 = Module_26.z
          i.next = 27
          return ReduxSagaEffects.f(Module_22.y)
        case 27:
          i.t1 = i.sent
          i.t0.setCurrentProjectId.call(i.t0, i.t1)
          i.next = 31
          return ReduxSagaEffects.e(Actions.Gi(true))
        case 31:
          r = Module_26.z.generateAllWorkspaceCodes(e$payload$json.screenList)
          if (undefined !== (o = Terser.minify(r, {
            keep_fnames: true
          })).code) {
            r = o.code
          }
          window.parent.postMessage({
            type: "PLAYER_BLOCK_CODE",
            payload: r
          }, "*")
        case 35:
        case "end":
          return i.stop()
      }
    }
  }, Ri)
}
function ts(e, t) {
  var /* [auto-meaningful-name] */o$sent
  var /* [auto-meaningful-name] */_o$sent2
  return RegeneratorRuntime.wrap(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          o.next = 2
          return ReduxSagaEffects.f(Module_22.y)
        case 2:
          o$sent = o.sent
          o.next = 5
          return ReduxSagaEffects.f(Module_22.G)
        case 5:
          _o$sent2 = o.sent
          Module_141.a("WorkCreate", {
            sourceTag: e,
            sourceId: t,
            workId: o$sent,
            workType: "APP工匠",
            workName: _o$sent2,
            isSuccess: true,
            failReason: ""
          })
        case 7:
        case "end":
          return o.stop()
      }
    }
  }, ki)
}
function ns(e) {
  var /* [auto-meaningful-name] */e$payload$json
  return RegeneratorRuntime.wrap(function (n) {
    for (;;) {
      switch (n.prev = n.next) {
        case 0:
          e$payload$json = e.payload.json
          n.next = 3
          return ReduxSagaEffects.e(Actions.cg())
        case 3:
          n.next = 5
          return ReduxSagaEffects.e(Actions.bg())
        case 5:
          n.next = 7
          return ReduxSagaEffects.b(loadWorkFromJSON, e$payload$json)
        case 7:
          n.next = 9
          return ReduxSagaEffects.e(Actions.Cf(true))
        case 9:
        case "end":
          return n.stop()
      }
    }
  }, xi)
}

/**
 * 从 JSON 文件加载作品
 *
 * @param workJSON 作品 JSON 文件
 * @returns
 */
function loadWorkFromJSON(workJSON) {
  let blockly
  let title
  let imageFileList
  let soundFileList
  let iconFileList
  let screenIds
  let globalVariableList
  let globalArrayList
  let globalWidgetIds
  let globalWidgets
  let extensionWidgetList
  let unsafeExtensionWidgetList
  let globalObjectList
  let version
  let cloudDictKeysList
  let cloudTableColumnList
  let cloudTableDataList
  let cloudDictList
  let cloudTableList
  var I
  var /* [auto-meaningful-name] */regeneratorContext$sent
  var N
  var /* [auto-meaningful-name] */_regeneratorContext$sent
  var k
  var x
  var D
  var /* [auto-meaningful-name] */D$value
  var L
  var P
  var B
  var /* [auto-meaningful-name] */B$value
  var /* [auto-meaningful-name] */_regeneratorContext$sent2
  var W
  var U
  var H
  var /* [auto-meaningful-name] */H$attributes$fontFamily
  var /* [auto-meaningful-name] */H$attributes
  var /* [auto-meaningful-name] */H$attributes$content
  var K
  var q
  var X
  var /* [auto-meaningful-name] */regeneratorContext$t1$value
  var /* [auto-meaningful-name] */regeneratorContext$t3$value
  var /* [auto-meaningful-name] */regeneratorContext$t5$value
  return RegeneratorRuntime.wrap(function (regeneratorContext) {
    for (;;) {
      switch (regeneratorContext.prev = regeneratorContext.next) {
        case 0:
          Module_345.b(workJSON)
          Module_42.b.clear()
          ;({
            blockly,
            title,
            imageFileList,
            soundFileList,
            iconFileList,
            screenIds,
            globalVariableList,
            globalArrayList,
            globalWidgetIds = [],
            globalWidgets = {},
            extensionWidgetList = [],
            unsafeExtensionWidgetList = [],
            globalObjectList,
            version = 1,
            cloudDictKeysList,
            cloudTableColumnList,
            cloudTableDataList,
            cloudDictList,
            cloudTableList
          } = workJSON)
          regeneratorContext.next = 5
          return ReduxSagaEffects.b(LoadCustomWidget.loadWidgetsFromFile, extensionWidgetList, unsafeExtensionWidgetList)
        case 5:
          I = Module_97.f(workJSON.screens)
          regeneratorContext.next = 8
          return ReduxSagaEffects.b(LoadCustomWidget.w, extensionWidgetList, I, globalWidgets)
        case 8:
          regeneratorContext.next = 10
          return ReduxSagaEffects.f(Module_22.z)
        case 10:
          regeneratorContext$sent = regeneratorContext.sent
          Module_345.c(I, version)
          N = Module_97.e(workJSON.screens, screenIds)
          regeneratorContext.next = 15
          return ReduxSagaEffects.e(Actions.Th({
            screens: N,
            title: title,
            globalVariableList,
            globalArrayList,
            globalWidgetIds,
            globalObjectList
          }))
        case 15:
          regeneratorContext.next = 17
          return ReduxSagaEffects.f(Module_22.y)
        case 17:
          if (_regeneratorContext$sent = regeneratorContext.sent, Module_20.clearLocalDocuments(_regeneratorContext$sent, globalWidgetIds), Module_174.a.clear(), regeneratorContext$sent === Module_18.d.LOCAL_FILE) {
            k = Module_9.Zb(globalWidgets)
            x = Module_47.a(k)
            try {
              for (x.s(); !(D = x.n()).done;) {
                D$value = D.value
                Module_42.b.set(D$value.id, D$value)
              }
            } catch (ee) {
              x.e(ee)
            } finally {
              x.f()
            }
            L = Module_9.Zb(I)
            P = Module_47.a(L)
            try {
              for (P.s(); !(B = P.n()).done;) {
                B$value = B.value
                Module_42.b.set(B$value.id, B$value)
              }
            } catch (ee) {
              P.e(ee)
            } finally {
              P.f()
            }
          }
          Module_9.Sb(Module_6.a(Module_6.a({}, I), globalWidgets))
          regeneratorContext.next = 24
          return ReduxSagaEffects.b(go)
        case 24:
          Module_9.Qb(imageFileList)
          // [CoCo Next] 移除孤立的影子积木（Undefined 修复）
          removeAloneShadowBlocks(blockly)
          Module_26.z.replaceWorkspaces(blockly)
          Module_376.b()
          regeneratorContext.next = 29
          return ReduxSagaEffects.b(Ms)
        case 29:
          regeneratorContext.next = 31
          return ReduxSagaEffects.b($r, soundFileList || [])
        case 31:
          regeneratorContext.next = 33
          return ReduxSagaEffects.b(uo, iconFileList || [])
        case 33:
          regeneratorContext.next = 35
          return ReduxSagaEffects.e(Actions.vg(0, false))
        case 35:
          regeneratorContext.next = 37
          return ReduxSagaEffects.e(Actions.Zj())
        case 37:
          regeneratorContext.next = 39
          return ReduxSagaEffects.f(Module_22.j)
        case 39:
          for (U in _regeneratorContext$sent2 = regeneratorContext.sent, W = {}, _regeneratorContext$sent2.forEach(function (e) {
            if (e.cdnUrl) {
              W[e.id] = e.cdnUrl
            }
          }), I) {
            if ((H = I[U]).type === Widget_builtIn_types.H && (H$attributes$fontFamily = H.attributes.fontFamily) && W[H$attributes$fontFamily] && !Shared_tools.db[H$attributes$fontFamily]) {
              Shared_tools.bb(H$attributes$fontFamily, W[H$attributes$fontFamily])
              Shared_tools.db[H$attributes$fontFamily] = true
            }
            if (H && H.attributes && "EXTENSION_QUILL_RICH_TEXT_WIDGET" === H.type) {
              H$attributes = H.attributes
              H$attributes$content = H$attributes.content
              K = undefined === H$attributes$content ? "" : H$attributes$content
              Module_375.a(K).forEach(function (e) {
                if (e && W[e] && !Shared_tools.db[e]) {
                  Shared_tools.bb(e, W[e])
                  Shared_tools.db[e] = true
                }
              })
            }
          }
          if (regeneratorContext$sent === Module_18.d.LOCAL_FILE) {
            regeneratorContext.next = 50
            break
          }
          q = Module_9.ab()
          regeneratorContext.next = 47
          return ReduxSagaEffects.e(Actions.Sj(q.map(function (e) {
            return e.attributes.cloudDictId
          })))
        case 47:
          X = Module_9.rb()
          regeneratorContext.next = 50
          return ReduxSagaEffects.e(Actions.Tj(X))
        case 50:
          if (!cloudDictKeysList) {
            regeneratorContext.next = 58
            break
          }
          regeneratorContext.t0 = RegeneratorRuntime.keys(cloudDictKeysList)
        case 52:
          if ((regeneratorContext.t1 = regeneratorContext.t0()).done) {
            regeneratorContext.next = 58
            break
          }
          regeneratorContext$t1$value = regeneratorContext.t1.value
          regeneratorContext.next = 56
          return ReduxSagaEffects.e(Actions.Jj(Number(regeneratorContext$t1$value), cloudDictKeysList[regeneratorContext$t1$value]))
        case 56:
          regeneratorContext.next = 52
          break
        case 58:
          if (!cloudTableColumnList) {
            regeneratorContext.next = 66
            break
          }
          regeneratorContext.t2 = RegeneratorRuntime.keys(cloudTableColumnList)
        case 60:
          if ((regeneratorContext.t3 = regeneratorContext.t2()).done) {
            regeneratorContext.next = 66
            break
          }
          regeneratorContext$t3$value = regeneratorContext.t3.value
          regeneratorContext.next = 64
          return ReduxSagaEffects.e(Actions.Mj(Number(regeneratorContext$t3$value), cloudTableColumnList[regeneratorContext$t3$value]))
        case 64:
          regeneratorContext.next = 60
          break
        case 66:
          if (!cloudTableDataList) {
            regeneratorContext.next = 74
            break
          }
          regeneratorContext.t4 = RegeneratorRuntime.keys(cloudTableDataList)
        case 68:
          if ((regeneratorContext.t5 = regeneratorContext.t4()).done) {
            regeneratorContext.next = 74
            break
          }
          regeneratorContext$t5$value = regeneratorContext.t5.value
          regeneratorContext.next = 72
          return ReduxSagaEffects.e(Actions.Nj(Number(regeneratorContext$t5$value), cloudTableDataList[regeneratorContext$t5$value]))
        case 72:
          regeneratorContext.next = 68
          break
        case 74:
          if (!cloudDictList) {
            regeneratorContext.next = 77
            break
          }
          regeneratorContext.next = 77
          return ReduxSagaEffects.e(Actions.Kj(cloudDictList))
        case 77:
          if (!cloudTableList) {
            regeneratorContext.next = 80
            break
          }
          regeneratorContext.next = 80
          return ReduxSagaEffects.e(Actions.Lj(cloudTableList))
        case 80:
        case "end":
          return regeneratorContext.stop()
      }
    }
  }, Di)
}

/**
 * [CoCo Next] 移除孤立的影子积木（Undefined 修复）
 */
function removeAloneShadowBlocks(blockly) {
  for (const { workspaceJson } of Object.values(blockly)) {
    const { blocks, connections, comments } = workspaceJson
    for (const [key, block] of Object.entries(blocks)) {
      if (block.is_shadow && block.parent_id == null) {
        delete blocks[key]
        delete connections[key]
        delete comments[key]
      }
    }
  }
}

function os(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$screenId
  var /* [auto-meaningful-name] */e$payload$isEmitOT
  var o
  var /* [auto-meaningful-name] */m$sent
  var a
  var s
  var /* [auto-meaningful-name] */m$sent1
  var /* [auto-meaningful-name] */_m$sent2
  var d
  var /* [auto-meaningful-name] */m$sent2
  var f
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$screen
  return RegeneratorRuntime.wrap(function (m) {
    for (;;) {
      switch (m.prev = m.next) {
        case 0:
          e$payload = e.payload
          e$payload$screenId = e$payload.screenId
          e$payload$isEmitOT = e$payload.isEmitOT
          o = undefined === e$payload$isEmitOT || e$payload$isEmitOT
          m.next = 3
          return ReduxSagaEffects.f(Module_22.C)
        case 3:
          m$sent = m.sent
          a = m$sent.findIndex(function (e) {
            return e.id === e$payload$screenId
          })
          s = m$sent.get(a)
          m.next = 8
          return ReduxSagaEffects.f(Module_22.x)
        case 8:
          m$sent1 = m.sent
          m.next = 11
          return ReduxSagaEffects.f(Module_22.f)
        case 11:
          if (_m$sent2 = m.sent, !(a > -1 && s && _m$sent2)) {
            m.next = 29
            break
          }
          Module_26.q(Module_26.c.SCREEN, e$payload$screenId)
          Module_26.z.removeWorkspaceByScreenId(e$payload$screenId)
          s.get("widgetIds").forEach(function (e) {
            return Module_9.F(e)
          })
          d = a < m$sent1 ? Math.max(m$sent1 - 1, 0) : Math.min(m$sent1, m$sent.size - 2)
          m.next = 19
          return ReduxSagaEffects.e(Actions.eh(e$payload$screenId))
        case 19:
          m.next = 21
          return ReduxSagaEffects.e(Actions.Bi(d))
        case 21:
          m.next = 23
          return ReduxSagaEffects.e(Actions.Fi(true))
        case 23:
          m.next = 25
          return ReduxSagaEffects.f(Module_22.C)
        case 25:
          m$sent2 = m.sent
          if ((f = m$sent2.get(d)) && f.id !== _m$sent2.id) {
            Module_26.z.selectWorkspaceByScreenId(f.id, false)
          }
          if (o) {
            if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$screen = oTHelper.screen) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$screen)) {
              $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$screen.clientOp.removeScreen(a, e$payload$screenId)
            }
          }
        case 29:
        case "end":
          return m.stop()
      }
    }
  }, Mi)
}
function is(e) {
  var /* [auto-meaningful-name] */e$payload$screenId
  var /* [auto-meaningful-name] */T$sent
  var r
  var o
  var /* [auto-meaningful-name] */_T$sent
  var s
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$screen
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$blink
  var d
  var p
  var f
  var h
  var m
  var g
  var _
  var v
  var b
  var y
  var E
  var O
  var w
  var C
  return RegeneratorRuntime.wrap(function (T) {
    for (;;) {
      switch (T.prev = T.next) {
        case 0:
          e$payload$screenId = e.payload.screenId
          T.next = 3
          return ReduxSagaEffects.f(Module_22.C)
        case 3:
          T$sent = T.sent
          r = T$sent.findIndex(function (e) {
            return e.id === e$payload$screenId
          })
          o = T$sent.get(r)
          T.next = 8
          return ReduxSagaEffects.f(Module_22.f)
        case 8:
          if (_T$sent = T.sent, s = r + 1, !o || !_T$sent) {
            T.next = 48
            break
          }
          d = Module_9.B(o.get("title"), T$sent)
          p = Module_9.A(d)
          f = o.get("widgetIds")
          h = Module_25.a(f)
          f.forEach(function (e) {
            Module_9.v(e, h)
          })
          p.widgetIds = h
          m = o.get("invisibleWidgetIds")
          g = Module_25.a(m)
          m.forEach(function (e) {
            Module_9.v(e, g)
          })
          p.invisibleWidgetIds = g
          _ = new Map()
          h.forEach(function (e, t) {
            _.set(f[t], e)
          })
          v = Lodash.cloneDeep(o.get("primitiveVariables"))
          b = new Map()
          v.forEach(function (e) {
            var t = Module_64.a("VARIABLE")
            b.set(e.id, t)
            e.id = t
          })
          p.primitiveVariables = v
          y = Lodash.cloneDeep(o.get("arrayVariables"))
          E = new Map()
          y.forEach(function (e) {
            var t = Module_64.a("VARIABLE")
            E.set(e.id, t)
            e.id = t
          })
          p.arrayVariables = y
          O = Lodash.cloneDeep(o.get("objectVariables"))
          w = new Map()
          O.forEach(function (e) {
            var t = Module_64.a("OBJECT")
            w.set(e.id, t)
            e.id = t
          })
          p.objectVariables = O
          p.snapshot = o.get("snapshot")
          p.backgroundColor = o.get("backgroundColor")
          C = Module_26.z.copyWorkspaceData(o.toJS().id, p.id, _, b, E, w)
          p.backgroundImage = o.get("backgroundImage")
          p.backgroundImageResizeMode = o.get("backgroundImageResizeMode")
          T.next = 42
          return ReduxSagaEffects.e(Actions.if(p, s))
        case 42:
          T.next = 44
          return ReduxSagaEffects.e(Actions.vg(s))
        case 44:
          T.next = 46
          return ReduxSagaEffects.e(Actions.Fi(true))
        case 46:
          if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$screen = oTHelper.screen) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$screen)) {
            $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$screen.clientOp.addScreen(p, s)
          }
          if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$blink = oTHelper.blink) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$blink)) {
            $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$blink.clientOp.addWorkspace(p.id, C)
          }
        case 48:
        case "end":
          return T.stop()
      }
    }
  }, Li)
}
function as(e, t) {
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$globalWidget
  return RegeneratorRuntime.wrap(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          if (e.type !== Widget_builtIn_types.y) {
            r.next = 5
            break
          }
          r.next = 3
          return ReduxSagaEffects.b(ss, e.id)
        case 3:
          r.next = 9
          break
        case 5:
          if (e.type !== Widget_builtIn_types.l) {
            r.next = 9
            break
          }
          if (!t) {
            r.next = 9
            break
          }
          r.next = 9
          return ReduxSagaEffects.b(Ut, e.attributes.cloudDbId)
        case 9:
          Module_9.F(e.id)
          Module_26.q(e.type, e.id)
          r.next = 13
          return ReduxSagaEffects.e(Actions.Lh(e.id))
        case 13:
          r.next = 15
          return ReduxSagaEffects.e(Actions.bh(e.id))
        case 15:
          if (t) {
            if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$globalWidget = oTHelper.globalWidget) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$globalWidget)) {
              $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$globalWidget.clientOp.del(e.id)
            }
          }
        case 16:
        case "end":
          return r.stop()
      }
    }
  }, Pi)
}
function ss(e) {
  var /* [auto-meaningful-name] */n$sent
  return RegeneratorRuntime.wrap(function (n) {
    for (;;) {
      switch (n.prev = n.next) {
        case 0:
          n.next = 2
          return ReduxSagaEffects.f(Module_22.y)
        case 2:
          n$sent = n.sent
          Module_9.yb(e).forEach(function (e) {
            Module_26.q(Module_26.c.DOC_KEYS, e.id)
          })
          gn(n$sent)
        case 6:
        case "end":
          return n.stop()
      }
    }
  }, Bi)
}
function cs(e, t, n) {
  var /* [auto-meaningful-name] */e$type
  var o
  var a
  var s
  var l
  var u
  var d
  var /* [auto-meaningful-name] */d$value
  var f
  var h
  var m
  var g
  var /* [auto-meaningful-name] */g$value
  var v
  var b
  var /* [auto-meaningful-name] */b$widgetIds
  var E
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget
  var w
  var /* [auto-meaningful-name] */_$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget
  var /* [auto-meaningful-name] */_$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget2
  return RegeneratorRuntime.wrap(function (S) {
    for (;;) {
      switch (S.prev = S.next) {
        case 0:
          if (e$type = e.type, o = e.id, a = Module_9.Db(e$type), e$type !== Widget_builtIn_types.f) {
            S.next = 25
            break
          }
          s = e
          l = Module_25.a(s.widgetIds)
          u = Module_47.a(l)
          S.prev = 7
          u.s()
        case 9:
          if ((d = u.n()).done) {
            S.next = 15
            break
          }
          d$value = d.value
          S.next = 13
          return ReduxSagaEffects.e(asyncDeleteProjectWidgetAction(d$value, t, false))
        case 13:
          S.next = 9
          break
        case 15:
          S.next = 20
          break
        case 17:
          S.prev = 17
          S.t0 = S.catch(7)
          u.e(S.t0)
        case 20:
          S.prev = 20
          u.f()
          return S.finish(20)
        case 23:
          S.next = 48
          break
        case 25:
          if (e$type !== Widget_builtIn_types.x && e$type !== Widget_builtIn_types.A) {
            S.next = 47
            break
          }
          f = e
          h = Module_25.a(f.widgetIds)
          m = Module_47.a(h)
          S.prev = 29
          m.s()
        case 31:
          if ((g = m.n()).done) {
            S.next = 37
            break
          }
          g$value = g.value
          S.next = 35
          return ReduxSagaEffects.e(asyncDeleteProjectWidgetAction(g$value, t, false))
        case 35:
          S.next = 31
          break
        case 37:
          S.next = 42
          break
        case 39:
          S.prev = 39
          S.t1 = S.catch(29)
          m.e(S.t1)
        case 42:
          S.prev = 42
          m.f()
          return S.finish(42)
        case 45:
          S.next = 48
          break
        case 47:
          if (!(e$type !== Widget_builtIn_types.c && e$type !== Widget_builtIn_types.a)) {
            if ((v = null === e || undefined === e ? undefined : e.parentId) && Module_9.Bb(v)) {
              b = Module_9.Bb(v)
              b$widgetIds = b.widgetIds
              if ((E = b$widgetIds.indexOf(o)) > -1) {
                b$widgetIds.splice(E, 1)
                if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget = oTHelper.widget) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget)) {
                  $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget.clientOp.replaceWidgetAttributeOp(t, v, "widgetIds", b$widgetIds)
                }
              }
            }
            if (w = Module_215.b(o)) {
              Module_145.b(w, o)
            }
          }
        case 48:
          Module_9.F(e.id)
          S.next = 51
          return ReduxSagaEffects.e(Actions.Mh(t, o, null === a || undefined === a ? undefined : a.isInvisibleWidget))
        case 51:
          S.next = 53
          return ReduxSagaEffects.e(Actions.bh(o))
        case 53:
          if (n) {
            if (null === a || undefined === a ? undefined : a.isInvisibleWidget) {
              if (!(null === (_$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget = oTHelper.widget) || undefined === _$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget)) {
                _$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget.clientOp.deleteInvisibleWidgetOp(t, o)
              }
            } else {
              if (!(null === (_$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget2 = oTHelper.widget) || undefined === _$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget2)) {
                _$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget2.clientOp.deleteWidgetOp(t, o)
              }
            }
          }
          Module_26.q(e$type, o)
          if (!("CANVAS_WIDGET" !== e$type && "ACTOR_WIDGET" !== e$type)) {
            Module_26.l()
          }
        case 56:
        case "end":
          return S.stop()
      }
    }
  }, Fi, null, [[7, 17, 20, 23], [29, 39, 42, 45]])
}
function ls(e) {
  var /* [auto-meaningful-name] */o$sent
  var /* [auto-meaningful-name] */_o$sent3
  var r
  return RegeneratorRuntime.wrap(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          o.next = 2
          return ReduxSagaEffects.f(Module_22.s)
        case 2:
          o$sent = o.sent
          o.next = 5
          return ReduxSagaEffects.f(Module_22.r)
        case 5:
          if (_o$sent3 = o.sent, r = true, e.type !== Widget_builtIn_types.l || _o$sent3) {
            o.next = 11
            break
          }
          o.next = 10
          return ReduxSagaEffects.e(Actions.showCommonToastInfoAction({
            type: "error",
            message: Language.c(o$sent, "notHavePermissionToDeleteCloudDb").toString()
          }))
        case 10:
          r = false
        case 11:
          return o.abrupt("return", r)
        case 12:
        case "end":
          return o.stop()
      }
    }
  }, Gi)
}
function us(e) {
  var /* [auto-meaningful-name] */o$sent
  var /* [auto-meaningful-name] */_o$sent4
  var r
  return RegeneratorRuntime.wrap(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          o.next = 2
          return ReduxSagaEffects.f(Module_22.s)
        case 2:
          o$sent = o.sent
          o.next = 5
          return ReduxSagaEffects.f(Module_22.r)
        case 5:
          if (_o$sent4 = o.sent, r = true, e.type !== Widget_builtIn_types.l) {
            o.next = 18
            break
          }
          if (!(Module_9.cb().length >= Module_305.f)) {
            o.next = 14
            break
          }
          o.next = 11
          return ReduxSagaEffects.e(Actions.showCommonToastInfoAction({
            type: "error",
            message: Language.c(o$sent, "cloudDbCountOverflowTitle").toString()
          }))
        case 11:
          r = false
          o.next = 18
          break
        case 14:
          if (_o$sent4) {
            o.next = 18
            break
          }
          o.next = 17
          return ReduxSagaEffects.e(Actions.showCommonToastInfoAction({
            type: "error",
            message: Language.c(o$sent, "notHavePermissionToAddCloudDb").toString()
          }))
        case 17:
          r = false
        case 18:
          return o.abrupt("return", r)
        case 19:
        case "end":
          return o.stop()
      }
    }
  }, Wi)
}
function ds(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$screenId
  var /* [auto-meaningful-name] */e$payload$widgetId
  var /* [auto-meaningful-name] */e$payload$isEmitOT
  var i
  var a
  var /* [auto-meaningful-name] */v$sent
  var /* [auto-meaningful-name] */_v$sent
  var /* [auto-meaningful-name] */a$attributes$cloudDbId
  var d
  var p
  var f
  var /* [auto-meaningful-name] */f$value
  var m
  var /* [auto-meaningful-name] */m$attributes$templateSlotMap
  var _
  return RegeneratorRuntime.wrap(function (v) {
    for (;;) {
      switch (v.prev = v.next) {
        case 0:
          e$payload = e.payload
          e$payload$screenId = e$payload.screenId
          e$payload$widgetId = e$payload.widgetId
          e$payload$isEmitOT = e$payload.isEmitOT
          i = undefined === e$payload$isEmitOT || e$payload$isEmitOT
          a = Module_9.Bb(e$payload$widgetId)
          v.next = 4
          return ReduxSagaEffects.f(Module_22.D)
        case 4:
          if (v$sent = v.sent, a) {
            v.next = 7
            break
          }
          return v.abrupt("return")
        case 7:
          if (!i) {
            v.next = 13
            break
          }
          v.next = 10
          return ReduxSagaEffects.b(ls, a)
        case 10:
          if (v.sent) {
            v.next = 13
            break
          }
          return v.abrupt("return")
        case 13:
          if (a.type !== Widget_builtIn_types.h) {
            v.next = 21
            break
          }
          v.next = 16
          return ReduxSagaEffects.f(Module_22.y)
        case 16:
          if (_v$sent = v.sent, !Module_97.a(_v$sent)) {
            v.next = 21
            break
          }
          a$attributes$cloudDbId = a.attributes.cloudDbId
          v.next = 21
          return ReduxSagaEffects.b(Module_147.d, a$attributes$cloudDbId, _v$sent)
        case 21:
          if (a.id === v$sent && e$payload$screenId && Module_26.g.setSelectedItemByWidgetId(e$payload$screenId), !a.isGlobalWidget) {
            v.next = 27
            break
          }
          v.next = 25
          return ReduxSagaEffects.b(as, a, i)
        case 25:
          v.next = 30
          break
        case 27:
          if (!e$payload$screenId || !a) {
            v.next = 30
            break
          }
          v.next = 30
          return ReduxSagaEffects.b(cs, a, e$payload$screenId, i)
        case 30:
          if (a.type !== Widget_builtIn_types.G) {
            v.next = 57
            break
          }
          d = Module_9.L(Widget_builtIn_types.A)
          p = Module_47.a(d)
          v.prev = 33
          p.s()
        case 35:
          if ((f = p.n()).done) {
            v.next = 47
            break
          }
          if (f$value = f.value, (null === (m = Module_9.Bb(f$value)) || undefined === m ? undefined : m.type) !== Widget_builtIn_types.A || m.attributes.dataSource !== e$payload$widgetId) {
            v.next = 45
            break
          }
          for (_ in m$attributes$templateSlotMap = m.attributes.templateSlotMap) m$attributes$templateSlotMap[_].dataBindings = ""
          v.next = 43
          return ReduxSagaEffects.e(Actions.Kg(f$value, "dataSource", ""))
        case 43:
          v.next = 45
          return ReduxSagaEffects.e(Actions.Kg(f$value, "templateSlotMap", m$attributes$templateSlotMap))
        case 45:
          v.next = 35
          break
        case 47:
          v.next = 52
          break
        case 49:
          v.prev = 49
          v.t0 = v.catch(33)
          p.e(v.t0)
        case 52:
          v.prev = 52
          p.f()
          return v.finish(52)
        case 55:
          v.next = 57
          return ReduxSagaEffects.e(Actions.Uj())
        case 57:
          v.next = 59
          return ReduxSagaEffects.e(Actions.Fi(true))
        case 59:
        case "end":
          return v.stop()
      }
    }
  }, Ui, null, [[33, 49, 52, 55]])
}
function ps(e, t, n) {
  var /* [auto-meaningful-name] */regeneratorContext$sent
  var /* [auto-meaningful-name] */regeneratorContext$sent1
  var s
  var c
  var /* [auto-meaningful-name] */c$attributes
  var u
  var d
  var /* [auto-meaningful-name] */regeneratorContext$sent2
  var f
  var h
  var /* [auto-meaningful-name] */s$contentTextField
  var g
  var _
  var v
  return RegeneratorRuntime.wrap(function (regeneratorContext) {
    for (;;) {
      switch (regeneratorContext.prev = regeneratorContext.next) {
        case 0:
          u = function (e) {
            return "string" === typeof e ? Language.f(regeneratorContext$sent, e) : (e.constructor !== Array && e.constructor !== Object || Object.entries(e).forEach(function (t) {
              var n = Module_11.a(t, 2)
              var r = n[0]
              var o = n[1]
              e[r] = u(o)
            }), e)
          }
          regeneratorContext.next = 3
          return ReduxSagaEffects.f(Module_22.s)
        case 3:
          regeneratorContext$sent = regeneratorContext.sent
          regeneratorContext.next = 6
          return ReduxSagaEffects.f(Module_22.n)
        case 6:
          if (regeneratorContext$sent1 = regeneratorContext.sent, s = Module_9.Db(e)) {
            regeneratorContext.next = 10
            break
          }
          return regeneratorContext.abrupt("return", null)
        case 10:
          if (c = Shared_tools.q(s.widget), c$attributes = c.attributes, s.isInvisibleWidget || undefined !== c.opacity || (c.opacity = 100), u(c$attributes), d = [], !s.widget.isGlobalWidget) {
            regeneratorContext.next = 19
            break
          }
          d = regeneratorContext$sent1
          regeneratorContext.next = 24
          break
        case 19:
          if (!n) {
            regeneratorContext.next = 24
            break
          }
          regeneratorContext.next = 22
          return ReduxSagaEffects.f(Module_22.H, n)
        case 22:
          if (regeneratorContext$sent2 = regeneratorContext.sent) {
            d = [].concat(Module_25.a(regeneratorContext$sent2.widgetIds), Module_25.a(regeneratorContext$sent2.invisibleWidgetIds))
          }
        case 24:
          f = s.title
          if (!!s.contentTextField && s.contentTextField) {
            s$contentTextField = s.contentTextField
            h = c$attributes[s$contentTextField]
            h = Module_9.D(e, d, h)
          } else {
            f = null === (g = Language.c(regeneratorContext$sent, s.title)) || undefined === g ? undefined : g.toString()
            f = Module_9.D(e, d, f)
          }
          _ = Module_64.a(e)
          v = Module_6.a(Module_6.a({
            animationRecord: {},
            size: {
              width: 10,
              height: 10
            }
          }, c), {}, {
            id: _,
            title: f,
            contentTitle: h,
            type: e,
            position: t,
            visible: true,
            attributes: c$attributes,
            isGlobalWidget: s.widget.isGlobalWidget
          })
          return regeneratorContext.abrupt("return", v)
        case 30:
        case "end":
          return regeneratorContext.stop()
      }
    }
  }, Hi)
}
function fs(e) {
  var /* [auto-meaningful-name] */n$sent
  return RegeneratorRuntime.wrap(function (n) {
    for (;;) {
      switch (n.prev = n.next) {
        case 0:
          n.next = 2
          return ReduxSagaEffects.b(Bt, e.title)
        case 2:
          n$sent = n.sent
          return n.abrupt("return", n$sent)
        case 4:
        case "end":
          return n.stop()
      }
    }
  }, Vi)
}
function hs(e, t) {
  var n
  var /* [auto-meaningful-name] */e$attributes$fields
  return RegeneratorRuntime.wrap(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          if (n = Module_9.Db(e.type)) {
            o.next = 3
            break
          }
          return o.abrupt("return")
        case 3:
          if (Module_9.Ub(e.id, e), !e.isGlobalWidget) {
            o.next = 9
            break
          }
          o.next = 7
          return ReduxSagaEffects.e(Actions.hf(e.id))
        case 7:
          o.next = 12
          break
        case 9:
          if (!t) {
            o.next = 12
            break
          }
          o.next = 12
          return ReduxSagaEffects.e(Actions.jf(t, e.id, n.isInvisibleWidget))
        case 12:
          if (e.type !== Widget_builtIn_types.B && e.type !== Widget_builtIn_types.y) {
            o.next = 18
            break
          }
          e$attributes$fields = e.attributes.fields
          o.next = 16
          return ReduxSagaEffects.e(Actions.bf(Module_110.a(e.type, {
            id: e.id,
            name: e.title,
            value: e$attributes$fields,
            defaultValue: "no-use"
          }, {
            isWatching: false
          })))
        case 16:
          o.next = 21
          break
        case 18:
          if (e.type !== Widget_builtIn_types.G) {
            o.next = 21
            break
          }
          o.next = 21
          return ReduxSagaEffects.e(Actions.bf(Module_110.a(Widget_builtIn_types.G, {
            id: e.id,
            name: e.title,
            value: e.attributes.db,
            defaultValue: "no-use"
          }, {
            isWatching: false
          })))
        case 21:
        case "end":
          return o.stop()
      }
    }
  }, zi)
}
function ms(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$screenId
  var /* [auto-meaningful-name] */e$payload$widgetType
  var /* [auto-meaningful-name] */e$payload$position
  var /* [auto-meaningful-name] */e$payload$attributes
  var /* [auto-meaningful-name] */e$payload$setBlockValue
  var s
  var /* [auto-meaningful-name] */v$sent
  var /* [auto-meaningful-name] */_v$sent2
  var /* [auto-meaningful-name] */v$sent1
  var /* [auto-meaningful-name] */_v$sent4
  var /* [auto-meaningful-name] */_v$sent5
  var /* [auto-meaningful-name] */v$sent2
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$globalWidget
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget
  var /* [auto-meaningful-name] */_$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget3
  return RegeneratorRuntime.wrap(function (v) {
    for (;;) {
      switch (v.prev = v.next) {
        case 0:
          e$payload = e.payload
          e$payload$screenId = e$payload.screenId
          e$payload$widgetType = e$payload.widgetType
          e$payload$position = e$payload.position
          e$payload$attributes = e$payload.attributes
          e$payload$setBlockValue = e$payload.setBlockValue
          s = Module_9.Db(e$payload$widgetType)
          v.next = 4
          return ReduxSagaEffects.b(ps, e$payload$widgetType, e$payload$position, e$payload$screenId)
        case 4:
          if ((v$sent = v.sent) && s) {
            v.next = 8
            break
          }
          console.error("Can not create widget")
          return v.abrupt("return")
        case 8:
          v.next = 10
          return ReduxSagaEffects.b(us, v$sent)
        case 10:
          if (v.sent) {
            v.next = 13
            break
          }
          return v.abrupt("return")
        case 13:
          v.next = 15
          return ReduxSagaEffects.f(Module_22.J)
        case 15:
          if (_v$sent2 = v.sent, v$sent.type !== Widget_builtIn_types.DATE_PICKER_WIDGET && v$sent.type !== Widget_builtIn_types.TIME_PICKER_WIDGET) {
            v.next = 20
            break
          }
          v$sent.attributes.timeStamp = Date.now()
          v.next = 68
          break
        case 20:
          if (v$sent.type !== Widget_builtIn_types.CLOUD_STORAGE_WIDGET) {
            v.next = 30
            break
          }
          if (_v$sent2) {
            v.next = 25
            break
          }
          v.next = 24
          return ReduxSagaEffects.e(Actions.openSignInDialogAction())
        case 24:
          return v.abrupt("return")
        case 25:
          v.next = 27
          return ReduxSagaEffects.b(fs, v$sent)
        case 27:
          v$sent.attributes.cloudDbId = v.sent
          v.next = 68
          break
        case 30:
          if (v$sent.type !== Widget_builtIn_types.x && v$sent.type !== Widget_builtIn_types.A) {
            v.next = 38
            break
          }
          v.next = 33
          return ReduxSagaEffects.b(_s, e$payload$screenId, v$sent.id, v$sent.attributes.templateType)
        case 33:
          v$sent1 = v.sent
          v$sent.widgetIds = v$sent1.widgetIds
          v$sent.attributes.templateSlotMap = v$sent1.templateSlotMap
          v.next = 68
          break
        case 38:
          if (v$sent.type !== Widget_builtIn_types.m) {
            v.next = 42
            break
          }
          if (e$payload$attributes) {
            if (Lodash.isString(e$payload$attributes.name)) {
              v$sent.title = e$payload$attributes.name
            }
            if (e$payload$attributes.header) {
              v$sent.attributes.db.header = e$payload$attributes.header
            }
            if (e$payload$attributes.data) {
              v$sent.attributes.db.data = e$payload$attributes.data
            }
          }
          v.next = 68
          break
        case 42:
          if (v$sent.type !== Widget_builtIn_types.h) {
            v.next = 67
            break
          }
          v.next = 45
          return ReduxSagaEffects.f(Module_22.y)
        case 45:
          if (_v$sent4 = v.sent, _v$sent2) {
            v.next = 50
            break
          }
          v.next = 49
          return ReduxSagaEffects.e(Actions.openSignInDialogAction())
        case 49:
          return v.abrupt("return")
        case 50:
          if (e$payload$attributes && (v$sent.attributes.cloudDbId = e$payload$attributes.cloudDbId, v$sent.attributes.name = e$payload$attributes.name, v$sent.attributes.columns = e$payload$attributes.columns, v$sent.attributes.primaryKey = e$payload$attributes.primaryKey), "_EMPTY_CLOUD_DB_ID_" !== v$sent.attributes.cloudDbId) {
            v.next = 64
            break
          }
          v.next = 54
          return ReduxSagaEffects.f(Module_22.s)
        case 54:
          _v$sent5 = v.sent
          v.next = 57
          return ReduxSagaEffects.b(Module_147.b, Language.c(_v$sent5, "cloudDb.defaultName").toString(), Module_97.a(_v$sent4) ? _v$sent4 : "")
        case 57:
          if ((v$sent2 = v.sent).id) {
            v.next = 62
            break
          }
          v.next = 61
          return ReduxSagaEffects.e(Actions.showCommonToastInfoAction({
            type: "error",
            message: Language.c(_v$sent5, "cloudDBWidget.generateError").toString()
          }))
        case 61:
          return v.abrupt("return")
        case 62:
          v$sent.attributes.cloudDbId = v$sent2.id
          v$sent.attributes.name = v$sent2.name
        case 64:
          v$sent.title = v$sent.attributes.name
          v.next = 68
          break
        case 67:
          if (v$sent.type === Widget_builtIn_types.G) {
            v$sent.attributes.db = Module_410.d()
          }
        case 68:
          v.next = 70
          return ReduxSagaEffects.b(hs, v$sent, e$payload$screenId)
        case 70:
          if (e$payload$setBlockValue) {
            e$payload$setBlockValue(v$sent.id)
          }
          if (v$sent.isGlobalWidget) {
            oTHelper.globalWidget?.clientOp.add(v$sent)
          } else {
            if (e$payload$screenId) {
              if (s.isInvisibleWidget) {
                if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget = oTHelper.widget) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget)) {
                  $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget.clientOp.addInvisibleWidgetOp(e$payload$screenId, v$sent)
                }
              } else {
                if (!(null === (_$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget3 = oTHelper.widget) || undefined === _$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget3)) {
                  _$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget3.clientOp.addWidgetOp(e$payload$screenId, v$sent)
                }
              }
            }
          }
          v.next = 74
          return ReduxSagaEffects.e(Actions.Fi(true))
        case 74:
          if (v$sent.type === Widget_builtIn_types.m) {
            v.next = 79
            break
          }
          v.next = 77
          return ReduxSagaEffects.b(vs, v$sent)
        case 77:
          v.next = 79
          return ReduxSagaEffects.e(Actions.ug(v$sent.id))
        case 79:
          v.next = 81
          return ReduxSagaEffects.b(bs, e$payload$screenId, v$sent)
        case 81:
          CustomWidgetShop.a(v$sent.type, null === _v$sent2 || undefined === _v$sent2 ? undefined : _v$sent2.id)
          return v.abrupt("return", v$sent)
        case 83:
        case "end":
          return v.stop()
      }
    }
  }, Yi)
}
function gs(e) {
  var /* [auto-meaningful-name] */e$payload$widgetType
  var /* [auto-meaningful-name] */l$sent
  var r
  var /* [auto-meaningful-name] */_l$sent
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$extensionWidget
  var a
  var s
  return RegeneratorRuntime.wrap(function (l) {
    for (;;) {
      switch (l.prev = l.next) {
        case 0:
          if (e$payload$widgetType = e.payload.widgetType, Module_9.Db(e$payload$widgetType)) {
            l.next = 17
            break
          }
          l.next = 4
          return ReduxSagaEffects.f(Module_22.t)
        case 4:
          if (l$sent = l.sent, !(r = l$sent.find(function (e) {
            return CustomWidgetType.standardize(e.type, true) === e$payload$widgetType
          }))) {
            l.next = 11
            break
          }
          l.next = 9
          return ReduxSagaEffects.b(LoadCustomWidget.u, r.cdnUrl, r.id)
        case 9:
          l.next = 16
          break
        case 11:
          l.next = 13
          return ReduxSagaEffects.f(Module_22.s)
        case 13:
          _l$sent = l.sent
          l.next = 16
          return ReduxSagaEffects.e(Actions.showCommonToastInfoAction({
            type: "error",
            message: Language.c(_l$sent, "WidgetList.addFailureToast").toString()
          }))
        case 16:
          if (CustomWidgetType.isSafeExtensions(e$payload$widgetType)) {
            a = CustomWidgetStorage.f(e$payload$widgetType)
            s = {
              id: a.id,
              cdnUrl: a.cdnUrl,
              type: a.type
            }
            if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$extensionWidget = oTHelper.extensionWidget) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$extensionWidget)) {
              $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$extensionWidget.clientOp.addMallExtensionWidget(s)
            }
          }
        case 17:
        case "end":
          return l.stop()
      }
    }
  }, Ki)
}
function _s(e, t, n) {
  var /* [auto-meaningful-name] */f$sent
  var o
  var i
  var s
  var /* [auto-meaningful-name] */f$t1$value
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget
  var u
  var d
  var /* [auto-meaningful-name] */_f$sent
  return RegeneratorRuntime.wrap(function (f) {
    for (;;) {
      switch (f.prev = f.next) {
        case 0:
          f.next = 2
          return ReduxSagaEffects.f(Module_22.s)
        case 2:
          f$sent = f.sent
          o = Module_127.n[n]
          i = []
          s = {}
          f.t0 = RegeneratorRuntime.keys(o)
        case 7:
          if ((f.t1 = f.t0()).done) {
            f.next = 28
            break
          }
          f$t1$value = f.t1.value
          u = o[f$t1$value]
          d = Module_9.Db(u.widgetType)
          f.next = 13
          return ReduxSagaEffects.b(ps, u.widgetType, {
            x: 0,
            y: 0
          }, e)
        case 13:
          if ((_f$sent = f.sent) && d) {
            f.next = 17
            break
          }
          console.error("can not create widget")
          return f.abrupt("return")
        case 17:
          _f$sent.parentId = t
          _f$sent.title = Language.c(f$sent, u.titleMessageId).toString()
          _f$sent.attributes = Module_6.a(Module_6.a({}, _f$sent.attributes), u.attributes)
          if (_f$sent.type === Widget_builtIn_types.H) {
            _f$sent.attributes.content = Language.c(f$sent, u.contentMessageId || "").toString()
            _f$sent.attributes.textAlign = "left"
          }
          f.next = 23
          return ReduxSagaEffects.b(hs, _f$sent, e)
        case 23:
          s[f$t1$value] = {
            label: _f$sent.title,
            widgetId: _f$sent.id,
            dataBindings: ""
          }
          i.push(_f$sent.id)
          if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget = oTHelper.widget) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget)) {
            $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget.clientOp.addWidgetOp(e, _f$sent)
          }
          f.next = 7
          break
        case 28:
          return f.abrupt("return", {
            widgetIds: i,
            templateSlotMap: s
          })
        case 29:
        case "end":
          return f.stop()
      }
    }
  }, qi)
}
function vs(e) {
  var /* [auto-meaningful-name] */a$sent
  var n
  var r
  var o
  var i
  return RegeneratorRuntime.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          a.next = 2
          return ReduxSagaEffects.f(Module_22.s)
        case 2:
          if (a$sent = a.sent, n = Module_9.Db(e.type)) {
            a.next = 6
            break
          }
          return a.abrupt("return")
        case 6:
          if (!n.isInvisibleWidget) {
            a.next = 11
            break
          }
          o = null === (r = Language.c(a$sent, n.title)) || undefined === r ? undefined : r.toString()
          i = Language.c(a$sent, "WidgetList.addSuccessToast", {
            widgetTitle: o
          }).toString()
          a.next = 11
          return ReduxSagaEffects.e(Actions.xj("".concat(i), true))
        case 11:
        case "end":
          return a.stop()
      }
    }
  }, Xi)
}
function bs(e, t) {
  var n
  var /* [auto-meaningful-name] */c$sent
  var o
  var /* [auto-meaningful-name] */_c$sent
  var /* [auto-meaningful-name] */_c$sent2
  var s
  return RegeneratorRuntime.wrap(function (c) {
    for (;;) {
      switch (c.prev = c.next) {
        case 0:
          c.next = 2
          return ReduxSagaEffects.f(Module_22.s)
        case 2:
          if (c$sent = c.sent, o = Module_9.Db(t.type)) {
            c.next = 6
            break
          }
          return c.abrupt("return")
        case 6:
          c.next = 8
          return ReduxSagaEffects.f(Module_22.f)
        case 8:
          _c$sent = c.sent
          c.next = 11
          return ReduxSagaEffects.f(Module_22.u)
        case 11:
          _c$sent2 = c.sent
          s = null === (n = Language.c(c$sent, o.previewAreaWidgetTitle)) || undefined === n ? undefined : n.toString()
          Module_141.a("AddWidgetToStage", {
            screenId: e,
            screenName: (null === _c$sent || undefined === _c$sent ? undefined : _c$sent.title) || "",
            isCooperation: !!_c$sent2,
            widgetName: s
          })
        case 14:
        case "end":
          return c.stop()
      }
    }
  }, Qi)
}
function ys(e) {
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget
  var /* [auto-meaningful-name] */_$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget4
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$widgetId
  var /* [auto-meaningful-name] */e$payload$templateType
  var /* [auto-meaningful-name] */e$payload$onSuccess
  var s
  var /* [auto-meaningful-name] */h$sent
  var u
  var d
  var /* [auto-meaningful-name] */d$value
  var /* [auto-meaningful-name] */_h$sent
  return RegeneratorRuntime.wrap(function (h) {
    for (;;) {
      switch (h.prev = h.next) {
        case 0:
          e$payload = e.payload
          e$payload$widgetId = e$payload.widgetId
          e$payload$templateType = e$payload.templateType
          e$payload$onSuccess = e$payload.onSuccess
          s = Module_9.Bb(e$payload$widgetId)
          h.next = 4
          return ReduxSagaEffects.f(Module_22.g)
        case 4:
          if (h$sent = h.sent, s && h$sent) {
            h.next = 7
            break
          }
          return h.abrupt("return")
        case 7:
          if (s.type === Widget_builtIn_types.x || s.type === Widget_builtIn_types.A) {
            h.next = 9
            break
          }
          return h.abrupt("return")
        case 9:
          u = Module_47.a(s.widgetIds)
          h.prev = 10
          u.s()
        case 12:
          if ((d = u.n()).done) {
            h.next = 18
            break
          }
          d$value = d.value
          h.next = 16
          return ReduxSagaEffects.e(asyncDeleteProjectWidgetAction(d$value, h$sent, true))
        case 16:
          h.next = 12
          break
        case 18:
          h.next = 23
          break
        case 20:
          h.prev = 20
          h.t0 = h.catch(10)
          u.e(h.t0)
        case 23:
          h.prev = 23
          u.f()
          return h.finish(23)
        case 26:
          Module_26.t(e$payload$widgetId)
          h.next = 29
          return ReduxSagaEffects.b(_s, h$sent, e$payload$widgetId, e$payload$templateType)
        case 29:
          _h$sent = h.sent
          Module_9.Wb(e$payload$widgetId, _h$sent.widgetIds)
          h.next = 33
          return ReduxSagaEffects.e(Actions.Kg(e$payload$widgetId, "templateSlotMap", _h$sent.templateSlotMap))
        case 33:
          if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget = oTHelper.widget) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget)) {
            $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget.clientOp.replaceWidgetAttributeOp(h$sent, e$payload$widgetId, "widgetIds", _h$sent.widgetIds)
          }
          if (!(null === (_$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget4 = oTHelper.widget) || undefined === _$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget4)) {
            _$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget4.clientOp.replaceWidgetAttributeOp(h$sent, e$payload$widgetId, "templateSlotMap", _h$sent.templateSlotMap)
          }
          e$payload$onSuccess()
        case 36:
        case "end":
          return h.stop()
      }
    }
  }, Zi, null, [[10, 20, 23, 26]])
}
function Es(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$gridId
  var /* [auto-meaningful-name] */e$payload$deleteColumnIdList
  var /* [auto-meaningful-name] */m$sent
  var /* [auto-meaningful-name] */m$sent$id
  var a
  var s
  var /* [auto-meaningful-name] */s$value
  var u
  var d
  var /* [auto-meaningful-name] */u$attributes$templateSlotMap
  var f
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget
  return RegeneratorRuntime.wrap(function (m) {
    for (;;) {
      switch (m.prev = m.next) {
        case 0:
          e$payload = e.payload
          e$payload$gridId = e$payload.gridId
          e$payload$deleteColumnIdList = e$payload.deleteColumnIdList
          m.next = 3
          return ReduxSagaEffects.f(Module_22.f)
        case 3:
          if (m$sent = m.sent) {
            m.next = 6
            break
          }
          return m.abrupt("return")
        case 6:
          m$sent$id = m$sent.id
          a = Module_47.a(m$sent.widgetIds)
          m.prev = 8
          a.s()
        case 10:
          if ((s = a.n()).done) {
            m.next = 23
            break
          }
          if (s$value = s.value, (null === (u = Module_9.Bb(s$value)) || undefined === u ? undefined : u.type) !== Widget_builtIn_types.x && (null === u || undefined === u ? undefined : u.type) !== Widget_builtIn_types.A || u.attributes.dataSource !== e$payload$gridId) {
            m.next = 21
            break
          }
          for (f in d = false, u$attributes$templateSlotMap = u.attributes.templateSlotMap) if (e$payload$deleteColumnIdList.includes(u$attributes$templateSlotMap[f].dataBindings)) {
            u$attributes$templateSlotMap[f].dataBindings = ""
            d = true
          }
          if (!d) {
            m.next = 21
            break
          }
          m.next = 20
          return ReduxSagaEffects.e(Actions.Kg(s$value, "templateSlotMap", u$attributes$templateSlotMap))
        case 20:
          if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget = oTHelper.widget) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget)) {
            $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget.clientOp.replaceWidgetAttributeOp(m$sent$id, s$value, "templateSlotMap", u$attributes$templateSlotMap)
          }
        case 21:
          m.next = 10
          break
        case 23:
          m.next = 28
          break
        case 25:
          m.prev = 25
          m.t0 = m.catch(8)
          a.e(m.t0)
        case 28:
          m.prev = 28
          a.f()
          return m.finish(28)
        case 31:
        case "end":
          return m.stop()
      }
    }
  }, Ji, null, [[8, 25, 28, 31]])
}
function migrateCloudDb() {
  return ws.apply(this, arguments)
}
function ws() {
  return (ws = Module_7.a(RegeneratorRuntime.mark(function e() {
    var t
    var /* [auto-meaningful-name] */e$sent
    var /* [auto-meaningful-name] */store$getState$common$language
    return RegeneratorRuntime.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (!(t = Module_9.Y().map(function (e) {
              return e.attributes.cloudDbId
            })).length) {
              e.next = 6
              break
            }
            e.next = 4
            return Module_147.j(t)
          case 4:
            if (e$sent = e.sent) {
              store$getState$common$language = store.getState().common.language
              store.dispatch(Actions.showCommonToastInfoAction({
                type: "error",
                duration: 4e3,
                message: Language.c(store$getState$common$language, e$sent).toString()
              }))
            }
          case 6:
          case "end":
            return e.stop()
        }
      }
    }, e)
  }))).apply(this, arguments)
}
function Cs() {
  var /* [auto-meaningful-name] */a$sent
  var /* [auto-meaningful-name] */_a$sent2
  var /* [auto-meaningful-name] */_a$sent3
  var r
  var /* [auto-meaningful-name] */_a$sent4
  var /* [auto-meaningful-name] */_a$sent5
  return RegeneratorRuntime.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          a.next = 2
          return ReduxSagaEffects.f(Module_22.y)
        case 2:
          a$sent = a.sent
          a.next = 5
          return ReduxSagaEffects.b(function () {
            return generatePlayerData(false)
          })
        case 5:
          _a$sent2 = a.sent
          a.next = 8
          return ReduxSagaEffects.f(Module_22.J)
        case 8:
          if (_a$sent3 = a.sent, _a$sent2) {
            a.next = 11
            break
          }
          return a.abrupt("return")
        case 11:
          if (_a$sent3) {
            a.next = 15
            break
          }
          a.next = 14
          return ReduxSagaEffects.e(Actions.openSignInDialogAction())
        case 14:
          return a.abrupt("return")
        case 15:
          a.prev = 15
          r = Module_9.cb()
          a.next = 19
          return ReduxSagaEffects.f(Module_22.A)
        case 19:
          _a$sent4 = a.sent
          a.next = 22
          return ReduxSagaEffects.b(Module_177.l, _a$sent4, _a$sent2)
        case 22:
          _a$sent5 = a.sent
          a.next = 25
          return ReduxSagaEffects.e(Actions.Ni(_a$sent5.pack_label))
        case 25:
          a.next = 27
          return ReduxSagaEffects.e(Actions.Ig())
        case 27:
          migrateCloudDict(r.map(function (e) {
            return e.attributes.cloudDbId
          }), 2, 1, Module_97.a(a$sent) ? a$sent : undefined)
          a.next = 30
          return migrateCloudDb()
        case 30:
          a.next = 38
          break
        case 32:
          a.prev = 32
          a.t0 = a.catch(15)
          a.next = 36
          return ReduxSagaEffects.e(Actions.Ki(-1))
        case 36:
          a.next = 38
          return ReduxSagaEffects.b(As, a.t0.message)
        case 38:
        case "end":
          return a.stop()
      }
    }
  }, $i, null, [[15, 32]])
}

/**
 * 生成用于 Player 运行的数据
 *
 * @param isPlayCurrentScreen 是否从当前屏幕开始运行
 * @param debug [存疑] 是否是调试模式
 * @returns 用于 Player 运行的数据
 */
function* generatePlayerData(isPlayCurrentScreen: boolean, debug?: boolean) {
  var _
  let id = yield ReduxSagaEffects.f(Module_22.y)
  const language = yield ReduxSagaEffects.f(Module_22.s)
  const screens = yield ReduxSagaEffects.f(Module_22.C)
  const globalVariableList = yield ReduxSagaEffects.f(Module_22.m)
  const globalArrayList = yield ReduxSagaEffects.f(Module_22.k)
  const globalObjectList = yield ReduxSagaEffects.f(Module_22.l)
  const globalWidgetIds = yield ReduxSagaEffects.f(Module_22.n)
  const currentScreen = yield ReduxSagaEffects.f(Module_22.f)
  let apiToken = yield ReduxSagaEffects.f(Module_22.v)
  if (!currentScreen) {
    return
  }
  Module_26.z.updateCurrentWorkspaceData()
  const hasCloudRoomBlock = Module_26.z.hasCloudBlock("cloudRoom")
  const hasCloudStorageBlock = Module_26.z.hasCloudBlock("cloudStorage")
  const hasCloudDbBlock = Module_26.z.hasCloudBlock("cloudDB")
  const hasCloudDictBlock = Module_26.z.hasCloudBlock("cloudDict")
  const hasBlockTableBlock = Module_26.z.hasCloudBlock("cloudTable")
  _ = Module_9.q()
  if (
    hasCloudRoomBlock ||
    hasCloudDbBlock ||
    hasCloudStorageBlock ||
    hasCloudDictBlock ||
    hasBlockTableBlock ||
    _
  ) {
    if (!Module_97.a(id)) {
      yield ReduxSagaEffects.e(Actions.showCommonToastInfoAction({
        duration: 4000,
        showPrefixIcon: false,
        message: Language.c(language, "project.saving").toString()
      }))
      id = yield ReduxSagaEffects.b(Ws, Actions.asyncSaveProjectAction({
        isUpdate: false,
        isAutoSave: true
      }))
    }
    if (!apiToken) {
      yield ReduxSagaEffects.b(Vs)
      apiToken = yield ReduxSagaEffects.f(Module_22.v)
    }
  }
  const initialScreenId = isPlayCurrentScreen ? currentScreen.id : screens.toArray()[0].id
  const soundFileMap = yield getSoundFileMap()
  const iconFileMap = yield getIconFileMap()
  const fontFileMap = yield getFontFileMap()
  const result = Module_177.c(
    id,
    Module_26.z,
    screens.toArray(),
    globalVariableList,
    globalArrayList,
    Module_9.kb(),
    soundFileMap,
    iconFileMap,
    initialScreenId,
    apiToken,
    globalWidgetIds,
    globalObjectList
  )
  // [CoCo Next] 绕审核
  if (!debug && result.unsafeExtensionWidgetList?.length) {
    result.bypassAudit = {
      unsafeExtensionWidgetList: result.unsafeExtensionWidgetList
    }
    result.unsafeExtensionWidgetList = []
  }
  result.fontFileMap = fontFileMap
  result.blockCode = Module_26.z.generateAllWorkspaceCodes(result.screenList, debug)
  const minifyResult = Terser.minify(result.blockCode, { keep_fnames: true })
  if (minifyResult.code !== undefined) {
    result.blockCode = minifyResult.code
  }
  return result
}

function Ss() {
  var /* [auto-meaningful-name] */l$sent
  var t
  var /* [auto-meaningful-name] */l$sent1
  var /* [auto-meaningful-name] */l$sent2
  var /* [auto-meaningful-name] */_l$sent3$url
  var /* [auto-meaningful-name] */_l$sent3$version
  var /* [auto-meaningful-name] */_l$sent3$expireTime
  var s
  return RegeneratorRuntime.wrap(function (l) {
    for (;;) {
      switch (l.prev = l.next) {
        case 0:
          l.next = 2
          return ReduxSagaEffects.f(Module_22.B)
        case 2:
          l$sent = l.sent
          l.next = 5
          return ReduxSagaEffects.e(Actions.Oi(true))
        case 5:
          l.next = 7
          return ReduxSagaEffects.e(Actions.Ii(false))
        case 7:
          l.next = 9
          return ReduxSagaEffects.e(Actions.Ki(0))
        case 9:
          t = 0
          l.prev = 10
        case 11:
          if (!(t < 100 && t >= 0 && l$sent)) {
            l.next = 22
            break
          }
          l.next = 14
          return ReduxSagaEffects.b(Module_177.a, l$sent)
        case 14:
          l$sent1 = l.sent
          t = l$sent1.progress
          l.next = 18
          return ReduxSagaEffects.e(Actions.Ki(t))
        case 18:
          l.next = 20
          return ReduxSagaEffects.c(1e3)
        case 20:
          l.next = 11
          break
        case 22:
          if (-1 !== t) {
            l.next = 27
            break
          }
          l.next = 25
          return ReduxSagaEffects.e(Actions.Oi(false))
        case 25:
          l.next = 27
          return ReduxSagaEffects.b(As, "-1")
        case 27:
          if (-2 !== t) {
            l.next = 32
            break
          }
          l.next = 30
          return ReduxSagaEffects.e(Actions.Oi(false))
        case 30:
          l.next = 32
          return ReduxSagaEffects.b(As, "取消打包")
        case 32:
          if (100 !== t) {
            l.next = 49
            break
          }
          l.next = 35
          return ReduxSagaEffects.b(Module_177.i, l$sent)
        case 35:
          l$sent2 = l.sent
          _l$sent3$url = l$sent2.url
          _l$sent3$version = l$sent2.version
          _l$sent3$expireTime = l$sent2.expireTime
          l.next = 41
          return ReduxSagaEffects.e(Actions.Oi(false, _l$sent3$url))
        case 41:
          l.next = 43
          return ReduxSagaEffects.e(Actions.Ji({
            version: _l$sent3$version,
            expireTime: _l$sent3$expireTime,
            startTimeTamp: Date.now()
          }))
        case 43:
          l.next = 45
          return ReduxSagaEffects.e(Actions.Mi(true))
        case 45:
          l.next = 47
          return ReduxSagaEffects.e(Actions.Li(false))
        case 47:
          l.next = 49
          return ReduxSagaEffects.b(As)
        case 49:
          l.next = 61
          break
        case 51:
          l.prev = 51
          l.t0 = l.catch(10)
          l.next = 55
          return ReduxSagaEffects.e(Actions.Ki(-1))
        case 55:
          l.next = 57
          return ReduxSagaEffects.e(Actions.Oi(false))
        case 57:
          s = l.t0
          console.error(l.t0)
          l.next = 61
          return ReduxSagaEffects.b(As, s.message)
        case 61:
        case "end":
          return l.stop()
      }
    }
  }, ta, null, [[10, 51]])
}
function As(e) {
  var /* [auto-meaningful-name] */a$sent
  var /* [auto-meaningful-name] */_a$sent6
  var /* [auto-meaningful-name] */_a$sent7
  var /* [auto-meaningful-name] */_a$sent8
  var i
  return RegeneratorRuntime.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          a.next = 2
          return ReduxSagaEffects.f(Module_22.y)
        case 2:
          a$sent = a.sent
          a.next = 5
          return ReduxSagaEffects.f(Module_22.F)
        case 5:
          _a$sent6 = a.sent
          a.next = 8
          return ReduxSagaEffects.f(Module_22.A)
        case 8:
          _a$sent7 = a.sent
          a.next = 11
          return ReduxSagaEffects.f(Module_22.w)
        case 11:
          _a$sent8 = a.sent
          i = _a$sent7.apkSplash.match(/splash0(\d)\.png/)
          Module_141.a("WorkPack", {
            workId: a$sent,
            sourceTag: _a$sent6.tag,
            sourceId: _a$sent6.id,
            launchScreenId: i ? i[1] : "0",
            apkName: _a$sent7.apkName,
            isSuccess: !e,
            failReason: e || "",
            bcmUrl: e ? _a$sent8 : "",
            packLabel: e && _a$sent7.packLabel ? _a$sent7.packLabel : ""
          })
        case 14:
        case "end":
          return a.stop()
      }
    }
  }, na)
}
function Is(e) {
  var /* [auto-meaningful-name] */e$payload$isPlayCurrentScreen
  var /* [auto-meaningful-name] */f$sent
  var /* [auto-meaningful-name] */_f$sent2
  var /* [auto-meaningful-name] */_f$sent2$widgetMap
  var i
  var a
  var s
  var l
  var /* [auto-meaningful-name] */_f$sent3
  var p
  return RegeneratorRuntime.wrap(function (f) {
    for (;;) {
      switch (f.prev = f.next) {
        case 0:
          e$payload$isPlayCurrentScreen = e.payload.isPlayCurrentScreen
          f.next = 3
          return ReduxSagaEffects.f(Module_22.s)
        case 3:
          f$sent = f.sent
          f.next = 6
          return ReduxSagaEffects.e(Actions.Sg())
        case 6:
          f.prev = 6
          f.next = 9
          return ReduxSagaEffects.b(function () {
            return generatePlayerData(e$payload$isPlayCurrentScreen, true)
          })
        case 9:
          if (_f$sent2 = f.sent) {
            f.next = 12
            break
          }
          return f.abrupt("return")
        case 12:
          if (_f$sent2$widgetMap = _f$sent2.widgetMap, i = new Set(), a = new Set(), s = new Set(), l = true, Object.values(_f$sent2$widgetMap).forEach(function (e) {
            var /* [auto-meaningful-name] */o$types
            var /* [auto-meaningful-name] */e$type = e.type
            var o = CustomWidgetStorage.f(e$type)
            if (e$type.includes(CustomWidgetType.UNSAFE_EXTENSION_PREFIX) && o) {
              var c = o
              // [CoCo Next] 移除运行作品时的控件关键词检查
              // CustomWidgetRestrict.keyWords.forEach(function (e) {
              //   var /* [auto-meaningful-name] */c$code
              //   if (null === (c$code = c.code) || undefined === c$code ? undefined : c$code.includes(e)) {
              //     a.add(e)
              //     i.add(o.types.title)
              //   }
              // })
            }
            if (null === o || undefined === o || null === (o$types = o.types) || undefined === o$types ? undefined : o$types.platforms) {
              var d = o.types.platforms.includes("web")
              if (!d) {
                if (LoadCustomWidget.q(e$type)) {
                  s.add(o.types.title)
                } else {
                  var p = Module_9.Db(e$type)
                  if (p) {
                    var f = Language.c(f$sent, p.title)
                    s.add(f)
                  }
                }
                l = d
              }
            }
          }), !a.size) {
            f.next = 22
            break
          }
          f.next = 21
          return ReduxSagaEffects.e(Actions.openConfirmDialogAction({
            allowText: Language.c(f$sent, "cloudDb.know").toString(),
            title: "error",
            content: Language.c(f$sent, "Play.widgetNotSupportsForbiddenKeywords", {
              widgetTypeNames: Array.from(i).join("、"),
              keywords: Array.from(a).join("、")
            }).toString(),
            cancelBtnVisible: false
          }))
        case 21:
          return f.abrupt("return")
        case 22:
          if (l) {
            f.next = 25
            break
          }
          f.next = 25
          return ReduxSagaEffects.e(Actions.showCommonToastInfoAction({
            type: "info",
            duration: 4e3,
            message: Language.c(f$sent, "Play.widgetNotSupportsWebPlatform", {
              widgetTypeNames: Array.from(s).join("、")
            }).toString()
          }))
        case 25:
          f.next = 27
          return ReduxSagaEffects.f(Module_22.y)
        case 27:
          _f$sent3 = f.sent
          Module_26.z.stopWarningAnimation()
          f.next = 31
          return ReduxSagaEffects.b(Module_177.b, _f$sent3, _f$sent2)
        case 31:
          f.next = 33
          return ReduxSagaEffects.e(Actions.Cj())
        case 33:
          f.next = 35
          return ReduxSagaEffects.b(js, _f$sent2$widgetMap)
        case 35:
          Module_219.b({
            playing: true
          })
          f.next = 38
          return ReduxSagaEffects.b(Ns)
        case 38:
          f.next = 51
          break
        case 40:
          if (f.prev = 40, f.t0 = f.catch(6), !(f.t0 instanceof Module_139.b)) {
            f.next = 48
            break
          }
          p = {
            type: "lintError",
            screenId: f.t0.screenId,
            blockId: f.t0.blockId,
            message: Language.c(f$sent, f.t0.message, f.t0.data) + ""
          }
          f.next = 46
          return ReduxSagaEffects.e(Actions.nf(p))
        case 46:
          f.next = 48
          return ReduxSagaEffects.b(Rs, p)
        case 48:
          console.error(f.t0)
          f.next = 51
          return ReduxSagaEffects.b(Ns, f.t0.message)
        case 51:
        case "end":
          return f.stop()
      }
    }
  }, ra, null, [[6, 40]])
}
function js(e) {
  var /* [auto-meaningful-name] */p$sent
  var n
  var r
  var o
  var /* [auto-meaningful-name] */o$attributes
  var /* [auto-meaningful-name] */o$attributes$maxValue
  var /* [auto-meaningful-name] */o$attributes$minValue
  var /* [auto-meaningful-name] */o$attributes$step
  var u
  var d
  return RegeneratorRuntime.wrap(function (p) {
    for (;;) {
      switch (p.prev = p.next) {
        case 0:
          p.next = 2
          return ReduxSagaEffects.f(Module_22.s)
        case 2:
          p$sent = p.sent
          n = 0
          r = Object.values(e)
        case 4:
          if (!(n < r.length)) {
            p.next = 19
            break
          }
          if ((o = r[n]).type !== Widget_builtIn_types.E) {
            p.next = 16
            break
          }
          if (o$attributes = o.attributes, o$attributes$maxValue = o$attributes.maxValue, o$attributes$minValue = o$attributes.minValue, o$attributes$step = o$attributes.step, o$attributes$maxValue !== o$attributes$minValue) {
            p.next = 12
            break
          }
          u = {
            type: "warning",
            screenId: "",
            blockId: "",
            message: Language.c(p$sent, "slider.maxValueEqualMinValue", {
              title: o.title
            }).toString()
          }
          p.next = 12
          return ReduxSagaEffects.e(Actions.nf(u))
        case 12:
          if (!(o$attributes$step > o$attributes$maxValue - o$attributes$minValue)) {
            p.next = 16
            break
          }
          d = {
            type: "warning",
            screenId: "",
            blockId: "",
            message: Language.c(p$sent, "slider.stepGreaterThanRange", {
              title: o.title
            }).toString()
          }
          p.next = 16
          return ReduxSagaEffects.e(Actions.nf(d))
        case 16:
          n++
          p.next = 4
          break
        case 19:
        case "end":
          return p.stop()
      }
    }
  }, oa)
}
function Ns(e) {
  var /* [auto-meaningful-name] */r$sent
  var /* [auto-meaningful-name] */_r$sent
  return RegeneratorRuntime.wrap(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          r.next = 2
          return ReduxSagaEffects.f(Module_22.y)
        case 2:
          r$sent = r.sent
          r.next = 5
          return ReduxSagaEffects.f(Module_22.G)
        case 5:
          _r$sent = r.sent
          Module_141.a("WorkRun", {
            workId: r$sent,
            workName: _r$sent,
            workType: "APP工匠",
            isSuccess: !e,
            failReason: e || ""
          })
        case 7:
        case "end":
          return r.stop()
      }
    }
  }, ia)
}
function Rs(e) {
  var /* [auto-meaningful-name] */o$sent
  var n
  var /* [auto-meaningful-name] */o$sent$filterFunctionEReturnWarningE$getType$size
  return RegeneratorRuntime.wrap(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          o.next = 2
          return ReduxSagaEffects.f(Module_22.e)
        case 2:
          o$sent = o.sent
          n = o$sent.filter(function (e) {
            return "error" === e.get("type")
          }).size + o$sent.filter(function (e) {
            return "customError" === e.get("type")
          }).size
          o$sent$filterFunctionEReturnWarningE$getType$size = o$sent.filter(function (e) {
            return "warning" === e.get("type")
          }).size
          Module_141.a("ConsoleDetail", {
            errorCount: n,
            warningCount: o$sent$filterFunctionEReturnWarningE$getType$size,
            errorMessage: e.message,
            warningMessage: ""
          })
        case 6:
        case "end":
          return o.stop()
      }
    }
  }, aa)
}

function* handlePublishWorkToCommunity(action) {
  const playerData = yield ReduxSagaEffects.b(() => generatePlayerData(false))
  if (!playerData) {
    throw new Error("can not generate player data")
  }
  const workId = yield ReduxSagaEffects.f(Module_22.y)
  yield ReduxSagaEffects.b(Actions.Bf, action.payload.name)
  const blob = new Blob([JSON.stringify(playerData)], { type: "application/json,charset=utf-8;" })
  const file = new File([blob], "test.json", { type: blob.type })
  const uploadPlayerDataResult = yield ReduxSagaEffects.b(Module_197.e, file, "JSON")
  const { payload } = action
  const { name, description, operation, coverUrl } = payload
  const publishInfo = {
    name: name,
    description: description || Module_328.a,
    operation: operation || Module_328.b,
    coverUrl,
    workId,
    bcmcUrl: uploadPlayerDataResult.url,
    playerUrl: Shared_tools.getPlayerCommunityUrl(workId)
  }
  const publishResponse = yield ReduxSagaEffects.b(Module_177.m, publishInfo)
  if (publishResponse.code !== 200) {
    throw Error(`${publishResponse.code}`)
  }
  migrateCloudDict(
    Module_9.cb().map((e) => e.attributes.cloudDbId),
    2,
    1,
    Module_97.a(workId) ? workId : undefined
  )
  yield migrateCloudDb()
  return workId
}

function handlePublishWorkToH5(action) {
  var /* [auto-meaningful-name] */regeneratorContext$sent
  var n
  var /* [auto-meaningful-name] */_f$sent4
  var /* [auto-meaningful-name] */action$payload$info
  var /* [auto-meaningful-name] */_f$sent5
  var /* [auto-meaningful-name] */regeneratorContext$sent1
  var l
  var u
  var /* [auto-meaningful-name] */_f$sent7
  var /* [auto-meaningful-name] */_f$sent8
  return RegeneratorRuntime.wrap(function (regeneratorContext) {
    for (;;) {
      switch (regeneratorContext.prev = regeneratorContext.next) {
        case 0:
          regeneratorContext.next = 2
          return ReduxSagaEffects.f(Module_22.y)
        case 2:
          regeneratorContext$sent = regeneratorContext.sent
          n = Module_97.a(regeneratorContext$sent)
          regeneratorContext.next = 6
          return ReduxSagaEffects.b(Ws, Actions.asyncSaveProjectAction({
            isUpdate: n,
            isAutoSave: true
          }))
        case 6:
          _f$sent4 = regeneratorContext.sent
          action$payload$info = action.payload.info
          regeneratorContext.next = 10
          return ReduxSagaEffects.f(Module_22.J)
        case 10:
          _f$sent5 = regeneratorContext.sent
          regeneratorContext.next = 13
          return ReduxSagaEffects.b(function () {
            return generatePlayerData(false)
          })
        case 13:
          if (regeneratorContext$sent1 = regeneratorContext.sent) {
            regeneratorContext.next = 16
            break
          }
          throw new Error("can not generate player data")
        case 16:
          if (_f$sent5) {
            regeneratorContext.next = 18
            break
          }
          throw new Error("user not login")
        case 18:
          l = new Blob([
            JSON.stringify(Module_6.a(Module_6.a({}, regeneratorContext$sent1), {}, {
              userInfo: {
                name: _f$sent5.nickname,
                avatarUrl: _f$sent5.avatar_url
              },
              title: action$payload$info.title,
              description: action$payload$info.desc,
              coverUrl: action$payload$info.img
            }))
          ], {
            type: "application/json,charset=utf-8;"
          })
          u = new File([l], "test.json", {
            type: l.type
          })
          regeneratorContext.next = 22
          return ReduxSagaEffects.b(Module_197.e, u, "JSON")
        case 22:
          _f$sent7 = regeneratorContext.sent
          migrateCloudDict(Module_9.cb().map(function (e) {
            return e.attributes.cloudDbId
          }), 2, 1, Module_97.a(_f$sent4) ? _f$sent4 : undefined)
          regeneratorContext.next = 27
          return migrateCloudDb()
        case 27:
          regeneratorContext.next = 29
          return ReduxSagaEffects.b(Module_177.n, _f$sent4, _f$sent7.url)
        case 29:
          if (200 === (_f$sent8 = regeneratorContext.sent).code) {
            regeneratorContext.next = 32
            break
          }
          throw Error("".concat(_f$sent8.code))
        case 32:
          return regeneratorContext.abrupt("return", _f$sent4)
        case 33:
        case "end":
          return regeneratorContext.stop()
      }
    }
  }, ca)
}

function Ds(e) {
  var /* [auto-meaningful-name] */e$payload$shouldCloneCloud
  var /* [auto-meaningful-name] */a$sent
  var /* [auto-meaningful-name] */_a$sent9
  var /* [auto-meaningful-name] */a$sent1
  var i
  return RegeneratorRuntime.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          e$payload$shouldCloneCloud = e.payload.shouldCloneCloud
          a.next = 3
          return ReduxSagaEffects.f(Module_22.f)
        case 3:
          a$sent = a.sent
          a.next = 6
          return ReduxSagaEffects.f(Module_22.G)
        case 6:
          if (_a$sent9 = a.sent, !a$sent) {
            a.next = 13
            break
          }
          a.next = 10
          return ReduxSagaEffects.b(Module_97.b, e$payload$shouldCloneCloud)
        case 10:
          a$sent1 = a.sent
          i = new Blob([JSON.stringify(a$sent1)], {
            type: "application/json,charset=utf-8;"
          })
          Shared_tools.s(URL.createObjectURL(i), _a$sent9)
        case 13:
        case "end":
          return a.stop()
      }
    }
  }, la)
}
function Ms() {
  var /* [auto-meaningful-name] */t$sent
  return RegeneratorRuntime.wrap(function (t) {
    for (;;) {
      switch (t.prev = t.next) {
        case 0:
          t.next = 2
          return ReduxSagaEffects.f(Module_22.J)
        case 2:
          if (t$sent = t.sent, t.prev = 3, !t$sent) {
            t.next = 7
            break
          }
          t.next = 7
          return ReduxSagaEffects.b(Module_197.c, Module_9.jb(), function (e) {
            var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$imageFileList
            if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$imageFileList = oTHelper.imageFileList) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$imageFileList)) {
              $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$imageFileList.clientOp.replaceImageFileCdnUrl(e.id, e.cdnUrl)
            }
          })
        case 7:
          t.next = 13
          break
        case 9:
          t.prev = 9
          t.t0 = t.catch(3)
          t.t0
          Module_197.a
          throw t.t0
        case 13:
        case "end":
          return t.stop()
      }
    }
  }, ua, null, [[3, 9]])
}
function Ls(e, t) {
  return Ps.apply(this, arguments)
}
function Ps() {
  return (Ps = Module_7.a(RegeneratorRuntime.mark(function e(t, n) {
    var r
    var /* [auto-meaningful-name] */e$sent
    return RegeneratorRuntime.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (!n) {
              e.next = 12
              break
            }
            if (!(r = document.getElementById(t.id))) {
              e.next = 12
              break
            }
            e.prev = 3
            e.next = 6
            return Module_553.a(r, 1)
          case 6:
            t.snapshot = e.sent
            e.next = 12
            break
          case 9:
            e.prev = 9
            e.t0 = e.catch(3)
            console.error("uploadImageDataUrlToCdn htmlToImage error", e.t0)
          case 12:
            if (!t.snapshot.startsWith("http")) {
              e.next = 14
              break
            }
            return e.abrupt("return", Promise.resolve())
          case 14:
            e.prev = 14
            e.next = 17
            return Module_197.f(t.snapshot)
          case 17:
            e$sent = e.sent
            t.snapshot = e$sent
            e.next = 25
            break
          case 21:
            e.prev = 21
            e.t1 = e.catch(14)
            e.t1
            Module_197.a
            console.error("uploadImageDataUrlToCdn error", e.t1)
          case 25:
          case "end":
            return e.stop()
        }
      }
    }, e, null, [[3, 9], [14, 21]])
  }))).apply(this, arguments)
}
function getSoundFileMap() {
  var e
  var /* [auto-meaningful-name] */o$sent
  var n
  var r = arguments
  return RegeneratorRuntime.wrap(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          e = r.length > 0 && undefined !== r[0] && r[0]
          o.next = 3
          return ReduxSagaEffects.f(Module_22.I)
        case 3:
          o$sent = o.sent
          n = {}
          o$sent.forEach(function (t) {
            n[t.id] = Module_6.a(Module_6.a({}, t), {}, {
              cdnUrl: e && t.source || t.cdnUrl
            })
          })
          return o.abrupt("return", n)
        case 7:
        case "end":
          return o.stop()
      }
    }
  }, da)
}
function getIconFileMap() {
  var e
  var /* [auto-meaningful-name] */o$sent
  var n
  var r = arguments
  return RegeneratorRuntime.wrap(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          e = r.length > 0 && undefined !== r[0] && r[0]
          o.next = 3
          return ReduxSagaEffects.f(Module_22.o)
        case 3:
          o$sent = o.sent
          n = {}
          o$sent.forEach(function (t) {
            n[t.id] = Module_6.a(Module_6.a({}, t), {}, {
              cdnUrl: e && t.source || t.cdnUrl
            })
          })
          return o.abrupt("return", n)
        case 7:
        case "end":
          return o.stop()
      }
    }
  }, pa)
}
function getFontFileMap() {
  var /* [auto-meaningful-name] */o$sent
  var t
  var /* [auto-meaningful-name] */_o$sent5
  var r
  return RegeneratorRuntime.wrap(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          o.next = 2
          return ReduxSagaEffects.f(Module_22.j)
        case 2:
          o$sent = o.sent
          t = {}
          o.next = 6
          return ReduxSagaEffects.f(Module_22.C)
        case 6:
          _o$sent5 = o.sent
          r = {}
          o$sent.forEach(function (e) {
            t[e.id] = e
          })
          _o$sent5.forEach(function (e) {
            e.widgetIds.forEach(function (e) {
              var n = Module_9.Bb(e)
              if ((null === n || undefined === n ? undefined : n.type) === Widget_builtIn_types.H || (null === n || undefined === n ? undefined : n.type) === Widget_builtIn_types.z || (null === n || undefined === n ? undefined : n.type) === Widget_builtIn_types.w) {
                var o
                var /* [auto-meaningful-name] */n$attributes$fontFamily = n.attributes.fontFamily
                if (!r[n$attributes$fontFamily] && (null === (o = t[n$attributes$fontFamily]) || undefined === o ? undefined : o.cdnUrl)) {
                  r[n$attributes$fontFamily] = t[n$attributes$fontFamily]
                }
              }
              if (n && n.attributes && "EXTENSION_QUILL_RICH_TEXT_WIDGET" === n.type) {
                var /* [auto-meaningful-name] */n$attributes$content = n.attributes.content
                var s = undefined === n$attributes$content ? "" : n$attributes$content
                Module_375.a(s).forEach(function (e) {
                  var n
                  if (!r[e] && (null === (n = t[e]) || undefined === n ? undefined : n.cdnUrl)) {
                    r[e] = t[e]
                  }
                })
              }
            })
          })
          return o.abrupt("return", r)
        case 11:
        case "end":
          return o.stop()
      }
    }
  }, fa)
}
function Ws(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$isUpdate
  var /* [auto-meaningful-name] */e$payload$isNeedReport
  var /* [auto-meaningful-name] */e$payload$isAutoSave
  var /* [auto-meaningful-name] */e$payload$isSaveAs
  var /* [auto-meaningful-name] */A$sent
  var /* [auto-meaningful-name] */_A$sent
  var l
  var /* [auto-meaningful-name] */_A$sent2
  var /* [auto-meaningful-name] */A$sent1
  var p
  var f
  var h
  var m
  var g
  var _
  var v
  var b
  var /* [auto-meaningful-name] */b$value
  var /* [auto-meaningful-name] */b$value$snapshot
  var /* [auto-meaningful-name] */_A$sent4
  var /* [auto-meaningful-name] */_A$sent5
  var C
  var T
  var /* [auto-meaningful-name] */_A$sent6
  return RegeneratorRuntime.wrap(function (A) {
    for (;;) {
      switch (A.prev = A.next) {
        case 0:
          e$payload = e.payload
          e$payload$isUpdate = e$payload.isUpdate
          e$payload$isNeedReport = e$payload.isNeedReport
          e$payload$isAutoSave = e$payload.isAutoSave
          e$payload$isSaveAs = e$payload.isSaveAs
          A.next = 3
          return ReduxSagaEffects.f(Module_22.C)
        case 3:
          A$sent = A.sent
          A.next = 6
          return ReduxSagaEffects.f(Module_22.y)
        case 6:
          _A$sent = A.sent
          l = Math.ceil(10 * Math.random()) + 10
          A.next = 10
          return ReduxSagaEffects.f(Module_22.J)
        case 10:
          _A$sent2 = A.sent
          A.next = 13
          return ReduxSagaEffects.f(Module_22.F)
        case 13:
          A$sent1 = A.sent
          p = 20
          A.next = 17
          break
        case 17:
          if (_A$sent2) {
            A.next = 21
            break
          }
          A.next = 20
          return ReduxSagaEffects.e(Actions.openSignInDialogAction())
        case 20:
          return A.abrupt("return")
        case 21:
          []
          A.next = 24
          return ReduxSagaEffects.b(li, true)
        case 24:
          if (!(A.sent.length > 0)) {
            A.next = 27
            break
          }
          throw new Error(Module_276.a.CLOUD_SPACE_DATA_ERROR)
        case 27:
          A.next = 29
          return ReduxSagaEffects.f(Module_22.G)
        case 29:
          if (f = A.sent, !e$payload$isSaveAs) {
            A.next = 35
            break
          }
          "-副本"
          f += "-副本"
          A.next = 35
          return ReduxSagaEffects.e(Actions.Bf(f))
        case 35:
          A.next = 37
          return ReduxSagaEffects.e(Actions.Pi(l))
        case 37:
          A.next = 39
          return ReduxSagaEffects.e(Actions.Si(true))
        case 39:
          h = A$sent.map(function (e) {
            return e.toJS()
          }).toJS()
          m = h.map(function (e, t) {
            return Ls(e, 0 === t)
          })
          A.next = 43
          return Promise.all(m)
        case 43:
          g = h[0]
          _ = g.snapshot
          v = Module_47.a(h)
          A.prev = 46
          v.s()
        case 48:
          if ((b = v.n()).done) {
            A.next = 56
            break
          }
          if (b$value = b.value, !(b$value$snapshot = b$value.snapshot).startsWith("http")) {
            A.next = 54
            break
          }
          A.next = 54
          return ReduxSagaEffects.e(Actions.Xj(b$value.id, b$value$snapshot))
        case 54:
          A.next = 48
          break
        case 56:
          A.next = 61
          break
        case 58:
          A.prev = 58
          A.t0 = A.catch(46)
          v.e(A.t0)
        case 61:
          A.prev = 61
          v.f()
          return A.finish(61)
        case 64:
          if (!_.startsWith("http")) {
            _ = "https://creation.codemao.cn/716/appcraft/IMAGE_ssdp_AuDw_1645089354494.png"
          }
          A.next = 67
          return ReduxSagaEffects.b(Module_97.b)
        case 67:
          _A$sent4 = A.sent
          A.next = 70
          return ReduxSagaEffects.b(Module_297.h, JSON.stringify(_A$sent4))
        case 70:
          _A$sent5 = A.sent
          A.next = 73
          return ReduxSagaEffects.e(Actions.Vj(_A$sent5))
        case 73:
          A.next = 75
          return ReduxSagaEffects.e(Actions.Pi(50))
        case 75:
          if (!e$payload$isUpdate) {
            A.next = 106
            break
          }
          C = {
            name: f.substring(0, p),
            bcmUrl: _A$sent5,
            coverUrl: _,
            id: _A$sent,
            saveType: e$payload$isAutoSave ? Module_53.g.AutoSave : Module_53.g.ByUser
          }
          A.prev = 77
          A.next = 80
          return ReduxSagaEffects.b(Module_297.g, C)
        case 80:
          if (!e$payload$isNeedReport) {
            A.next = 83
            break
          }
          A.next = 83
          return ReduxSagaEffects.b(Us, true)
        case 83:
          A.next = 93
          break
        case 85:
          A.prev = 85
          A.t1 = A.catch(77)
          A.next = 89
          return ReduxSagaEffects.e(Actions.Si(false))
        case 89:
          if (!e$payload$isNeedReport) {
            A.next = 92
            break
          }
          A.next = 92
          return ReduxSagaEffects.b(Us, false, A.t1.message)
        case 92:
          throw A.t1
        case 93:
          A.next = 95
          return ReduxSagaEffects.e(Actions.Pi(100))
        case 95:
          A.next = 97
          return ReduxSagaEffects.e(Actions.Fi(false))
        case 97:
          A.next = 99
          return ReduxSagaEffects.e(Actions.Si(false))
        case 99:
          A.next = 101
          return ReduxSagaEffects.e(Actions.Ei(Date.now()))
        case 101:
          A.next = 103
          return ReduxSagaEffects.b(vc, _A$sent)
        case 103:
          return A.abrupt("return", _A$sent)
        case 106:
          T = {
            name: f.substring(0, p),
            bcmUrl: _A$sent5,
            coverUrl: _,
            saveType: e$payload$isAutoSave ? Module_53.g.AutoSave : Module_53.g.ByUser,
            sourceTag: A$sent1.tag
          }
          A.prev = 107
          A.next = 110
          return ReduxSagaEffects.b(Module_297.f, T)
        case 110:
          if (_A$sent6 = A.sent, !e$payload$isNeedReport) {
            A.next = 114
            break
          }
          A.next = 114
          return ReduxSagaEffects.b(Us, true)
        case 114:
          A.next = 124
          break
        case 116:
          A.prev = 116
          A.t2 = A.catch(107)
          A.next = 120
          return ReduxSagaEffects.e(Actions.Si(false))
        case 120:
          if (!e$payload$isNeedReport) {
            A.next = 123
            break
          }
          A.next = 123
          return ReduxSagaEffects.b(Us, false, A.t2.message)
        case 123:
          throw A.t2
        case 124:
          if (!_A$sent6) {
            A.next = 141
            break
          }
          A.next = 127
          return ReduxSagaEffects.e(Actions.Pi(100))
        case 127:
          A.next = 129
          return ReduxSagaEffects.e(Actions.Fi(false))
        case 129:
          A.next = 131
          return ReduxSagaEffects.e(Actions.Uh(_A$sent6))
        case 131:
          A.next = 133
          return ReduxSagaEffects.e(Actions.Ei(Date.now()))
        case 133:
          A.next = 135
          return ReduxSagaEffects.e(Actions.Si(false))
        case 135:
          Module_26.z.setCurrentProjectId(_A$sent6)
          A.next = 138
          return ReduxSagaEffects.b(Vs)
        case 138:
          Shared_tools.jb(_A$sent6)
          A.next = 141
          return ReduxSagaEffects.b(vc, _A$sent6)
        case 141:
          if (!e$payload$isSaveAs) {
            A.next = 144
            break
          }
          A.next = 144
          return ReduxSagaEffects.e(Module_100.n())
        case 144:
          Shared_tools.k(["courseId", "templateId"])
          Pn()
          return A.abrupt("return", _A$sent6)
        case 147:
        case "end":
          return A.stop()
      }
    }
  }, ha, null, [[46, 58, 61, 64], [77, 85], [107, 116]])
}
function Us(e, t) {
  var /* [auto-meaningful-name] */i$sent
  var /* [auto-meaningful-name] */_i$sent
  var /* [auto-meaningful-name] */_i$sent2
  return RegeneratorRuntime.wrap(function (i) {
    for (;;) {
      switch (i.prev = i.next) {
        case 0:
          i.next = 2
          return ReduxSagaEffects.f(Module_22.y)
        case 2:
          i$sent = i.sent
          i.next = 5
          return ReduxSagaEffects.f(Module_22.G)
        case 5:
          _i$sent = i.sent
          i.next = 8
          return ReduxSagaEffects.f(Module_22.F)
        case 8:
          _i$sent2 = i.sent
          Module_141.a("WorkSave", {
            workId: i$sent,
            workName: _i$sent,
            workType: "APP工匠",
            sourceTag: _i$sent2.tag,
            sourceId: _i$sent2.id,
            isSuccess: e,
            failReason: t || ""
          })
        case 10:
        case "end":
          return i.stop()
      }
    }
  }, ma)
}
function Hs() {
  return RegeneratorRuntime.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          e.next = 2
          return ReduxSagaEffects.e(Actions.Si(false))
        case 2:
          e.next = 4
          return ReduxSagaEffects.e(Actions.Qi(false))
        case 4:
        case "end":
          return e.stop()
      }
    }
  }, ga)
}
function Vs() {
  var /* [auto-meaningful-name] */n$sent
  var /* [auto-meaningful-name] */_n$sent
  return RegeneratorRuntime.wrap(function (n) {
    for (;;) {
      switch (n.prev = n.next) {
        case 0:
          n.next = 2
          return ReduxSagaEffects.f(Module_22.y)
        case 2:
          n$sent = n.sent
          n.next = 5
          return ReduxSagaEffects.b(Module_177.k, n$sent)
        case 5:
          _n$sent = n.sent
          n.next = 8
          return ReduxSagaEffects.e(Actions.Ai(_n$sent))
        case 8:
        case "end":
          return n.stop()
      }
    }
  }, _a)
}
function zs(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$key
  var /* [auto-meaningful-name] */e$payload$value
  var /* [auto-meaningful-name] */e$payload$widgetId
  var /* [auto-meaningful-name] */e$payload$shouldUpdatePreviewArea
  var a
  var /* [auto-meaningful-name] */e$payload$shouldUpdateEditArea
  var l
  var /* [auto-meaningful-name] */e$payload$isEmitOT
  var d
  var /* [auto-meaningful-name] */e$payload$isBasePropertyPriority
  var f
  var h
  var /* [auto-meaningful-name] */b$sent
  var g
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$globalWidget
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget
  return RegeneratorRuntime.wrap(function (b) {
    for (;;) {
      switch (b.prev = b.next) {
        case 0:
          e$payload = e.payload
          e$payload$key = e$payload.key
          e$payload$value = e$payload.value
          e$payload$widgetId = e$payload.widgetId
          e$payload$shouldUpdatePreviewArea = e$payload.shouldUpdatePreviewArea
          a = undefined === e$payload$shouldUpdatePreviewArea || e$payload$shouldUpdatePreviewArea
          e$payload$shouldUpdateEditArea = e$payload.shouldUpdateEditArea
          l = undefined === e$payload$shouldUpdateEditArea || e$payload$shouldUpdateEditArea
          e$payload$isEmitOT = e$payload.isEmitOT
          d = undefined === e$payload$isEmitOT || e$payload$isEmitOT
          e$payload$isBasePropertyPriority = e$payload.isBasePropertyPriority
          f = undefined === e$payload$isBasePropertyPriority || e$payload$isBasePropertyPriority
          h = Module_9.Bb(e$payload$widgetId)
          b.next = 4
          return ReduxSagaEffects.f(Module_22.C)
        case 4:
          if (b$sent = b.sent, g = b$sent.find(function (e) {
            var /* [auto-meaningful-name] */e$invisibleWidgetIds
            return e.widgetIds.includes(e$payload$widgetId) || (null === (e$invisibleWidgetIds = e.invisibleWidgetIds) || undefined === e$invisibleWidgetIds ? undefined : e$invisibleWidgetIds.includes(e$payload$widgetId))
          }), h && h.type) {
            b.next = 8
            break
          }
          return b.abrupt("return")
        case 8:
          if (d && (h.isGlobalWidget ? null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$globalWidget = oTHelper.globalWidget) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$globalWidget || $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$globalWidget.clientOp.replaceWidgetAttributeOp(e$payload$widgetId, e$payload$key.toString(), e$payload$value, f) : g && (null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget = oTHelper.widget) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget || $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget.clientOp.replaceWidgetAttributeOp(g.id, e$payload$widgetId, e$payload$key.toString(), e$payload$value, f))), !Module_9.o.includes(e$payload$key) && !(e$payload$key in h) || !f) {
            b.next = 14
            break
          }
          b.next = 12
          return ReduxSagaEffects.b(Ks, e$payload$key, e$payload$value, e$payload$widgetId)
        case 12:
          b.next = 22
          break
        case 14:
          if (!(e$payload$key in h.attributes)) {
            b.next = 19
            break
          }
          b.next = 17
          return ReduxSagaEffects.e(Actions.Kg(e$payload$widgetId, e$payload$key, e$payload$value))
        case 17:
          b.next = 22
          break
        case 19:
          console.warn("This property ".concat(e$payload$key, " maybe is invalid"))
          b.next = 22
          return ReduxSagaEffects.e(Actions.Kg(e$payload$widgetId, e$payload$key, e$payload$value))
        case 22:
          if (!a) {
            b.next = 25
            break
          }
          b.next = 25
          return ReduxSagaEffects.e(Actions.Uj())
        case 25:
          if (!l) {
            b.next = 28
            break
          }
          b.next = 28
          return ReduxSagaEffects.e(Actions.Qj())
        case 28:
        case "end":
          return b.stop()
      }
    }
  }, va)
}
function Ys(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$widgetId
  var /* [auto-meaningful-name] */e$payload$key
  var /* [auto-meaningful-name] */e$payload$value
  var /* [auto-meaningful-name] */store$getState$project$id
  var a
  var s
  var l
  var /* [auto-meaningful-name] */s$contentTitle
  var d
  var p
  return RegeneratorRuntime.wrap(function (f) {
    for (;;) {
      switch (f.prev = f.next) {
        case 0:
          if (e$payload = e.payload, e$payload$widgetId = e$payload.widgetId, e$payload$key = e$payload.key, e$payload$value = e$payload.value, Module_9.Vb(e$payload$widgetId, e$payload$key, e$payload$value), store$getState$project$id = store.getState().project.id, e$payload$widgetId.includes(Widget_builtIn_types.G) && "db" === e$payload$key && Module_174.a.get(e$payload$widgetId).then(function (e) {
            if (e) {
              ReduxSagaEffects.e(Actions.Pj(e$payload$widgetId, "value", e))
            } else {
              ReduxSagaEffects.e(Actions.Pj(e$payload$widgetId, "value", e$payload$value))
            }
          }), !e$payload$widgetId.includes(Widget_builtIn_types.B) && !e$payload$widgetId.includes(Widget_builtIn_types.y)) {
            f.next = 14
            break
          }
          if ("fields" !== e$payload$key) {
            f.next = 14
            break
          }
          if (a = Module_20.getLocalDocumentObject(store$getState$project$id, e$payload$widgetId)) {
            f.next = 12
            break
          }
          f.next = 10
          return ReduxSagaEffects.e(Actions.Pj(e$payload$widgetId, "value", e$payload$value))
        case 10:
          f.next = 14
          break
        case 12:
          f.next = 14
          return ReduxSagaEffects.e(Actions.Pj(e$payload$widgetId, "value", a))
        case 14:
          f.next = 16
          return ReduxSagaEffects.e(Actions.Fi(true))
        case 16:
          if (s = Module_9.Bb(e$payload$widgetId)) {
            f.next = 19
            break
          }
          return f.abrupt("return")
        case 19:
          if (s.type === Widget_builtIn_types.B && "fields" === e$payload$key && Module_26.o(s.id, e$payload$value), s.type === Widget_builtIn_types.G && "db" === e$payload$key && Module_26.p(s.id, e$payload$value), !s.title) {
            f.next = 23
            break
          }
          return f.abrupt("return")
        case 23:
          if (l = Module_9.Db(s.type)) {
            f.next = 26
            break
          }
          return f.abrupt("return")
        case 26:
          if (l.contentTextField === e$payload$key) {
            s$contentTitle = s.contentTitle
            if (d = (d = (d = e$payload$value).replace(Module_53.E, "")).trim()) {
              d = Module_9.C(e$payload$widgetId, s.type, d)
            } else {
              p = l.previewAreaWidgetTitle
              p = Language.d(p)
              d = Module_9.C(e$payload$widgetId, s.type, p)
            }
            if (s$contentTitle !== d) {
              s.contentTitle = d
              Module_26.g.updateToolBoxWidgetTitle(e$payload$widgetId, d)
              Module_26.y(e$payload$widgetId, d, s.type)
            }
          }
        case 28:
        case "end":
          return f.stop()
      }
    }
  }, ba)
}
function Ks(e, t, n) {
  var r
  return RegeneratorRuntime.wrap(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          if (r = Module_9.Bb(n)) {
            o.next = 3
            break
          }
          return o.abrupt("return")
        case 3:
          o.next = 5
          return ReduxSagaEffects.e(Actions.Fi(true))
        case 5:
          if (Module_9.o.includes(e) || e in r) {
            if (!("size" !== e && "position" !== e)) {
              t = Module_6.a(Module_6.a({}, r[e]), t)
            }
            r[e] = t
          }
        case 6:
        case "end":
          return o.stop()
      }
    }
  }, ya)
}
function qs(e, t) {
  return RegeneratorRuntime.wrap(function (n) {
    for (;;) {
      switch (n.prev = n.next) {
        case 0:
          Module_26.g.updateToolBoxWidgetTitle(e, t)
          Module_26.x(e, t)
          n.next = 4
          return ReduxSagaEffects.e(Actions.Yj(e, t))
        case 4:
        case "end":
          return n.stop()
      }
    }
  }, Ea)
}
function Xs(e, t) {
  var /* [auto-meaningful-name] */i$sent
  var r
  var /* [auto-meaningful-name] */r$attributes$cloudDbId
  return RegeneratorRuntime.wrap(function (i) {
    for (;;) {
      switch (i.prev = i.next) {
        case 0:
          i.next = 2
          return ReduxSagaEffects.f(Module_22.y)
        case 2:
          if (i$sent = i.sent, (r = Module_9.Bb(e)) && r.type === Widget_builtIn_types.l) {
            i.next = 6
            break
          }
          return i.abrupt("return")
        case 6:
          r$attributes$cloudDbId = r.attributes.cloudDbId
          i.next = 9
          return ReduxSagaEffects.b(Gt, r$attributes$cloudDbId, t, Module_97.a(i$sent) ? i$sent : undefined)
        case 9:
        case "end":
          return i.stop()
      }
    }
  }, Oa)
}
function Qs(e, t) {
  var /* [auto-meaningful-name] */a$sent
  var r
  var /* [auto-meaningful-name] */r$attributes$cloudDbId
  var /* [auto-meaningful-name] */_a$sent1
  return RegeneratorRuntime.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          a.next = 2
          return ReduxSagaEffects.f(Module_22.y)
        case 2:
          if (a$sent = a.sent, (r = Module_9.Bb(e)) && r.type === Widget_builtIn_types.h) {
            a.next = 6
            break
          }
          return a.abrupt("return", t)
        case 6:
          r$attributes$cloudDbId = r.attributes.cloudDbId
          a.next = 9
          return ReduxSagaEffects.b(Module_147.p, r$attributes$cloudDbId, t, Module_97.a(a$sent) ? a$sent : undefined)
        case 9:
          _a$sent1 = a.sent
          return a.abrupt("return", _a$sent1 || t)
        case 11:
        case "end":
          return a.stop()
      }
    }
  }, wa)
}
function Zs(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$widgetId
  var /* [auto-meaningful-name] */e$payload$title
  var /* [auto-meaningful-name] */e$payload$shouldUpdatePreviewArea
  var /* [auto-meaningful-name] */e$payload$shouldUpdateEditArea
  var /* [auto-meaningful-name] */e$payload$isEmitOT
  var s
  var l
  var /* [auto-meaningful-name] */g$sent
  var d
  var /* [auto-meaningful-name] */l$type
  var /* [auto-meaningful-name] */_g$sent
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$globalWidget
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget
  return RegeneratorRuntime.wrap(function (g) {
    for (;;) {
      switch (g.prev = g.next) {
        case 0:
          if (e$payload = e.payload, e$payload$widgetId = e$payload.widgetId, e$payload$title = e$payload.title, e$payload$shouldUpdatePreviewArea = e$payload.shouldUpdatePreviewArea, e$payload$shouldUpdateEditArea = e$payload.shouldUpdateEditArea, e$payload$isEmitOT = e$payload.isEmitOT, s = undefined === e$payload$isEmitOT || e$payload$isEmitOT, l = Module_9.Bb(e$payload$widgetId)) {
            g.next = 4
            break
          }
          return g.abrupt("return")
        case 4:
          g.next = 6
          return ReduxSagaEffects.f(Module_22.f)
        case 6:
          g$sent = g.sent
          d = null === g$sent || undefined === g$sent ? undefined : g$sent.id
          l$type = l.type
          g.next = 11
          return ReduxSagaEffects.b(Xs, e$payload$widgetId, e$payload$title)
        case 11:
          g.next = 13
          return ReduxSagaEffects.b(Qs, e$payload$widgetId, e$payload$title)
        case 13:
          _g$sent = g.sent
          Module_9.Xb(e$payload$widgetId, _g$sent)
          Module_9.Vb(e$payload$widgetId, "name", _g$sent)
          Module_26.g.updateToolBoxWidgetTitle(e$payload$widgetId, _g$sent)
          Module_26.y(e$payload$widgetId, _g$sent, l$type)
          g.next = 20
          return ReduxSagaEffects.e(Actions.Fi(true))
        case 20:
          if (!e$payload$shouldUpdatePreviewArea) {
            g.next = 23
            break
          }
          g.next = 23
          return ReduxSagaEffects.e(Actions.Uj())
        case 23:
          if (!e$payload$shouldUpdateEditArea) {
            g.next = 26
            break
          }
          g.next = 26
          return ReduxSagaEffects.e(Actions.Qj())
        case 26:
          g.next = 28
          return ReduxSagaEffects.e(Actions.Pj(l.id, "name", _g$sent))
        case 28:
          if (s) {
            if (l.isGlobalWidget) {
              if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$globalWidget = oTHelper.globalWidget) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$globalWidget)) {
                $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$globalWidget.clientOp.replaceWidgetAttributeOp(e$payload$widgetId, "title", _g$sent)
              }
            } else {
              if (d) {
                if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget = oTHelper.widget) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget)) {
                  $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget.clientOp.replaceWidgetAttributeOp(d, e$payload$widgetId, "title", _g$sent)
                }
              }
            }
          }
        case 29:
        case "end":
          return g.stop()
      }
    }
  }, Ca)
}
function Js() {
  var e
  var t
  var n
  var /* [auto-meaningful-name] */d$sent
  var /* [auto-meaningful-name] */d$sent$list
  var /* [auto-meaningful-name] */d$sent$total
  var a
  var /* [auto-meaningful-name] */d$sent1
  var /* [auto-meaningful-name] */d$sent1$list
  var /* [auto-meaningful-name] */d$t0$response
  return RegeneratorRuntime.wrap(function (d) {
    for (;;) {
      switch (d.prev = d.next) {
        case 0:
          d.prev = 0
          e = []
          t = 1
          n = 100
          d.next = 6
          return ReduxSagaEffects.b(CustomWidgetShop.c, t, n)
        case 6:
          if (d$sent = d.sent, d$sent$list = d$sent.list, d$sent$total = d$sent.total, a = Math.ceil(d$sent$total / n), e = e.concat(d$sent$list), !(a > 1)) {
            d.next = 22
            break
          }
          t += 1
        case 13:
          if (!(t <= a)) {
            d.next = 22
            break
          }
          d.next = 16
          return ReduxSagaEffects.b(CustomWidgetShop.c, t, n)
        case 16:
          d$sent1 = d.sent
          d$sent1$list = d$sent1.list
          e = e.concat(d$sent1$list)
        case 19:
          t++
          d.next = 13
          break
        case 22:
          d.next = 24
          return ReduxSagaEffects.e(Actions.Sh(e))
        case 24:
          d.next = 30
          break
        case 26:
          if (d.prev = 26, d.t0 = d.catch(0), 40400100 !== (null === (d$t0$response = d.t0.response) || undefined === d$t0$response ? undefined : d$t0$response.data.code)) {
            d.next = 30
            break
          }
          return d.abrupt("return")
        case 30:
        case "end":
          return d.stop()
      }
    }
  }, Ta, null, [[0, 26]])
}
function $s(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$widgetCloneList
  var /* [auto-meaningful-name] */e$payload$screenId
  var /* [auto-meaningful-name] */i$sent
  return RegeneratorRuntime.wrap(function (i) {
    for (;;) {
      switch (i.prev = i.next) {
        case 0:
          e$payload = e.payload
          e$payload$widgetCloneList = e$payload.widgetCloneList
          e$payload$screenId = e$payload.screenId
          i.next = 3
          return ReduxSagaEffects.f(Module_22.g)
        case 3:
          if (i$sent = i.sent, e$payload$screenId && i$sent !== e$payload$screenId) {
            i.next = 9
            break
          }
          i.next = 7
          return ReduxSagaEffects.b(tc, e$payload$widgetCloneList)
        case 7:
          i.next = 11
          break
        case 9:
          i.next = 11
          return ReduxSagaEffects.b(ec, e$payload$widgetCloneList, e$payload$screenId)
        case 11:
        case "end":
          return i.stop()
      }
    }
  }, Sa)
}
function ec(e, t) {
  var /* [auto-meaningful-name] */f$sent
  var /* [auto-meaningful-name] */_f$sent9
  var o
  var i
  var a
  var s
  var l
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget
  var /* [auto-meaningful-name] */l$value
  var p
  return RegeneratorRuntime.wrap(function (f) {
    for (;;) {
      switch (f.prev = f.next) {
        case 0:
          f.next = 2
          return ReduxSagaEffects.f(Module_22.C)
        case 2:
          f$sent = f.sent
          f.next = 5
          return ReduxSagaEffects.f(Module_22.J)
        case 5:
          if (_f$sent9 = f.sent, o = f$sent.findIndex(function (e) {
            return e.id === t
          }), !(i = f$sent.get(o))) {
            f.next = 36
            break
          }
          if (!e.length) {
            f.next = 36
            break
          }
          s = Module_47.a(e)
          f.prev = 11
          s.s()
        case 13:
          if ((l = s.n()).done) {
            f.next = 21
            break
          }
          l$value = l.value
          if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget = oTHelper.widget) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget)) {
            $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget.clientOp.addWidgetOp(t, l$value)
          }
          f.next = 18
          return ReduxSagaEffects.e(Actions.jf(i.id, l$value.id))
        case 18:
          if (!l$value.parentId) {
            CustomWidgetShop.a(l$value.type, null === _f$sent9 || undefined === _f$sent9 ? undefined : _f$sent9.id)
          }
        case 19:
          f.next = 13
          break
        case 21:
          f.next = 26
          break
        case 23:
          f.prev = 23
          f.t0 = f.catch(11)
          s.e(f.t0)
        case 26:
          f.prev = 26
          s.f()
          return f.finish(26)
        case 29:
          f.next = 31
          return ReduxSagaEffects.b(Xa, Actions.vg(o))
        case 31:
          p = null === (a = e[0]) || undefined === a ? undefined : a.id
          f.next = 34
          return ReduxSagaEffects.e(Actions.ug(p))
        case 34:
          f.next = 36
          return ReduxSagaEffects.e(Actions.Fi(true))
        case 36:
        case "end":
          return f.stop()
      }
    }
  }, Aa, null, [[11, 23, 26, 29]])
}
function tc(e) {
  var /* [auto-meaningful-name] */_$sent
  var /* [auto-meaningful-name] */_$sent1
  var /* [auto-meaningful-name] */_$sent5
  var o
  var a
  var s
  var l
  var u
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget
  var /* [auto-meaningful-name] */u$value
  var f
  var h
  var m
  var g
  return RegeneratorRuntime.wrap(function (_) {
    for (;;) {
      switch (_.prev = _.next) {
        case 0:
          _.next = 2
          return ReduxSagaEffects.f(Module_22.x)
        case 2:
          _$sent = _.sent
          _.next = 5
          return ReduxSagaEffects.f(Module_22.C)
        case 5:
          _$sent1 = _.sent
          _.next = 8
          return ReduxSagaEffects.f(Module_22.J)
        case 8:
          if (_$sent5 = _.sent, o = _$sent1.get(_$sent), !e.length || !o) {
            _.next = 50
            break
          }
          s = o.get("id")
          l = Module_47.a(e)
          _.prev = 13
          l.s()
        case 15:
          if ((u = l.n()).done) {
            _.next = 37
            break
          }
          if (!(u$value = u.value).parentId) {
            _.next = 29
            break
          }
          if (u$value.position.x += 20, u$value.position.y -= 20, u$value.type !== Widget_builtIn_types.a && u$value.type !== Widget_builtIn_types.c) {
            _.next = 27
            break
          }
          if (!(f = Module_9.Bb(u$value.parentId))) {
            _.next = 27
            break
          }
          m = (h = f).widgetIds.includes(u$value.id) ? Module_25.a(h.widgetIds) : [].concat(Module_25.a(h.widgetIds), [u$value.id])
          _.next = 27
          return ReduxSagaEffects.e(Actions.Lg(u$value.parentId, "widgetIds", m, true, true, true, true))
        case 27:
          _.next = 31
          break
        case 29:
          u$value.position.x += 10
          u$value.position.y += 10
        case 31:
          if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget = oTHelper.widget) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget)) {
            $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget.clientOp.addWidgetOp(s, u$value)
          }
          _.next = 34
          return ReduxSagaEffects.e(Actions.jf(s, u$value.id))
        case 34:
          if (!u$value.parentId) {
            CustomWidgetShop.a(u$value.type, null === _$sent5 || undefined === _$sent5 ? undefined : _$sent5.id)
          }
        case 35:
          _.next = 15
          break
        case 37:
          _.next = 42
          break
        case 39:
          _.prev = 39
          _.t0 = _.catch(13)
          l.e(_.t0)
        case 42:
          _.prev = 42
          l.f()
          return _.finish(42)
        case 45:
          g = null === (a = e[0]) || undefined === a ? undefined : a.id
          _.next = 48
          return ReduxSagaEffects.e(Actions.ug(g))
        case 48:
          _.next = 50
          return ReduxSagaEffects.e(Actions.Fi(true))
        case 50:
        case "end":
          return _.stop()
      }
    }
  }, Ia, null, [[13, 39, 42, 45]])
}
function nc(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$widgetId
  var /* [auto-meaningful-name] */e$payload$position
  var /* [auto-meaningful-name] */Widget_builtIn_types$c
  var s
  var /* [auto-meaningful-name] */E$sent
  var /* [auto-meaningful-name] */E$sent1
  var /* [auto-meaningful-name] */E$sent2
  var p
  var /* [auto-meaningful-name] */_E$sent3
  var /* [auto-meaningful-name] */s$widget$attributes
  var /* [auto-meaningful-name] */s$widget$isGlobalWidget
  var g
  var _
  var v
  var b
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget
  return RegeneratorRuntime.wrap(function (E) {
    for (;;) {
      switch (E.prev = E.next) {
        case 0:
          e$payload = e.payload
          e$payload$widgetId = e$payload.widgetId
          e$payload$position = e$payload.position
          Widget_builtIn_types$c = Widget_builtIn_types.c
          s = Module_9.Db(Widget_builtIn_types$c)
          E.next = 5
          return ReduxSagaEffects.f(Module_22.s)
        case 5:
          E$sent = E.sent
          E.next = 8
          return ReduxSagaEffects.f(Module_22.x)
        case 8:
          E$sent1 = E.sent
          E.next = 11
          return ReduxSagaEffects.f(Module_22.C)
        case 11:
          if (E$sent2 = E.sent, (p = E$sent1 > -1 ? E$sent2.get(E$sent1) : undefined) && s) {
            E.next = 15
            break
          }
          return E.abrupt("return")
        case 15:
          E.next = 17
          return ReduxSagaEffects.f(Module_22.J)
        case 17:
          if (_E$sent3 = E.sent, s$widget$attributes = s.widget.attributes, s$widget$isGlobalWidget = s.widget.isGlobalWidget, g = s.title ? Module_9.D(Widget_builtIn_types$c, p.widgetIds, Language.c(E$sent, s.title).toString()) : "", _ = Module_64.a(Widget_builtIn_types$c), v = {
            id: _,
            title: g,
            type: Widget_builtIn_types.c,
            position: e$payload$position,
            visible: true,
            size: s.widget.size,
            parentId: e$payload$widgetId,
            animationRecord: {},
            attributes: Module_6.a({}, s$widget$attributes),
            isGlobalWidget: s$widget$isGlobalWidget
          }, Module_9.Ub(_, v), !(b = Module_9.Bb(e$payload$widgetId))) {
            E.next = 39
            break
          }
          b.widgetIds.push(_)
          E.next = 29
          return ReduxSagaEffects.e(Actions.Uj())
        case 29:
          E.next = 31
          return ReduxSagaEffects.e(Actions.Qj())
        case 31:
          E.next = 33
          return ReduxSagaEffects.e(Actions.jf(p.id, v.id))
        case 33:
          E.next = 35
          return ReduxSagaEffects.e(Actions.ug(v.id))
        case 35:
          E.next = 37
          return ReduxSagaEffects.b(bs, p.id, v)
        case 37:
          if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget = oTHelper.widget) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget)) {
            $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget.clientOp.addBrushAndActorWidgetOp(p.id, v, b.id, Module_25.a(b.widgetIds))
          }
          CustomWidgetShop.a(v.type, null === _E$sent3 || undefined === _E$sent3 ? undefined : _E$sent3.id)
        case 39:
        case "end":
          return E.stop()
      }
    }
  }, ja)
}
function rc(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$widgetId
  var /* [auto-meaningful-name] */e$payload$position
  var o
  var /* [auto-meaningful-name] */Widget_builtIn_types$a
  var s
  var /* [auto-meaningful-name] */E$sent
  var /* [auto-meaningful-name] */E$sent1
  var /* [auto-meaningful-name] */E$sent2
  var p
  var /* [auto-meaningful-name] */_E$sent6
  var h
  var /* [auto-meaningful-name] */s$widget$isGlobalWidget
  var g
  var _
  var v
  var b
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget
  return RegeneratorRuntime.wrap(function (E) {
    for (;;) {
      switch (E.prev = E.next) {
        case 0:
          e$payload = e.payload
          e$payload$widgetId = e$payload.widgetId
          e$payload$position = e$payload.position
          o = e$payload$widgetId
          Widget_builtIn_types$a = Widget_builtIn_types.a
          s = Module_9.Db(Widget_builtIn_types$a)
          E.next = 6
          return ReduxSagaEffects.f(Module_22.s)
        case 6:
          E$sent = E.sent
          E.next = 9
          return ReduxSagaEffects.f(Module_22.x)
        case 9:
          E$sent1 = E.sent
          E.next = 12
          return ReduxSagaEffects.f(Module_22.C)
        case 12:
          if (E$sent2 = E.sent, p = E$sent1 > -1 ? E$sent2.get(E$sent1) : undefined) {
            E.next = 16
            break
          }
          return E.abrupt("return")
        case 16:
          if (s) {
            E.next = 18
            break
          }
          return E.abrupt("return")
        case 18:
          E.next = 20
          return ReduxSagaEffects.f(Module_22.J)
        case 20:
          if (_E$sent6 = E.sent, h = Lodash.cloneDeep(s.widget.attributes), s$widget$isGlobalWidget = s.widget.isGlobalWidget, h.actionList.push({
            id: Module_64.a(Module_144.a),
            name: Language.c(E$sent, "ActorStyleDialog.defaultActionName").toString(),
            styleList: [],
            interval: 200
          }), g = s.title ? Module_9.D(Widget_builtIn_types$a, p.widgetIds, Language.c(E$sent, s.title).toString()) : "", _ = Module_64.a(Widget_builtIn_types$a), v = {
            id: _,
            title: g,
            type: Widget_builtIn_types.a,
            position: e$payload$position,
            visible: true,
            parentId: o,
            animationRecord: {},
            size: {
              width: 0,
              height: 0
            },
            attributes: h,
            isGlobalWidget: s$widget$isGlobalWidget
          }, Module_9.Ub(_, v), !(b = Module_9.Bb(o))) {
            E.next = 43
            break
          }
          b.widgetIds.push(_)
          E.next = 33
          return ReduxSagaEffects.e(Actions.Uj())
        case 33:
          E.next = 35
          return ReduxSagaEffects.e(Actions.Qj())
        case 35:
          E.next = 37
          return ReduxSagaEffects.e(Actions.jf(p.id, v.id))
        case 37:
          E.next = 39
          return ReduxSagaEffects.e(Actions.ug(v.id))
        case 39:
          E.next = 41
          return ReduxSagaEffects.b(bs, p.id, v)
        case 41:
          if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget = oTHelper.widget) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget)) {
            $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget.clientOp.addBrushAndActorWidgetOp(p.id, v, b.id, Module_25.a(b.widgetIds))
          }
          CustomWidgetShop.a(v.type, null === _E$sent6 || undefined === _E$sent6 ? undefined : _E$sent6.id)
        case 43:
        case "end":
          return E.stop()
      }
    }
  }, Na)
}
function oc(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$screenId
  var /* [auto-meaningful-name] */e$payload$blockId
  var /* [auto-meaningful-name] */l$sent
  var /* [auto-meaningful-name] */_l$sent4
  var /* [auto-meaningful-name] */l$sent1
  var s
  return RegeneratorRuntime.wrap(function (l) {
    for (;;) {
      switch (l.prev = l.next) {
        case 0:
          e$payload = e.payload
          e$payload$screenId = e$payload.screenId
          e$payload$blockId = e$payload.blockId
          l.next = 3
          return ReduxSagaEffects.f(Module_22.s)
        case 3:
          l$sent = l.sent
          l.next = 6
          return ReduxSagaEffects.f(Module_22.f)
        case 6:
          _l$sent4 = l.sent
          l.next = 9
          return ReduxSagaEffects.f(Module_22.C)
        case 9:
          if (l$sent1 = l.sent, s = l$sent1.findIndex(function (e) {
            return e.id === e$payload$screenId
          }), (null === _l$sent4 || undefined === _l$sent4 ? undefined : _l$sent4.id) !== e$payload$screenId) {
            l.next = 16
            break
          }
          l.next = 14
          return ReduxSagaEffects.b(Module_26.z.playWarningAnimation, e$payload$blockId)
        case 14:
          l.next = 19
          break
        case 16:
          if (!(s > -1)) {
            l.next = 19
            break
          }
          l.next = 19
          return ReduxSagaEffects.b(Xa, Actions.vg(s))
        case 19:
          if (!Module_26.z.getBlockById(e$payload$blockId)) {
            l.next = 25
            break
          }
          l.next = 23
          return ReduxSagaEffects.b(Module_26.z.playWarningAnimation, e$payload$blockId)
        case 23:
          l.next = 27
          break
        case 25:
          l.next = 27
          return ReduxSagaEffects.e(Actions.showCommonToastInfoAction({
            message: Language.c(l$sent, "theBlockHasBeRemoved").toString(),
            showCloseIcon: false,
            showPrefixIcon: false,
            type: "error"
          }))
        case 27:
        case "end":
          return l.stop()
      }
    }
  }, Ra)
}
function ic(e) {
  var /* [auto-meaningful-name] */e$payload$screenIds
  var /* [auto-meaningful-name] */l$sent
  var r
  var /* [auto-meaningful-name] */l$sent1
  var i
  var a
  return RegeneratorRuntime.wrap(function (l) {
    for (;;) {
      switch (l.prev = l.next) {
        case 0:
          e$payload$screenIds = e.payload.screenIds
          l.next = 3
          return ReduxSagaEffects.f(Module_22.C)
        case 3:
          l$sent = l.sent
          r = l$sent.map(function (e) {
            return e.id
          }).toJSON()
          l.next = 7
          return ReduxSagaEffects.f(Module_22.f)
        case 7:
          if (l$sent1 = l.sent, Lodash.isEqual(r, e$payload$screenIds)) {
            l.next = 16
            break
          }
          i = []
          e$payload$screenIds.forEach(function (e) {
            var t = l$sent.find(function (t) {
              return t.id === e
            })
            if (t) {
              i.push(t)
            }
          })
          l.next = 13
          return ReduxSagaEffects.e(Actions.Aj(Immutable.List(i)))
        case 13:
          a = e$payload$screenIds.indexOf(l$sent1.id)
          l.next = 16
          return ReduxSagaEffects.e(Actions.Bi(a))
        case 16:
        case "end":
          return l.stop()
      }
    }
  }, ka)
}
function ac(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$screenId
  var /* [auto-meaningful-name] */e$payload$key
  var /* [auto-meaningful-name] */e$payload$value
  var /* [auto-meaningful-name] */e$payload$isEmitOT
  var a
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$screen
  return RegeneratorRuntime.wrap(function (l) {
    for (;;) {
      switch (l.prev = l.next) {
        case 0:
          if (e$payload = e.payload, e$payload$screenId = e$payload.screenId, e$payload$key = e$payload.key, e$payload$value = e$payload.value, e$payload$isEmitOT = e$payload.isEmitOT, a = undefined === e$payload$isEmitOT || e$payload$isEmitOT, "title" !== e$payload$key || "string" !== typeof e$payload$value) {
            l.next = 7
            break
          }
          l.next = 4
          return ReduxSagaEffects.b(qs, e$payload$screenId, e$payload$value)
        case 4:
          Module_26.y(e$payload$screenId, e$payload$value, "SCREEN")
          l.next = 9
          break
        case 7:
          l.next = 9
          return ReduxSagaEffects.e(Actions.Wj(e$payload$screenId, e$payload$key, e$payload$value))
        case 9:
          l.next = 11
          return ReduxSagaEffects.e(Actions.Fi(true))
        case 11:
          if (a) {
            if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$screen = oTHelper.screen) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$screen)) {
              $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$screen.clientOp.updateScreenStyle(e$payload$screenId, e$payload$key, e$payload$value)
            }
          }
        case 12:
        case "end":
          return l.stop()
      }
    }
  }, xa)
}
function sc(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$isEmitOT
  var r
  var /* [auto-meaningful-name] */e$payload$widgetId
  var /* [auto-meaningful-name] */u$sent
  var /* [auto-meaningful-name] */_u$sent
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$customEvent
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$customEvent$emit
  return RegeneratorRuntime.wrap(function (u) {
    for (;;) {
      switch (u.prev = u.next) {
        case 0:
          e$payload = e.payload
          e$payload$isEmitOT = e$payload.isEmitOT
          r = undefined === e$payload$isEmitOT || e$payload$isEmitOT
          e$payload$widgetId = e$payload.widgetId
          u.next = 3
          return ReduxSagaEffects.f(Module_22.f)
        case 3:
          u$sent = u.sent
          u.next = 6
          return ReduxSagaEffects.f(Module_22.i)
        case 6:
          _u$sent = u.sent
          u.next = 9
          return ReduxSagaEffects.e(Actions.Xh(e$payload$widgetId))
        case 9:
          if (_u$sent) {
            setTimeout(function () {
              return Module_26.g.setSelectedItemByWidgetId(e$payload$widgetId || u$sent.id)
            }, 10)
          }
          if (r) {
            if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$customEvent = oTHelper.customEvent) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$customEvent || null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$customEvent$emit = $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$customEvent.emit) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$customEvent$emit)) {
              $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$customEvent$emit.focusItem("widget", e$payload$widgetId)
            }
          }
        case 11:
        case "end":
          return u.stop()
      }
    }
  }, Da)
}
function cc(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$title
  var /* [auto-meaningful-name] */e$payload$isEmitOT
  var o
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$projectOt
  return RegeneratorRuntime.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          e$payload = e.payload
          e$payload$title = e$payload.title
          e$payload$isEmitOT = e$payload.isEmitOT
          o = undefined === e$payload$isEmitOT || e$payload$isEmitOT
          a.next = 3
          return ReduxSagaEffects.e(Actions.Qg(e$payload$title))
        case 3:
          a.next = 5
          return ReduxSagaEffects.e(Actions.Fi(true))
        case 5:
          if (o) {
            if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$projectOt = oTHelper.projectOt) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$projectOt)) {
              $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$projectOt.clientOp.changeProjectProperty("title", e$payload$title)
            }
          }
        case 6:
        case "end":
          return a.stop()
      }
    }
  }, Ma)
}
function lc(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$screenId
  var /* [auto-meaningful-name] */e$payload$widgetId
  var /* [auto-meaningful-name] */e$payload$widgetIds
  var /* [auto-meaningful-name] */e$payload$isEmitOT
  var a
  var s
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget
  return RegeneratorRuntime.wrap(function (u) {
    for (;;) {
      switch (u.prev = u.next) {
        case 0:
          e$payload = e.payload
          e$payload$screenId = e$payload.screenId
          e$payload$widgetId = e$payload.widgetId
          e$payload$widgetIds = e$payload.widgetIds
          e$payload$isEmitOT = e$payload.isEmitOT
          a = undefined === e$payload$isEmitOT || e$payload$isEmitOT
          if (s = Module_9.Bb(e$payload$widgetId)) {
            s.widgetIds = e$payload$widgetIds
          }
          u.next = 5
          return ReduxSagaEffects.e(Actions.Fi(true))
        case 5:
          u.next = 7
          return ReduxSagaEffects.e(Actions.Uj())
        case 7:
          u.next = 9
          return ReduxSagaEffects.e(Actions.Qj())
        case 9:
          if (a) {
            if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget = oTHelper.widget) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget)) {
              $$_$$_$$_$$_unrestored_shared_1571_2636_49$oTHelper$widget.clientOp.replaceWidgetAttributeOp(e$payload$screenId, e$payload$widgetId, "widgetIds", e$payload$widgetIds)
            }
          }
        case 10:
        case "end":
          return u.stop()
      }
    }
  }, La)
}
function uc() {
  var /* [auto-meaningful-name] */o$sent
  var /* [auto-meaningful-name] */_o$sent6
  var /* [auto-meaningful-name] */_o$sent7
  var r
  return RegeneratorRuntime.wrap(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          o.next = 2
          return ReduxSagaEffects.f(Module_22.y)
        case 2:
          o$sent = o.sent
          o.next = 5
          return ReduxSagaEffects.f(Module_22.G)
        case 5:
          _o$sent6 = o.sent
          o.next = 8
          return ReduxSagaEffects.b(Module_177.e, o$sent)
        case 8:
          if (!(_o$sent7 = o.sent) || !_o$sent7.pack_label) {
            o.next = 14
            break
          }
          o.next = 12
          return ReduxSagaEffects.e(Actions.Ji({
            apkIcon: _o$sent7.apk_icon,
            apkName: _o$sent7.apk_name,
            packLabel: _o$sent7.pack_label,
            apkSplash: _o$sent7.app_splash || ""
          }))
        case 12:
          o.next = 16
          break
        case 14:
          o.next = 16
          return ReduxSagaEffects.e(Actions.Ji({
            apkName: _o$sent6
          }))
        case 16:
          if (!(Module_9.Y().length > 0 && "true" !== localStorage.getItem("cloudDBPublishGuide"))) {
            o.next = 23
            break
          }
          r = function () {
            return store.dispatch(Actions.Ii(true))
          }
          o.next = 21
          return ReduxSagaEffects.e(Actions.kj(true, "pack", r))
        case 21:
          o.next = 25
          break
        case 23:
          o.next = 25
          return ReduxSagaEffects.e(Actions.Ii(true))
        case 25:
        case "end":
          return o.stop()
      }
    }
  }, Pa)
}
function dc() {
  var /* [auto-meaningful-name] */r$sent
  var /* [auto-meaningful-name] */_r$sent2
  var /* [auto-meaningful-name] */_r$sent3
  return RegeneratorRuntime.wrap(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          r.next = 2
          return ReduxSagaEffects.f(Module_22.B)
        case 2:
          r$sent = r.sent
          r.next = 5
          return ReduxSagaEffects.b(Module_177.d, r$sent)
        case 5:
          r.next = 7
          return ReduxSagaEffects.e(Actions.Li(false))
        case 7:
          r.next = 9
          return ReduxSagaEffects.f(Module_22.y)
        case 9:
          _r$sent2 = r.sent
          r.next = 12
          return ReduxSagaEffects.f(Module_22.A)
        case 12:
          _r$sent3 = r.sent
          Module_141.a("CancelWorkPack", {
            workId: _r$sent2,
            apkName: _r$sent3.apkName
          })
        case 14:
        case "end":
          return r.stop()
      }
    }
  }, Ba)
}
function pc() {
  var /* [auto-meaningful-name] */t$sent
  return RegeneratorRuntime.wrap(function (t) {
    for (;;) {
      switch (t.prev = t.next) {
        case 0:
          t.next = 2
          return ReduxSagaEffects.f(Module_22.s)
        case 2:
          t$sent = t.sent
          t.next = 5
          return ReduxSagaEffects.e(Actions.openConfirmDialogAction({
            onConfirm: function () {
              store.dispatch(Actions.openSignInDialogAction())
            },
            allowText: Language.c(t$sent, "cloudDbUserLogin").toString(),
            cancelText: Language.c(t$sent, "cloudDbUserCancelLogin").toString(),
            title: Language.c(t$sent, "cloudDbUserNotLoginTitle").toString(),
            content: Language.c(t$sent, "cloudDbUserNotLoginDescription").toString()
          }))
        case 5:
        case "end":
          return t.stop()
      }
    }
  }, Fa)
}
function fc() {
  var /* [auto-meaningful-name] */k$sent
  var t
  var n
  var /* [auto-meaningful-name] */k$t0$response
  var o
  var a
  var s
  var l
  var u
  var d
  var /* [auto-meaningful-name] */d$value
  var f
  var h
  var m
  var /* [auto-meaningful-name] */_k$sent
  var _
  var v
  var b
  var /* [auto-meaningful-name] */b$value
  var /* [auto-meaningful-name] */_k$sent2
  var O
  var w
  var /* [auto-meaningful-name] */w$value
  var /* [auto-meaningful-name] */w$value$type
  var /* [auto-meaningful-name] */w$value$id
  var A
  var I
  var j
  var N
  var /* [auto-meaningful-name] */_k$sent3
  return RegeneratorRuntime.wrap(function (k) {
    for (;;) {
      switch (k.prev = k.next) {
        case 0:
          k.next = 2
          return ReduxSagaEffects.f(Module_22.y)
        case 2:
          k$sent = k.sent
          t = Module_9.cb()
          n = []
          k.prev = 5
          k.next = 8
          return ReduxSagaEffects.b(Lt, Module_97.a(k$sent) ? k$sent : undefined)
        case 8:
          n = k.sent
          k.next = 17
          break
        case 11:
          if (k.prev = 11, k.t0 = k.catch(5), !(40400100 === (null === (k$t0$response = k.t0.response) || undefined === k$t0$response ? undefined : k$t0$response.data.code) && t.length > 0)) {
            k.next = 16
            break
          }
          k.next = 16
          return ReduxSagaEffects.b(pc)
        case 16:
          return k.abrupt("return")
        case 17:
          o = false
          a = []
          s = []
          l = t.filter(function (e) {
            return !n.some(function (t) {
              return t.id === e.attributes.cloudDbId
            })
          })
          u = Module_47.a(n)
          k.prev = 22
          u.s()
        case 24:
          if ((d = u.n()).done) {
            k.next = 31
            break
          }
          d$value = d.value
          k.next = 28
          return ReduxSagaEffects.b(gc, d$value.id)
        case 28:
          d$value.fields = k.sent
        case 29:
          k.next = 24
          break
        case 31:
          k.next = 36
          break
        case 33:
          k.prev = 33
          k.t1 = k.catch(22)
          u.e(k.t1)
        case 36:
          k.prev = 36
          u.f()
          return k.finish(36)
        case 39:
          n.reverse().forEach(function (e) {
            var t = Module_9.cb().find(function (t) {
              return t.attributes.cloudDbId === e.id
            })
            if (t) {
              Module_9.Vb(t.id, "fields", e.fields)
              a.push(t)
            } else {
              s.push(e)
            }
          })
          f = 0
          h = s
        case 41:
          if (!(f < h.length)) {
            k.next = 56
            break
          }
          m = h[f]
          k.next = 45
          return ReduxSagaEffects.b(ps, Widget_builtIn_types.l, {
            x: 0,
            y: 0
          })
        case 45:
          if (!(_k$sent = k.sent)) {
            k.next = 53
            break
          }
          _k$sent.title = m.name
          _k$sent.attributes.cloudDbId = m.id
          _k$sent.attributes.fields = m.fields
          a.push(_k$sent)
          k.next = 53
          return ReduxSagaEffects.b(hs, _k$sent)
        case 53:
          f++
          k.next = 41
          break
        case 56:
          if (!(l.length + a.length <= Module_305.f)) {
            k.next = 83
            break
          }
          _ = a.map(function (e) {
            return e.title
          })
          v = Module_47.a(l)
          k.prev = 59
          v.s()
        case 61:
          if ((b = v.n()).done) {
            k.next = 73
            break
          }
          b$value = b.value
          if (_.includes(b$value.title)) {
            o = true
            b$value.title = Module_9.ac(b$value.title, _)
            _.push(b$value.title)
          }
          k.next = 66
          return ReduxSagaEffects.b(Bt, b$value.title)
        case 66:
          _k$sent2 = k.sent
          b$value.attributes.cloudDbId = _k$sent2
          k.next = 70
          return ReduxSagaEffects.b(Yt, _k$sent2, {
            addItems: Module_25.a(b$value.attributes.fields),
            editItems: [],
            deleteItems: []
          }, Module_97.a(k$sent) ? k$sent : undefined)
        case 70:
          migrateCloudDict([_k$sent2], 2, 0, Module_97.a(k$sent) ? k$sent : undefined)
        case 71:
          k.next = 61
          break
        case 73:
          k.next = 78
          break
        case 75:
          k.prev = 75
          k.t2 = k.catch(59)
          v.e(k.t2)
        case 78:
          k.prev = 78
          v.f()
          return k.finish(78)
        case 81:
          k.next = 106
          break
        case 83:
          O = Module_47.a(l)
          k.prev = 84
          O.s()
        case 86:
          if ((w = O.n()).done) {
            k.next = 95
            break
          }
          w$value = w.value
          w$value$type = w$value.type
          w$value$id = w$value.id
          Module_26.q(w$value$type, w$value$id)
          Module_9.F(w$value.id)
          k.next = 93
          return ReduxSagaEffects.e(Actions.Lh(w$value$id))
        case 93:
          k.next = 86
          break
        case 95:
          k.next = 100
          break
        case 97:
          k.prev = 97
          k.t3 = k.catch(84)
          O.e(k.t3)
        case 100:
          k.prev = 100
          O.f()
          return k.finish(100)
        case 103:
          A = Language.d("cloudDbCountOverflowTitle")
          I = Language.d("cloudDbCountOverflowDescription", {
            workDbCount: l.length.toString(),
            selfDbCount: a.length.toString(),
            maxCount: Module_305.f.toString()
          })
          Module_2680.a.info({
            title: A,
            icon: null,
            centered: true,
            content: I,
            okText: "确认",
            width: 480,
            okButtonProps: {
              shape: "circle"
            }
          })
        case 106:
          if (o) {
            j = Language.d("cloudDbNameConflictTitle")
            N = Language.d("cloudDbNameConflictDescription")
            Module_2680.a.info({
              title: j,
              icon: null,
              centered: true,
              content: N,
              okText: "确认",
              width: 480,
              okButtonProps: {
                shape: "circle"
              }
            })
          }
          k.next = 109
          return ReduxSagaEffects.e(Actions.Qj())
        case 109:
          k.next = 111
          return ReduxSagaEffects.f(Module_22.n)
        case 111:
          _k$sent3 = k.sent
          Module_26.g.updateGlobalWidget(_k$sent3)
        case 113:
        case "end":
          return k.stop()
      }
    }
  }, Ga, null, [[5, 11], [22, 33, 36, 39], [59, 75, 78, 81], [84, 97, 100, 103]])
}
function hc() {
  var /* [auto-meaningful-name] */a$sent
  var t
  var /* [auto-meaningful-name] */_a$sent10
  var /* [auto-meaningful-name] */_a$sent11
  var o
  var i
  return RegeneratorRuntime.wrap(function (a) {
    for (;;) {
      switch (a.prev = a.next) {
        case 0:
          a.next = 2
          return ReduxSagaEffects.f(Module_22.s)
        case 2:
          a$sent = a.sent
          t = Module_9.Y()
          a.next = 6
          return ReduxSagaEffects.f(Module_22.J)
        case 6:
          _a$sent10 = a.sent
          a.next = 9
          return ReduxSagaEffects.f(Module_22.K)
        case 9:
          if (a.sent) {
            a.next = 12
            break
          }
          return a.abrupt("return")
        case 12:
          a.next = 14
          return ReduxSagaEffects.b(di)
        case 14:
          if (0 !== t.length) {
            a.next = 16
            break
          }
          return a.abrupt("return")
        case 16:
          if (_a$sent10) {
            a.next = 23
            break
          }
          t.forEach(function (e) {
            Module_9.F(e.id)
          })
          a.next = 20
          return ReduxSagaEffects.e(Actions.showCommonToastInfoAction({
            message: Language.c(a$sent, "cloudDb.noLoginError").toString(),
            type: "info"
          }))
        case 20:
          a.next = 22
          return ReduxSagaEffects.e(Actions.openSignInDialogAction())
        case 22:
          return a.abrupt("return")
        case 23:
          a.next = 25
          return ReduxSagaEffects.b(Module_147.g, "dev")
        case 25:
          if (_a$sent11 = a.sent) {
            a.next = 28
            break
          }
          return a.abrupt("return")
        case 28:
          if (o = false, i = false, t.forEach(function (e) {
            var /* [auto-meaningful-name] */e$attributes$cloudDbId = e.attributes.cloudDbId
            var n = e.id
            var a = _a$sent11.find(function (e) {
              return e.id === e$attributes$cloudDbId
            })
            if (a) {
              if (e.title !== a.name) {
                i = true
                var /* [auto-meaningful-name] */a$name = a.name
                Module_9.Xb(n, a$name)
                Module_26.g.updateToolBoxWidgetTitle(n, a$name)
                Module_26.y(e.id, a$name, "CLOUD_DB")
                Module_9.Vb(n, "name", a$name)
                store.dispatch(Actions.Uj())
                store.dispatch(Actions.Qj())
              }
              if (e.attributes.primaryKey !== a.primary_column) {
                i = true
                Module_9.Vb(n, "primaryKey", a.primary_column)
              }
              if (JSON.stringify(e.attributes.columns) !== JSON.stringify(a.columns)) {
                i = true
                store.dispatch(Actions.zg(e$attributes$cloudDbId, a.columns))
              }
            } else {
              o = true
              Module_9.F(n)
              Module_26.q("CLOUD_DB", n)
            }
          }), !o) {
            a.next = 36
            break
          }
          a.next = 34
          return ReduxSagaEffects.e(Actions.openConfirmDialogAction({
            allowText: Language.c(a$sent, "cloudDb.know").toString(),
            title: Language.c(a$sent, "cloudDb.dataRemoveTitle").toString(),
            content: Language.c(a$sent, "cloudDb.dataRemoveContent").toString(),
            cancelBtnVisible: false
          }))
        case 34:
          a.next = 39
          break
        case 36:
          if (!i) {
            a.next = 39
            break
          }
          a.next = 39
          return ReduxSagaEffects.e(Actions.showCommonToastInfoAction({
            message: Language.c(a$sent, "cloudDb.dataChangeNotice").toString(),
            type: "error"
          }))
        case 39:
          a.next = 41
          return ReduxSagaEffects.e(Actions.Qj())
        case 41:
        case "end":
          return a.stop()
      }
    }
  }, Wa)
}
function mc(e) {
  var /* [auto-meaningful-name] */e$payload
  var /* [auto-meaningful-name] */e$payload$fields
  var /* [auto-meaningful-name] */e$payload$setBlockValue
  var /* [auto-meaningful-name] */e$payload$widgetId
  var i
  var /* [auto-meaningful-name] */i$attributes$cloudDbId
  var /* [auto-meaningful-name] */i$attributes$fields
  var l
  var u
  var d
  var /* [auto-meaningful-name] */m$sent
  var f
  var /* [auto-meaningful-name] */_m$sent4
  return RegeneratorRuntime.wrap(function (m) {
    for (;;) {
      switch (m.prev = m.next) {
        case 0:
          if (e$payload = e.payload, e$payload$fields = e$payload.fields, e$payload$setBlockValue = e$payload.setBlockValue, e$payload$widgetId = e$payload.widgetId, (i = Module_9.Bb(e$payload$widgetId)) && i.type === Widget_builtIn_types.l) {
            m.next = 4
            break
          }
          return m.abrupt("return")
        case 4:
          i$attributes$cloudDbId = i.attributes.cloudDbId
          i$attributes$fields = i.attributes.fields
          l = []
          u = []
          d = []
          m.next = 11
          return ReduxSagaEffects.f(Module_22.y)
        case 11:
          if (m$sent = m.sent, f = e$payload$fields.length !== i$attributes$fields.length, e$payload$fields.forEach(function (e) {
            var t = true
            i$attributes$fields.forEach(function (n) {
              if (n.id === e.id) {
                if (!Lodash.isEqual(e, n)) {
                  f = true
                  u.push(e)
                }
                t = false
              }
            })
            if (t) {
              f = true
              l.push({
                key: e.key,
                value: e.value,
                type: e.type
              })
            }
          }), i$attributes$fields.forEach(function (e) {
            if (!e$payload$fields.some(function (t) {
              return t.id === e.id
            })) {
              d.push(e.id)
              f = true
            }
          }), !f) {
            m.next = 26
            break
          }
          m.next = 18
          return ReduxSagaEffects.b(Yt, i$attributes$cloudDbId, {
            addItems: l,
            editItems: u,
            deleteItems: d
          }, Module_97.a(m$sent) ? m$sent : undefined)
        case 18:
          if ((_m$sent4 = m.sent).addItems) {
            _m$sent4.addItems.forEach(function (e) {
              e.id = e.id + ""
              e$payload$fields.forEach(function (t) {
                if (e.key === t.key) {
                  t.id = e.id
                }
              })
            })
          }
          m.next = 22
          return ReduxSagaEffects.b(zs, Actions.Lg(e$payload$widgetId, "fields", e$payload$fields, false, true))
        case 22:
          if (e$payload$setBlockValue && 1 === _m$sent4.addItems.length) {
            e$payload$setBlockValue(_m$sent4.addItems[0].key)
          }
          u.forEach(function (e) {
            var t = i$attributes$fields.find(function (t) {
              return t.id === e.id
            })
            if (t) {
              Module_26.n(e$payload$widgetId, t.key, e.key)
            }
          })
          if (_m$sent4.deleteItems) {
            _m$sent4.deleteItems.forEach(function (e) {
              var t = i$attributes$fields.find(function (t) {
                return t.id === e.toString()
              })
              if (t) {
                Module_26.n(e$payload$widgetId, t.key, "")
              }
            })
          }
          migrateCloudDict([i$attributes$cloudDbId], 2, 0, Module_97.a(m$sent) ? m$sent : undefined)
        case 26:
        case "end":
          return m.stop()
      }
    }
  }, Ua)
}
function gc(e) {
  var /* [auto-meaningful-name] */c$sent
  var n
  var r
  var o
  var /* [auto-meaningful-name] */c$sent1
  var a
  var /* [auto-meaningful-name] */c$sent2
  return RegeneratorRuntime.wrap(function (c) {
    for (;;) {
      switch (c.prev = c.next) {
        case 0:
          c.next = 2
          return ReduxSagaEffects.f(Module_22.y)
        case 2:
          c$sent = c.sent
          n = []
          r = 1
          o = 500
          c.next = 8
          return ReduxSagaEffects.b(Vt, e, r, o, Module_97.a(c$sent) ? c$sent : undefined)
        case 8:
          if (c$sent1 = c.sent, n = n.concat(c$sent1.items), !((a = Math.ceil(c$sent1.total / o)) > 1)) {
            c.next = 21
            break
          }
          r += 1
        case 13:
          if (!(r <= a)) {
            c.next = 21
            break
          }
          c.next = 16
          return ReduxSagaEffects.b(Vt, e, r, o, Module_97.a(c$sent) ? c$sent : undefined)
        case 16:
          c$sent2 = c.sent
          n = n.concat(c$sent2.items)
        case 18:
          r++
          c.next = 13
          break
        case 21:
          return c.abrupt("return", n)
        case 22:
        case "end":
          return c.stop()
      }
    }
  }, Ha)
}
function _c(e) {
  var /* [auto-meaningful-name] */s$sent
  var /* [auto-meaningful-name] */e$payload$archiveId
  var /* [auto-meaningful-name] */s$sent1
  var /* [auto-meaningful-name] */_s$sent3$content
  var /* [auto-meaningful-name] */_s$sent4
  var /* [auto-meaningful-name] */$$_$$_$$_$$_unrestored_shared_1571_2636_24_index$a$client
  return RegeneratorRuntime.wrap(function (s) {
    for (;;) {
      switch (s.prev = s.next) {
        case 0:
          s.next = 2
          return ReduxSagaEffects.f(function (e) {
            return e.oTState.collWorkId
          })
        case 2:
          s$sent = s.sent
          e$payload$archiveId = e.payload.archiveId
          s.next = 6
          return ReduxSagaEffects.e(Actions.si(""))
        case 6:
          if (!e$payload$archiveId) {
            s.next = 33
            break
          }
          s.next = 9
          return ReduxSagaEffects.b(Module_297.e, e$payload$archiveId)
        case 9:
          if (s$sent1 = s.sent, !(_s$sent3$content = s$sent1.content)) {
            s.next = 32
            break
          }
          s.next = 14
          return ReduxSagaEffects.e(Actions.bg())
        case 14:
          s.next = 16
          return ReduxSagaEffects.e(Actions.cg())
        case 16:
          s.next = 18
          return ReduxSagaEffects.b(loadWorkFromJSON, _s$sent3$content)
        case 18:
          s.next = 20
          return ReduxSagaEffects.e(Actions.dg())
        case 20:
          s.next = 22
          return ReduxSagaEffects.e(Actions.Ei(undefined))
        case 22:
          s.next = 24
          return ReduxSagaEffects.e(Actions.Fi(false))
        case 24:
          s.next = 26
          return ReduxSagaEffects.e(Actions.tj(false))
        case 26:
          s.next = 28
          return ReduxSagaEffects.f(Module_22.s)
        case 28:
          _s$sent4 = s.sent
          s.next = 31
          return ReduxSagaEffects.e(Actions.showCommonToastInfoAction({
            message: Language.c(_s$sent4, "History.revertSuccess").toString(),
            type: "success"
          }))
        case 31:
          if (s$sent) {
            if (!(null === ($$_$$_$$_$$_unrestored_shared_1571_2636_24_index$a$client = Module_24.a.client) || undefined === $$_$$_$$_$$_unrestored_shared_1571_2636_24_index$a$client)) {
              $$_$$_$$_$$_unrestored_shared_1571_2636_24_index$a$client.forceSetDoc()
            }
          }
        case 32:
          Gn()
        case 33:
        case "end":
          return s.stop()
      }
    }
  }, Va)
}
function vc(e) {
  var t
  var n
  var /* [auto-meaningful-name] */s$sent
  var /* [auto-meaningful-name] */_s$sent5
  var /* [auto-meaningful-name] */_s$sent6
  var /* [auto-meaningful-name] */_s$sent7
  return RegeneratorRuntime.wrap(function (s) {
    for (;;) {
      switch (s.prev = s.next) {
        case 0:
          Pn()
          t = Module_9.Y()
          n = t.map(function (e) {
            return e.attributes.cloudDbId
          })
          s.next = 5
          return ReduxSagaEffects.b(Module_9.R)
        case 5:
          s$sent = s.sent
          s.next = 8
          return ReduxSagaEffects.b(Module_9.sb)
        case 8:
          _s$sent5 = s.sent
          s.next = 11
          return ReduxSagaEffects.b(Module_9.S)
        case 11:
          _s$sent6 = s.sent
          s.next = 14
          return ReduxSagaEffects.b(Module_9.tb)
        case 14:
          if (_s$sent7 = s.sent, !(t.length > 0)) {
            s.next = 18
            break
          }
          s.next = 18
          return ReduxSagaEffects.b(Module_147.a, n, e)
        case 18:
          if (s.prev = 18, !(s$sent.length > 0)) {
            s.next = 24
            break
          }
          s.next = 22
          return ReduxSagaEffects.b(Module_111.d, e, s$sent)
        case 22:
          s.next = 24
          return ReduxSagaEffects.e(Actions.lf(s$sent))
        case 24:
          s.next = 29
          break
        case 26:
          s.prev = 26
          s.t0 = s.catch(18)
          console.error(s.t0)
        case 29:
          if (s.prev = 29, !(_s$sent5.length > 0)) {
            s.next = 35
            break
          }
          s.next = 33
          return ReduxSagaEffects.b(Module_111.v, e, _s$sent5)
        case 33:
          s.next = 35
          return ReduxSagaEffects.e(Actions.Ih(_s$sent5))
        case 35:
          s.next = 40
          break
        case 37:
          s.prev = 37
          s.t1 = s.catch(29)
          console.error(s.t1)
        case 40:
          if (s.prev = 40, !(_s$sent6.length > 0)) {
            s.next = 46
            break
          }
          s.next = 44
          return ReduxSagaEffects.b(Module_111.e, e, _s$sent6)
        case 44:
          s.next = 46
          return ReduxSagaEffects.e(Actions.mf(_s$sent6))
        case 46:
          s.next = 51
          break
        case 48:
          s.prev = 48
          s.t2 = s.catch(40)
          console.error(s.t2)
        case 51:
          if (s.prev = 51, !(_s$sent7.length > 0)) {
            s.next = 57
            break
          }
          s.next = 55
          return ReduxSagaEffects.b(Module_111.w, e, _s$sent7)
        case 55:
          s.next = 57
          return ReduxSagaEffects.e(Actions.Jh(_s$sent7))
        case 57:
          s.next = 62
          break
        case 59:
          s.prev = 59
          s.t3 = s.catch(51)
          console.error(s.t3)
        case 62:
        case "end":
          return s.stop()
      }
    }
  }, za, null, [[18, 26], [29, 37], [40, 48], [51, 59]])
}
function bc(e) {
  var /* [auto-meaningful-name] */e$payload$json
  return RegeneratorRuntime.wrap(function (n) {
    for (;;) {
      switch (n.prev = n.next) {
        case 0:
          if (!(e$payload$json = e.payload.json)) {
            n.next = 4
            break
          }
          n.next = 4
          return ReduxSagaEffects.b(loadWorkFromJSON, e$payload$json)
        case 4:
        case "end":
          return n.stop()
      }
    }
  }, Ya)
}
function yc(e) {
  var /* [auto-meaningful-name] */e$payload$callback
  var /* [auto-meaningful-name] */u$sent
  var /* [auto-meaningful-name] */_u$sent2
  var o
  var /* [auto-meaningful-name] */_u$sent3
  var /* [auto-meaningful-name] */_u$sent4
  var /* [auto-meaningful-name] */_u$sent5
  var /* [auto-meaningful-name] */_u$sent6
  return RegeneratorRuntime.wrap(function (u) {
    for (;;) {
      switch (u.prev = u.next) {
        case 0:
          e$payload$callback = e.payload.callback
          u.next = 3
          return ReduxSagaEffects.f(Module_22.E)
        case 3:
          u$sent = u.sent
          u.next = 6
          return ReduxSagaEffects.f(Module_22.y)
        case 6:
          if (_u$sent2 = u.sent, o = Module_97.a(_u$sent2), u$sent.title) {
            u.next = 29
            break
          }
          if (!o) {
            u.next = 24
            break
          }
          u.next = 12
          return ReduxSagaEffects.b(Module_177.g, _u$sent2, 0)
        case 12:
          if (!(_u$sent3 = u.sent) || !_u$sent3.data) {
            u.next = 22
            break
          }
          u.next = 16
          return ReduxSagaEffects.b(fetch, _u$sent3.data.bcmc_url)
        case 16:
          _u$sent4 = u.sent
          u.next = 19
          return _u$sent4.json()
        case 19:
          _u$sent5 = u.sent
          u.next = 22
          return ReduxSagaEffects.e(Actions.Ti({
            title: _u$sent5.title,
            desc: _u$sent5.description || Module_328.c,
            img: _u$sent5.coverUrl || Unrestored_shared_1571_2636_37_515
          }))
        case 22:
          u.next = 29
          break
        case 24:
          u.next = 26
          return ReduxSagaEffects.f(Module_22.G)
        case 26:
          _u$sent6 = u.sent
          u.next = 29
          return ReduxSagaEffects.e(Actions.Ti({
            title: _u$sent6,
            desc: Module_328.c,
            img: Unrestored_shared_1571_2636_37_515
          }))
        case 29:
          if (!(Module_9.Y().length > 0 && "true" !== localStorage.getItem("cloudDBPublishGuide"))) {
            u.next = 35
            break
          }
          u.next = 33
          return ReduxSagaEffects.e(Actions.kj(true, "share", e$payload$callback))
        case 33:
          u.next = 36
          break
        case 35:
          e$payload$callback()
        case 36:
          return u.abrupt("return")
        case 37:
        case "end":
          return u.stop()
      }
    }
  }, Ka)
}
wi = {}
Module_11.a(wi, Actions.H, Qa)
Module_11.a(wi, Actions.M, ds)
Module_11.a(wi, Actions.gb, ms)
Module_11.a(wi, Actions.lb, gs)
Module_11.a(wi, Actions.jb, Cs)
Module_11.a(wi, Actions.Jb, Ss)
Module_11.a(wi, Actions.kb, Is)
Module_11.a(wi, Actions.Mb, zs)
Module_11.a(wi, Actions.Lb, Ys)
Module_11.a(wi, Actions.Ob, Zs)
Module_11.a(wi, Actions.db, Js)
Module_11.a(wi, Actions.nb, os)
Module_11.a(wi, Actions.D, is)
Module_11.a(wi, Actions.N, Ds)
Module_11.a(wi, Actions.ASYNC_CREATE_PROJECT, onAsyncCreateProject)
Module_11.a(wi, Actions.F, es)
Module_11.a(wi, Actions.ASYNC_GET_PROJECT_ERROR, Ja)
Module_11.a(wi, Actions.vb, Xa)
Module_11.a(wi, Actions.E, $s)
Module_11.a(wi, Actions.fb, nc)
Module_11.a(wi, Actions.eb, rc)
Module_11.a(wi, Actions.tb, Ws)
Module_11.a(wi, Actions.Ib, Vs)
Module_11.a(wi, Actions.hb, oc)
Module_11.a(wi, Actions.y, Hs)
Module_11.a(wi, Actions.xb, ic)
Module_11.a(wi, Actions.Kb, ac)
Module_11.a(wi, Actions.Bc, ns)
Module_11.a(wi, Actions.Nb, lc)
Module_11.a(wi, Actions.ub, sc)
Module_11.a(wi, Actions.B, cc)
Module_11.a(wi, Actions.T, uc)
Module_11.a(wi, Actions.x, dc)
Module_11.a(wi, Actions.ab, fc)
Module_11.a(wi, Actions.zb, mc)
Module_11.a(wi, Actions.PUBLISH_WORK_TO_COMMUNITY, handlePublishWorkToCommunity)
Module_11.a(wi, Actions.PUBLISH_WORK_TO_H5, handlePublishWorkToH5)
Module_11.a(wi, Actions.z, ys)
Module_11.a(wi, Actions.rb, Es)
Module_11.a(wi, Actions.sb, _c)
Module_11.a(wi, Actions.dc, bc)
Module_11.a(wi, Actions.bb, hc)
Module_11.a(wi, Actions.V, yc)
var Ec = wi
var Oc = qn(Ec)
function wc() {
  return RegeneratorRuntime.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          e.next = 2
          return ReduxSagaEffects.g(Object.keys(Ec), Oc)
        case 2:
        case "end":
          return e.stop()
      }
    }
  }, qa)
}
export { Si }
export { Ms }
export { wc }
